import { COUNTRY, ACCOUNT_TYPE } from '@red/data';

const mods = {
    mod10: (number) => {
        const arr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
        let length = number.length;
        let bit = 1;
        let sum = 0;
        let val;
        while (length) {
            val = parseInt(number.charAt(--length), 10);
            const b = (bit ^= 1);
            sum += b ? arr[val] : val;
        }
        return sum && sum % 10 === 0;
    },
    mod11: (number) => {
        let length = number.length;
        let sum = 0;
        let val;
        const weights = [1, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
        const arr = weights.splice(weights.length - length, weights.length - (weights.length - length));
        while (length) {
            val = parseInt(number.charAt(--length), 10);
            sum += arr[length] * val;
        }
        return sum && sum % 11 === 0;
    },
    mod97: (input) => {
        let checksum = parseInt(input.slice(0, 2), 10);
        let fragment;
        let offset = 2;
        const l = input.length;
        for (offset; offset < l; offset += 7) {
            fragment = String(checksum) + input.substring(offset, offset + 7);
            checksum = parseInt(fragment, 10) % 97;
        }
        return checksum;
    },
};

const banks = [
    {
        name: 'Svea Bank',
        type: 1,
        comment: 2,
        clearingRegex: /^966[0-9]$/,
        regex: /^966[0-9]{8}$/,
    },
    {
        name: 'Avanza Bank',
        type: 1,
        comment: 2,
        clearingRegex: /^95[5-6][0-9]$/,
        regex: /^95[5-6][0-9]{8}$/,
    },
    {
        name: 'BlueStep Finans',
        type: 1,
        comment: 1,
        clearingRegex: /^968[0-9]$/,
        regex: /^968[0-9]{8}$/,
    },
    {
        name: 'BNP Paribas SA.',
        type: 1,
        comment: 2,
        clearingRegex: /^947[0-9]$/,
        regex: /^947[0-9]{8}$/,
    },
    {
        name: 'Citibank',
        type: 1,
        comment: 2,
        clearingRegex: /^904[0-9]$/,
        regex: /^904[0-9]{8}$/,
    },
    {
        name: 'Danske Bank',
        type: 1,
        comment: 1,
        clearingRegex: /^(12|13|24)[0-9]{2}$/,
        regex: /^(12|13|24)[0-9]{9}$/,
    },
    {
        name: 'DNB Bank',
        type: 1,
        comment: 2,
        clearingRegex: /^(919|926)[0-9]$/,
        regex: /^(919|926)[0-9]{8}$/,
    },
    {
        name: 'Ekobanken',
        type: 1,
        comment: 2,
        clearingRegex: /^970[0-9]$/,
        regex: /^970[0-9]{8}$/,
    },
    {
        name: 'Erik Penser',
        type: 1,
        comment: 2,
        clearingRegex: /^959[0-9]$/,
        regex: /^959[0-9]{8}$/,
    },
    {
        name: 'Forex Bank',
        type: 1,
        comment: 1,
        clearingRegex: /^94[0-4][0-9]$/,
        regex: /^94[0-4][0-9]{8}$/,
    },
    {
        name: 'ICA Banken',
        type: 1,
        comment: 1,
        clearingRegex: /^927[0-9]$/,
        regex: /^927[0-9]{8}$/,
    },
    {
        name: 'IKANO Bank',
        type: 1,
        comment: 1,
        clearingRegex: /^917[0-9]$/,
        regex: /^917[0-9]{8}$/,
    },
    {
        name: 'JAK Medlemsbank',
        type: 1,
        comment: 2,
        clearingRegex: /^967[0-9]$/,
        regex: /^967[0-9]{8}$/,
    },
    {
        name: 'Klarna Bank',
        type: 1,
        comment: 2,
        clearingRegex: /^978[0-9]$/,
        regex: /^978[0-9]{8}$/,
    },
    {
        name: 'Landshypotek',
        type: 1,
        comment: 2,
        clearingRegex: /^939[0-9]$/,
        regex: /^939[0-9]{8}$/,
    },
    {
        name: 'Lån & Spar Bank Sverige',
        type: 1,
        comment: 1,
        clearingRegex: /^963[0-9]$/,
        regex: /^963[0-9]{8}$/,
    },
    {
        name: 'Länsförsäkringar Bank',
        type: 1,
        comment: 1,
        clearingRegex: /^(340|906)[0-9]$/,
        regex: /^(340|906)[0-9]{8}$/,
    },
    {
        name: 'Länsförsäkringar Bank',
        type: 1,
        comment: 2,
        clearingRegex: /^902[0-9]$/,
        regex: /^902[0-9]{8}$/,
    },
    {
        name: 'Marginalen Bank',
        type: 1,
        comment: 1,
        clearingRegex: /^923[0-9]$/,
        regex: /^923[0-9]{8}$/,
    },
    {
        name: 'MedMera Bank',
        type: 1,
        comment: 2,
        clearingRegex: /^965[0-9]$/,
        regex: /^965[0-9]{8}$/,
    },
    {
        name: 'Nordax Bank',
        type: 1,
        comment: 2,
        clearingRegex: /^964[0-9]$/,
        regex: /^964[0-9]{8}$/,
    },
    {
        name: 'Nordea',
        type: 1,
        comment: 1,
        clearingRegex: /^(11|14|15|16|17|18|19|20)[0-9]{2}$/,
        regex: /^((11|14|15|16|17|18|19|20)[0-9]{2})[0-9]{7}$/,
    },
    {
        name: 'Nordea (personkonto)',
        type: 2,
        comment: 1,
        clearingRegex: /^3(300|782)$/,
        regex: /^(3(300|782))[0-9]{10}$/, // "personkonto"
    },
    {
        name: 'Nordea',
        type: 1,
        comment: 1,
        clearingRegex: /^3(?!(300))[0-3][0-9]{2}$/,
        regex: /^(3(?!(300|782))[0-3][0-9]{2})[0-9]{7}$/,
    },
    {
        name: 'Nordea',
        type: 1,
        comment: 1,
        clearingRegex: /^(34[1-9][0-9]|3(?!782)[5-9][0-9]{2})$/,
        regex: /^(34[1-9][0-9]|3[5-9][0-9]{2})[0-9]{7}$/,
    },
    {
        name: 'Nordea',
        type: 1,
        comment: 2,
        clearingRegex: /^4[0-9]{3}$/,
        regex: /^4[0-9]{10}$/,
    },
    {
        name: 'Nordnet Bank',
        type: 1,
        comment: 2,
        clearingRegex: /^910[0-9]$/,
        regex: /^910[0-9]{8}$/,
    },
    {
        name: 'Northmill Bank',
        type: 1,
        comment: 2,
        clearingRegex: /^975[0-9]$/,
        regex: /^975[0-9]{8}$/,
    },
    {
        name: 'Resurs Bank',
        type: 1,
        comment: 1,
        clearingRegex: /^928[0-9]$/,
        regex: /^928[0-9]{8}$/,
    },
    {
        name: 'Riksgälden',
        type: 1,
        comment: 2,
        clearingRegex: /^988[0-9]$/,
        regex: /^988[0-9]{8}$/,
    },
    {
        name: 'Riksgälden',
        type: 2,
        comment: 1,
        clearingRegex: /^989[0-9]$/,
        regex: /^989[0-9]{11}$/,
    },
    {
        name: 'Santander Consumer Bank',
        type: 1,
        comment: 1,
        clearingRegex: /^946[0-9]$/,
        regex: /^946[0-9]{8}$/,
    },
    {
        name: 'SBAB',
        type: 1,
        comment: 1,
        clearingRegex: /^925[0-9]$/,
        regex: /^925[0-9]{8}$/,
    },
    {
        name: 'SEB',
        type: 1,
        comment: 1,
        clearingRegex: /^(5[0-9]{3}|912[0-4]|91[3-4][0-9])$/,
        regex: /^(5[0-9]{3}|912[0-4]|91[3-4][0-9])[0-9]{7}$/,
    },
    {
        name: 'Skandiabanken',
        type: 1,
        comment: 2,
        clearingRegex: /^91[5-6][0-9]$/,
        regex: /^91[5-6][0-9]{8}$/,
    },
    {
        name: 'Swedbank',
        type: 1,
        comment: 1,
        clearingRegex: /^7[0-9]{3}$/,
        regex: /^7[0-9]{10}$/,
    },
    {
        name: 'Ålandsbanken',
        type: 1,
        comment: 2,
        clearingRegex: /^23[0-9]{2}$/,
        regex: /^(23[0-9]{2})[0-9]{7}$/,
    },
    {
        name: 'Danske Bank',
        type: 2,
        comment: 1,
        clearingRegex: /^918[0-9]$/,
        regex: /^918[0-9]{11}$/,
    },
    {
        name: 'Handelsbanken',
        type: 2,
        comment: 2,
        clearingRegex: /^6[0-9]{3}$/,
        regex: /^6[0-9]{12}$/,
    },
    {
        name: 'Nordea Plusgirot',
        type: 2,
        comment: 3,
        clearingRegex: /^(95[0-4]|996)[0-9]$/,
        regex: /^(95[0-4]|996)[0-9]{8,11}$/, // Clearingnbr 4 digits, accountNbr 7-10 digits
    },
    {
        name: 'Sparbanken Syd',
        type: 2,
        comment: 1,
        clearingRegex: /^957[0-9]$/,
        regex: /^957[0-9]{11}$/,
    },
    {
        name: 'Swedbank',
        type: 2,
        comment: 3,
        clearingRegex: /^(8[0-9]{3,4})$/,
        regex: /^(8[0-9]{3,4})[0-9]{8,11}$/, // ClearingNbr 4 digits, accountNbr 7-10 digits
    },
    {
        name: 'Swedbank',
        type: 2,
        comment: 1,
        clearingRegex: /^93[0-4][0-9]/,
        regex: /^93[0-4][0-9]{11}$/,
    },
];

banks.sort((a, b) => {
    return a.name < b.name ? -1 : 1;
});
const utils$3 = {
    getClearingNumber: (accountNumber) => {
        return accountNumber.substr(0, accountNumber.charAt(0) === '8' ? 5 : 4);
    },
    getType2Comment3AccountNumber: (accountNumber) => {
        const clearingNumberLength = utils$3.getClearingNumber(accountNumber).length;
        return accountNumber.substr(clearingNumberLength);
    },
    getType2AccountNumber: (accountNumber, bank) => {
        let number;
        if (bank.comment === 2) {
            number = accountNumber.substr(-9);
        }
        else if (bank.comment === 3) {
            number = utils$3.getType2Comment3AccountNumber(accountNumber);
        }
        return number || accountNumber.substr(-10);
    },
    getAccountNumber: (accountNumber, bank) => {
        return bank.type === 1 ? accountNumber.substr(-7) : utils$3.getType2AccountNumber(accountNumber, bank);
    },
    modResult: {
        type1: {
            comment1: (number, clearing) => {
                return mods.mod11((clearing + number).substr(-10));
            },
            comment2: (number, clearing) => {
                return mods.mod11(clearing + number);
            },
        },
        type2: {
            comment2: (number) => {
                return mods.mod11(number);
            },
        },
        defaultType: (number) => {
            return mods.mod10(number);
        },
        getModFunc: (clearing, number, bank) => {
            const typeFunc = utils$3.modResult['type' + bank.type];
            const commentFunc = typeFunc ? typeFunc['comment' + bank.comment] : undefined;
            return commentFunc || utils$3.modResult.defaultType;
        },
    },
    getModResult: (clearing, number, bank) => {
        const modFunc = utils$3.modResult.getModFunc(clearing, number, bank);
        return modFunc(number, clearing);
    },
    justDigits: (str) => {
        return str.replace(/\D/g, '');
    },
    validate: (accountNumber, bank) => {
        const clearing = utils$3.getClearingNumber(accountNumber);
        const number = utils$3.getAccountNumber(accountNumber, bank);
        const modResult = utils$3.getModResult(clearing, number, bank);
        return !modResult
            ? null
            : {
                bankName: bank.name,
                clearingNumber: clearing,
                accountNumber: number,
            };
    },
};
class BankAccountValidator {
    static validateClearingNumber(clearingNumber) {
        const bankObj = banks
            .filter(bank => {
            return bank.clearingRegex && bank.clearingRegex.test(clearingNumber);
        })
            .shift();
        return (bankObj && bankObj.name) || '';
    }
    static validate(accountNumber) {
        let bankObj = null;
        banks.forEach(bank => {
            if (!bankObj && bank.regex.test(accountNumber)) {
                bankObj = utils$3.validate(accountNumber, bank);
            }
        });
        return bankObj;
    }
}

class BaseValidator {
    static format(nationalIdentifier, country) {
        throw new Error('NationalIdentifierValidator.format for ' + country + ' not implemented');
    }
    static validate(nationalIdentifier, country) {
        throw new Error('NationalIdentifierValidator.validate for ' + country + ' not implemented');
    }
}

const utils$2 = {
    getYear: (nationalIdentifier) => {
        return parseInt(nationalIdentifier.substr(0, 4), 10);
    },
    getMonth: (nationalIdentifier) => {
        const monthPos = nationalIdentifier.length === 12 ? 4 : 2;
        return parseInt(nationalIdentifier.substr(monthPos, 2), 10) - 1;
    },
    getDay: (nationalIdentifier) => {
        const dayPos = nationalIdentifier.length === 12 ? 6 : 4;
        return parseInt(nationalIdentifier.substr(dayPos, 2), 10);
    },
    getCentury: (nationalIdentifier, hasPlusDelimiter) => {
        const nowYear = parseInt(new Date().getFullYear().toString().substr(2, 2), 10);
        const yearFromPersonnummer = parseInt(nationalIdentifier.substring(0, 2), 10);
        let century = yearFromPersonnummer < nowYear ? 20 : 19;
        if (hasPlusDelimiter) {
            const nowCentury = parseInt(new Date().getFullYear().toString().substr(0, 2), 10);
            century = nowCentury - 1;
        }
        return century + nationalIdentifier;
    },
    setCentury: (nationalIdentifier, hasPlusDelimiter) => {
        const firstTwo19Or20 = /^(19|20)/.test(nationalIdentifier);
        if (nationalIdentifier.length === 10 && !firstTwo19Or20) {
            nationalIdentifier = utils$2.getCentury(nationalIdentifier, hasPlusDelimiter);
        }
        return nationalIdentifier;
    },
    eqPersonnummer: (nationalIdentifier) => {
        const hasPlusDelimiter = /^(19|20)?\d{6}\+\d{4}$/.test(nationalIdentifier);
        return utils$2.setCentury(nationalIdentifier.replace(/\D/g, ''), hasPlusDelimiter);
    },
    isSamordningsnummer: (nationalIdentifier) => {
        const day = utils$2.getDay(nationalIdentifier);
        return day >= 61 && day <= 91;
    },
};
const checks = {
    format: (nationalIdentifier) => {
        return /^(19|20)?\d{6}(-|\+)?\d{4}$/.test(nationalIdentifier);
    },
    isRealDate: (nationalIdentifier) => {
        nationalIdentifier = utils$2.eqPersonnummer(nationalIdentifier);
        const year = utils$2.getYear(nationalIdentifier);
        const month = utils$2.getMonth(nationalIdentifier);
        let day = utils$2.getDay(nationalIdentifier);
        // samordningsnummer
        if (day >= 61 && day <= 91) {
            day = day - 60;
        }
        const date = new Date(year, month, day, 12, 0, 0, 0);
        const yearOk = date.getFullYear() === year;
        const monthOk = date.getMonth() === month;
        const dayOk = date.getDate() === day;
        return yearOk && monthOk && dayOk;
    },
    isPassedDate: (nationalIdentifier) => {
        nationalIdentifier = utils$2.eqPersonnummer(nationalIdentifier);
        const now = new Date();
        const year = utils$2.getYear(nationalIdentifier);
        const month = utils$2.getMonth(nationalIdentifier);
        let day = utils$2.getDay(nationalIdentifier);
        // samordningsnummer
        if (day >= 61 && day <= 91) {
            day = day - 60;
        }
        const date = new Date(year, month, day, 12, 0, 0, 0);
        return now > date;
    },
    checkLastDigit: (nationalIdentifier) => {
        nationalIdentifier = utils$2.eqPersonnummer(nationalIdentifier);
        const number = nationalIdentifier.indexOf('0000', nationalIdentifier.length - 4);
        if (utils$2.isSamordningsnummer(nationalIdentifier) && number >= 0) {
            return true;
        }
        const checkStr = nationalIdentifier.toString().substring(2, 12);
        return mods.mod10(checkStr);
    },
};
class SEValidator extends BaseValidator {
    static format(nationalIdentifier) {
        return utils$2.eqPersonnummer(nationalIdentifier || '');
    }
    static validate(nationalIdentifier) {
        if (!nationalIdentifier) {
            return false;
        }
        const checksArray = Object.keys(checks);
        let checksPass = 0;
        checksArray.forEach(check => {
            if (checks[check](nationalIdentifier)) {
                checksPass += 1;
            }
        });
        return checksPass === checksArray.length;
    }
}

const nationalIdentifiers = {};
nationalIdentifiers[COUNTRY.SWEDEN] = SEValidator;
const utils$1 = {
    getMethod: (nationalIdentifier, country, methodName) => {
        return nationalIdentifiers[country]
            ? nationalIdentifiers[country][methodName](nationalIdentifier)
            : BaseValidator[methodName](nationalIdentifier, country);
    },
};
class NationalIdentifierValidator {
    static format(nationalIdentifier, country) {
        return utils$1.getMethod(nationalIdentifier, country, 'format');
    }
    static validate(nationalIdentifier, country) {
        return utils$1.getMethod(nationalIdentifier, country, 'validate');
    }
}

class OrganisationsnummerSE {
    static validate(orgnr) {
        const is10digits = /^\d{10}$/.test(orgnr);
        const checkSumOk = mods.mod10(orgnr);
        return is10digits && checkSumOk;
    }
}

const regexps = {
    BankGiro: /^\d{3,4}-\d{4}$/,
    PlusGiro: /^\d{1,7}-\d$/,
};
const localUtils = {
    getType(input) {
        const isBg = regexps['BankGiro'].test(input) && ACCOUNT_TYPE.SE_BANKGIRO;
        const isPg = regexps['PlusGiro'].test(input) && ACCOUNT_TYPE.SE_PLUSGIRO;
        return isBg || isPg || ACCOUNT_TYPE.UNKNOWN;
    },
};
class PGorBG {
    // This is an angular specific validator
    static validate(PGorBG) {
        const validPGorBG = Object.keys(regexps)
            .filter(key => {
            return regexps[key].test(PGorBG);
        })
            .shift();
        const checkSumOk = mods.mod10(PGorBG.replace(/\D/g, ''));
        return validPGorBG && checkSumOk
            ? {
                input: PGorBG,
                type: validPGorBG,
            }
            : null;
    }
    // This is a framework agnostic validator
    static validation(input) {
        const type = localUtils.getType(input);
        const checkSumOk = !!mods.mod10(input.replace(/-/, ''));
        const isValid = checkSumOk && type !== ACCOUNT_TYPE.UNKNOWN;
        return {
            input,
            type,
            isValid,
        };
    }
}

const ibanLengthForCountry = {
    AD: 24,
    AE: 23,
    AL: 28,
    AO: 25,
    AT: 20,
    AZ: 28,
    BA: 20,
    BE: 16,
    BF: 27,
    BG: 22,
    BH: 22,
    BI: 16,
    BJ: 28,
    BR: 29,
    CH: 21,
    CI: 28,
    CM: 27,
    CR: 21,
    CV: 25,
    CY: 28,
    CZ: 24,
    DE: 22,
    DK: 18,
    DO: 28,
    DZ: 24,
    EE: 20,
    ES: 24,
    FI: 18,
    FO: 18,
    FR: 27,
    GB: 22,
    GE: 22,
    GI: 23,
    GL: 18,
    GR: 27,
    GT: 28,
    HR: 21,
    HU: 28,
    IE: 22,
    IL: 23,
    IR: 26,
    IS: 26,
    IT: 27,
    JO: 30,
    KW: 30,
    KZ: 20,
    LB: 28,
    LI: 21,
    LT: 20,
    LU: 20,
    LV: 21,
    MC: 27,
    MD: 24,
    ME: 22,
    MG: 27,
    MK: 19,
    ML: 28,
    MR: 27,
    MT: 31,
    MU: 30,
    MZ: 25,
    NL: 18,
    NO: 15,
    PK: 24,
    PL: 28,
    PS: 29,
    PT: 25,
    QA: 29,
    RO: 24,
    RS: 22,
    SA: 24,
    SE: 24,
    SI: 19,
    SK: 24,
    SM: 27,
    SN: 28,
    TL: 23,
    TN: 24,
    TR: 26,
    UA: 29,
    VG: 24,
    XK: 20,
};
const ibanUtils = {
    format: (iban) => {
        return iban.toUpperCase();
    },
    getCountryCode: (iban) => {
        const formattedIban = ibanUtils.format(iban);
        const leadingUpperCaseLetters = formattedIban.match(/^[A-Z]{2}/);
        return leadingUpperCaseLetters ? leadingUpperCaseLetters[0] : '';
    },
    getCheckDigits: (iban) => {
        const checkDigits = iban.substr(2, 2).match(/^\d{2}$/);
        return checkDigits ? checkDigits[0] : '';
    },
    rearrange: (countryCode, checkDigits, remaningIban) => {
        return remaningIban + countryCode + checkDigits;
    },
    convertLettersToIntigers: (rearrangedIban) => {
        return rearrangedIban.replace(/[A-Z]/g, char => {
            return (char.charCodeAt(0) - 55).toString();
        });
    },
    reformat: (formattedIban, countryCode) => {
        const checkDigits = ibanUtils.getCheckDigits(formattedIban);
        const remaningIban = formattedIban.substr(4, formattedIban.length).replace(/[^A-Z\d]/g, '');
        const rearrangedIban = ibanUtils.rearrange(countryCode, checkDigits, remaningIban);
        return ibanUtils.convertLettersToIntigers(rearrangedIban);
    },
    hasExpectedIbanLength: (iban) => {
        const formattedIban = ibanUtils.format(iban);
        const countryCode = ibanUtils.getCountryCode(formattedIban);
        const expectedIbanLength = ibanLengthForCountry[countryCode];
        return formattedIban.length === expectedIbanLength;
    },
    mod97check: (formattedIban) => {
        const countryCode = ibanUtils.getCountryCode(formattedIban);
        const reformatIban = ibanUtils.reformat(formattedIban, countryCode);
        const mod97check = mods.mod97(reformatIban);
        return mod97check === 1;
    },
    isValid: (iban) => {
        const hasRightLength = ibanUtils.hasExpectedIbanLength(iban);
        const formattedIban = ibanUtils.format(iban);
        const mod97check = ibanUtils.mod97check(formattedIban);
        return hasRightLength && mod97check;
    },
    compileValidResponseObject: (iban, countryCode) => {
        return {
            input: iban,
            country: countryCode,
        };
    },
    getValidResponseObject: iban => {
        const countryCode = ibanUtils.getCountryCode(iban);
        return ibanUtils.compileValidResponseObject(iban, countryCode);
    },
};
class IBAN {
    static validate(iban) {
        const isValidIBAN = ibanUtils.isValid(iban);
        return isValidIBAN ? ibanUtils.getValidResponseObject(iban) : null;
    }
}

const sniCodes = {
    'Detaljgrupp (Femsiffer)': [
        {
            A: 'SNI 2007',
        },
        {
            A: 'Detaljgrupp (Officiell kodstruktur)',
            B: 'Detaljgrupp',
            C: 'Benämning',
        },
        {
            A: '01.110',
            B: '01110',
            C: 'Odling av spannmål (utom ris), baljväxter och oljeväxter',
        },
        {
            A: '01.120',
            B: '01120',
            C: 'Odling av ris',
        },
        {
            A: '01.131',
            B: '01131',
            C: 'Potatisodling',
        },
        {
            A: '01.132',
            B: '01132',
            C: 'Sockerbetsodling',
        },
        {
            A: '01.133',
            B: '01133',
            C: 'Odling av grönsaker (köksväxter) på friland',
        },
        {
            A: '01.134',
            B: '01134',
            C: 'Odling av grönsaker (köksväxter) i växthus',
        },
        {
            A: '01.135',
            B: '01135',
            C: 'Svampodling m.m.',
        },
        {
            A: '01.140',
            B: '01140',
            C: 'Odling av sockerrör',
        },
        {
            A: '01.150',
            B: '01150',
            C: 'Odling av tobak',
        },
        {
            A: '01.160',
            B: '01160',
            C: 'Odling av fiberväxter',
        },
        {
            A: '01.191',
            B: '01191',
            C: 'Odling av prydnadsväxter i växthus',
        },
        {
            A: '01.199',
            B: '01199',
            C: 'Odling av övriga ett- och tvååriga växter',
        },
        {
            A: '01.210',
            B: '01210',
            C: 'Odling av druvor',
        },
        {
            A: '01.220',
            B: '01220',
            C: 'Odling av tropiska och subtropiska frukter',
        },
        {
            A: '01.230',
            B: '01230',
            C: 'Odling av citrusfrukter',
        },
        {
            A: '01.240',
            B: '01240',
            C: 'Odling av kärnfrukter och stenfrukter',
        },
        {
            A: '01.250',
            B: '01250',
            C: 'Odling av andra frukter och bär samt nötter',
        },
        {
            A: '01.260',
            B: '01260',
            C: 'Odling av oljehaltiga frukter',
        },
        {
            A: '01.270',
            B: '01270',
            C: 'Odling av växter för dryckesframställning',
        },
        {
            A: '01.280',
            B: '01280',
            C: 'Odling av kryddväxter, drog- och medicinalväxter',
        },
        {
            A: '01.290',
            B: '01290',
            C: 'Odling av andra fleråriga växter',
        },
        {
            A: '01.301',
            B: '01301',
            C: 'Odling av plantskoleväxter i växthus',
        },
        {
            A: '01.302',
            B: '01302',
            C: 'Odling av plantskoleväxter m.m. på friland',
        },
        {
            A: '01.410',
            B: '01410',
            C: 'Mjölkproduktion och uppfödning av nötkreatur av mjölkras',
        },
        {
            A: '01.420',
            B: '01420',
            C: 'Uppfödning av andra nötkreatur och bufflar',
        },
        {
            A: '01.430',
            B: '01430',
            C: 'Uppfödning av hästar och andra hästdjur',
        },
        {
            A: '01.440',
            B: '01440',
            C: 'Uppfödning av kameler och kameldjur',
        },
        {
            A: '01.450',
            B: '01450',
            C: 'Uppfödning av får och getter',
        },
        {
            A: '01.461',
            B: '01461',
            C: 'Uppfödning av smågrisar',
        },
        {
            A: '01.462',
            B: '01462',
            C: 'Uppfödning av slaktsvin',
        },
        {
            A: '01.471',
            B: '01471',
            C: 'Äggproduktion (för försäljning)',
        },
        {
            A: '01.472',
            B: '01472',
            C: 'Uppfödning av fjäderfä, ej äggproduktion',
        },
        {
            A: '01.491',
            B: '01491',
            C: 'Renskötsel',
        },
        {
            A: '01.492',
            B: '01492',
            C: 'Uppfödning av sällskapsdjur',
        },
        {
            A: '01.499',
            B: '01499',
            C: 'Övrig uppfödning av andra djur',
        },
        {
            A: '01.500',
            B: '01500',
            C: 'Blandat jordbruk',
        },
        {
            A: '01.610',
            B: '01610',
            C: 'Service till växtodling',
        },
        {
            A: '01.620',
            B: '01620',
            C: 'Service till husdjursskötsel',
        },
        {
            A: '01.630',
            B: '01630',
            C: 'Bearbetning av skördade växter',
        },
        {
            A: '01.640',
            B: '01640',
            C: 'Bearbetning av utsäde',
        },
        {
            A: '01.700',
            B: '01700',
            C: 'Jakt och service i anslutning härtill',
        },
        {
            A: '02.101',
            B: '02101',
            C: 'Skogsförvaltning',
        },
        {
            A: '02.102',
            B: '02102',
            C: 'Skogsskötsel',
        },
        {
            A: '02.109',
            B: '02109',
            C: 'Övrig skoglig verksamhet',
        },
        {
            A: '02.200',
            B: '02200',
            C: 'Drivning',
        },
        {
            A: '02.300',
            B: '02300',
            C: 'Insamling av annat vilt växande skogsmaterial än trä',
        },
        {
            A: '02.401',
            B: '02401',
            C: 'Virkesmätning',
        },
        {
            A: '02.409',
            B: '02409',
            C: 'Övrig service till skogsbruk',
        },
        {
            A: '03.111',
            B: '03111',
            C: 'Trålfiske i saltvatten',
        },
        {
            A: '03.119',
            B: '03119',
            C: 'Övrigt saltvattensfiske',
        },
        {
            A: '03.120',
            B: '03120',
            C: 'Sötvattensfiske',
        },
        {
            A: '03.210',
            B: '03210',
            C: 'Fiskodling i saltvatten',
        },
        {
            A: '03.220',
            B: '03220',
            C: 'Fiskodling i sötvatten',
        },
        {
            A: '05.100',
            B: '05100',
            C: 'Stenkolsutvinning',
        },
        {
            A: '05.200',
            B: '05200',
            C: 'Brunkolsutvinning',
        },
        {
            A: '06.100',
            B: '06100',
            C: 'Utvinning av råpetroleum',
        },
        {
            A: '06.200',
            B: '06200',
            C: 'Utvinning av naturgas',
        },
        {
            A: '07.100',
            B: '07100',
            C: 'Järnmalmsutvinning',
        },
        {
            A: '07.210',
            B: '07210',
            C: 'Utvinning av uran- och toriummalm',
        },
        {
            A: '07.290',
            B: '07290',
            C: 'Utvinning av annan malm',
        },
        {
            A: '08.110',
            B: '08110',
            C: 'Brytning av natursten, kalk- och gipssten, krita och skiffer',
        },
        {
            A: '08.120',
            B: '08120',
            C: 'Utvinning av sand, grus och berg; utvinning av lera och kaolin',
        },
        {
            A: '08.910',
            B: '08910',
            C: 'Brytning av kemiska mineral',
        },
        {
            A: '08.920',
            B: '08920',
            C: 'Torvutvinning',
        },
        {
            A: '08.930',
            B: '08930',
            C: 'Saltutvinning',
        },
        {
            A: '08.990',
            B: '08990',
            C: 'Diverse övrig utvinning av mineral',
        },
        {
            A: '09.100',
            B: '09100',
            C: 'Stödtjänster till råpetroleum- och naturgasutvinning',
        },
        {
            A: '09.900',
            B: '09900',
            C: 'Stödtjänster till annan utvinning',
        },
        {
            A: '10.111',
            B: '10111',
            C: 'Kreatursslakt',
        },
        {
            A: '10.112',
            B: '10112',
            C: 'Styckning av kött',
        },
        {
            A: '10.120',
            B: '10120',
            C: 'Beredning och hållbarhetsbehandling av fjäderfäkött',
        },
        {
            A: '10.130',
            B: '10130',
            C: 'Charkuteri- och annan köttvarutillverkning',
        },
        {
            A: '10.200',
            B: '10200',
            C: 'Beredning och hållbarhetsbehandling av fisk samt skal- och blötdjur',
        },
        {
            A: '10.310',
            B: '10310',
            C: 'Beredning och hållbarhetsbehandling av potatis',
        },
        {
            A: '10.320',
            B: '10320',
            C: 'Juice- och safttillverkning',
        },
        {
            A: '10.390',
            B: '10390',
            C: 'Annan beredning och hållbarhetsbehandling av frukt, bär och grönsaker',
        },
        {
            A: '10.410',
            B: '10410',
            C: 'Framställning av oljor och fetter',
        },
        {
            A: '10.420',
            B: '10420',
            C: 'Matfettstillverkning',
        },
        {
            A: '10.511',
            B: '10511',
            C: 'Osttillverkning',
        },
        {
            A: '10.519',
            B: '10519',
            C: 'Annan mejerivarutillverkning',
        },
        {
            A: '10.520',
            B: '10520',
            C: 'Glasstillverkning',
        },
        {
            A: '10.611',
            B: '10611',
            C: 'Mjöltillverkning',
        },
        {
            A: '10.612',
            B: '10612',
            C: 'Tillverkning av frukostflingor, mixer och andra livsmedelsberedningar av kvarnprodukter',
        },
        {
            A: '10.620',
            B: '10620',
            C: 'Stärkelsetillverkning',
        },
        {
            A: '10.710',
            B: '10710',
            C: 'Tillverkning av mjukt matbröd och färska bakverk',
        },
        {
            A: '10.721',
            B: '10721',
            C: 'Knäckebrödstillverkning',
        },
        {
            A: '10.722',
            B: '10722',
            C: 'Tillverkning av kex och konserverade bakverk',
        },
        {
            A: '10.730',
            B: '10730',
            C: 'Tillverkning av pastaprodukter',
        },
        {
            A: '10.810',
            B: '10810',
            C: 'Sockertillverkning',
        },
        {
            A: '10.821',
            B: '10821',
            C: 'Tillverkning av sockerkonfektyrer',
        },
        {
            A: '10.822',
            B: '10822',
            C: 'Tillverkning av choklad och chokladkonfektyrer',
        },
        {
            A: '10.830',
            B: '10830',
            C: 'Framställning av te och kaffe',
        },
        {
            A: '10.840',
            B: '10840',
            C: 'Tillverkning av senap, ketchup, kryddor och andra smaksättningsmedel',
        },
        {
            A: '10.850',
            B: '10850',
            C: 'Tillverkning av lagad mat och färdigrätter',
        },
        {
            A: '10.860',
            B: '10860',
            C: 'Tillverkning av homogeniserade livsmedelspreparat inklusive dietmat',
        },
        {
            A: '10.890',
            B: '10890',
            C: 'Framställning av andra livsmedel',
        },
        {
            A: '10.910',
            B: '10910',
            C: 'Framställning av beredda fodermedel',
        },
        {
            A: '10.920',
            B: '10920',
            C: 'Framställning av mat till sällskapsdjur',
        },
        {
            A: '11.010',
            B: '11010',
            C: 'Destillering, rening och tillblandning av spritdrycker',
        },
        {
            A: '11.020',
            B: '11020',
            C: 'Framställning av vin från druvor',
        },
        {
            A: '11.030',
            B: '11030',
            C: 'Framställning av cider och andra fruktviner',
        },
        {
            A: '11.040',
            B: '11040',
            C: 'Framställning av andra icke-destillerade jästa drycker',
        },
        {
            A: '11.050',
            B: '11050',
            C: 'Framställning av öl',
        },
        {
            A: '11.060',
            B: '11060',
            C: 'Framställning av malt',
        },
        {
            A: '11.070',
            B: '11070',
            C: 'Framställning av läskedrycker, mineralvatten och annat vatten på flaska',
        },
        {
            A: '12.000',
            B: '12000',
            C: 'Tobaksvarutillverkning',
        },
        {
            A: '13.100',
            B: '13100',
            C: 'Garntillverkning',
        },
        {
            A: '13.200',
            B: '13200',
            C: 'Vävnadstillverkning',
        },
        {
            A: '13.300',
            B: '13300',
            C: 'Blekning, färgning och annan textilberedning',
        },
        {
            A: '13.910',
            B: '13910',
            C: 'Tillverkning av trikåväv',
        },
        {
            A: '13.921',
            B: '13921',
            C: 'Sömnad av gardiner, sängkläder och linnevaror',
        },
        {
            A: '13.922',
            B: '13922',
            C: 'Tillverkning av presenningar, tält, segel o.d.',
        },
        {
            A: '13.930',
            B: '13930',
            C: 'Tillverkning av mattor',
        },
        {
            A: '13.940',
            B: '13940',
            C: 'Tågvirkes- och bindgarnstillverkning',
        },
        {
            A: '13.950',
            B: '13950',
            C: 'Tillverkning av bondad duk',
        },
        {
            A: '13.960',
            B: '13960',
            C: 'Tillverkning av andra tekniska textilier och industritextilier',
        },
        {
            A: '13.990',
            B: '13990',
            C: 'Övrig textilietillverkning',
        },
        {
            A: '14.110',
            B: '14110',
            C: 'Tillverkning av läder- och skinnkläder',
        },
        {
            A: '14.120',
            B: '14120',
            C: 'Tillverkning av arbets-, skydds- och överdragskläder',
        },
        {
            A: '14.130',
            B: '14130',
            C: 'Tillverkning av andra gång- och ytterkläder',
        },
        {
            A: '14.140',
            B: '14140',
            C: 'Tillverkning av underkläder, skjortor och blusar',
        },
        {
            A: '14.190',
            B: '14190',
            C: 'Tillverkning av andra beklädnadsvaror och tillbehör',
        },
        {
            A: '14.200',
            B: '14200',
            C: 'Tillverkning av pälsvaror',
        },
        {
            A: '14.310',
            B: '14310',
            C: 'Tillverkning av strumpor',
        },
        {
            A: '14.390',
            B: '14390',
            C: 'Tillverkning av andra trikåvaror',
        },
        {
            A: '15.110',
            B: '15110',
            C: 'Garvning och annan läderberedning; pälsberedning',
        },
        {
            A: '15.120',
            B: '15120',
            C: 'Tillverkning av reseffekter, handväskor, sadel- och seldon m. m.',
        },
        {
            A: '15.200',
            B: '15200',
            C: 'Tillverkning av skodon',
        },
        {
            A: '16.101',
            B: '16101',
            C: 'Sågning av trä',
        },
        {
            A: '16.102',
            B: '16102',
            C: 'Hyvling av trä',
        },
        {
            A: '16.103',
            B: '16103',
            C: 'Träimpregnering',
        },
        {
            A: '16.210',
            B: '16210',
            C: 'Tillverkning av fanér och träbaserade skivor',
        },
        {
            A: '16.220',
            B: '16220',
            C: 'Tillverkning av sammansatta parkettgolv',
        },
        {
            A: '16.231',
            B: '16231',
            C: 'Tillverkning av monteringsfärdiga trähus',
        },
        {
            A: '16.232',
            B: '16232',
            C: 'Tillverkning av dörrar av trä',
        },
        {
            A: '16.233',
            B: '16233',
            C: 'Tillverkning av fönster av trä',
        },
        {
            A: '16.239',
            B: '16239',
            C: 'Tillverkning av övriga byggnads- och inredningssnickerier',
        },
        {
            A: '16.240',
            B: '16240',
            C: 'Träförpackningstillverkning',
        },
        {
            A: '16.291',
            B: '16291',
            C: 'Tillverkning av förädlade trädbränslen',
        },
        {
            A: '16.292',
            B: '16292',
            C: 'Övrig trävarutillverkning',
        },
        {
            A: '16.293',
            B: '16293',
            C: 'Tillverkning av varor av kork, halm, rotting o.d.',
        },
        {
            A: '17.111',
            B: '17111',
            C: 'Tillverkning av mekanisk eller halvkemisk massa',
        },
        {
            A: '17.112',
            B: '17112',
            C: 'Sulfatmassatillverkning',
        },
        {
            A: '17.113',
            B: '17113',
            C: 'Sulfitmassatillverkning',
        },
        {
            A: '17.121',
            B: '17121',
            C: 'Tillverkning av tidnings- och journalpapper',
        },
        {
            A: '17.122',
            B: '17122',
            C: 'Tryckpapperstillverkning, ej tidnings- och journalpapper',
        },
        {
            A: '17.123',
            B: '17123',
            C: 'Tillverkning av kraftpapper och kraftpapp',
        },
        {
            A: '17.129',
            B: '17129',
            C: 'Övrig tillverkning av papper och papp',
        },
        {
            A: '17.211',
            B: '17211',
            C: 'Tillverkning av wellpapp och wellpappförpackningar',
        },
        {
            A: '17.219',
            B: '17219',
            C: 'Övrig tillverkning av pappers- och pappförpackningar',
        },
        {
            A: '17.220',
            B: '17220',
            C: 'Tillverkning av hushålls- och hygienartiklar av papper',
        },
        {
            A: '17.230',
            B: '17230',
            C: 'Tillverkning av skrivpapper, kuvert o.d.',
        },
        {
            A: '17.240',
            B: '17240',
            C: 'Tapettillverkning',
        },
        {
            A: '17.290',
            B: '17290',
            C: 'Tillverkning av andra pappers- och pappvaror',
        },
        {
            A: '18.110',
            B: '18110',
            C: 'Tryckning av dagstidningar',
        },
        {
            A: '18.121',
            B: '18121',
            C: 'Tryckning av tidskrifter',
        },
        {
            A: '18.122',
            B: '18122',
            C: 'Tryckning av böcker och övriga trycksaker',
        },
        {
            A: '18.130',
            B: '18130',
            C: 'Grafiska tjänster före tryckning (prepress/premedia)',
        },
        {
            A: '18.140',
            B: '18140',
            C: 'Bokbindning och andra tjänster i samband med tryckning',
        },
        {
            A: '18.200',
            B: '18200',
            C: 'Reproduktion av inspelningar',
        },
        {
            A: '19.100',
            B: '19100',
            C: 'Tillverkning av stenkolsprodukter',
        },
        {
            A: '19.200',
            B: '19200',
            C: 'Petroleumraffinering',
        },
        {
            A: '20.110',
            B: '20110',
            C: 'Industrigasframställning',
        },
        {
            A: '20.120',
            B: '20120',
            C: 'Tillverkning av färgämnen',
        },
        {
            A: '20.130',
            B: '20130',
            C: 'Tillverkning av andra oorganiska baskemikalier',
        },
        {
            A: '20.140',
            B: '20140',
            C: 'Tillverkning av andra organiska baskemikalier',
        },
        {
            A: '20.150',
            B: '20150',
            C: 'Tillverkning av gödselmedel och kväveprodukter',
        },
        {
            A: '20.160',
            B: '20160',
            C: 'Basplastframställning',
        },
        {
            A: '20.170',
            B: '20170',
            C: 'Tillverkning av syntetiskt basgummi',
        },
        {
            A: '20.200',
            B: '20200',
            C: 'Tillverkning av bekämpningsmedel och andra lantbrukskemiska produkter',
        },
        {
            A: '20.300',
            B: '20300',
            C: 'Tillverkning av färg, lack, tryckfärg m.m.',
        },
        {
            A: '20.410',
            B: '20410',
            C: 'Tillverkning av tvål, såpa, tvättmedel och polermedel',
        },
        {
            A: '20.420',
            B: '20420',
            C: 'Tillverkning av parfymer och toalettartiklar',
        },
        {
            A: '20.510',
            B: '20510',
            C: 'Sprängämnestillverkning',
        },
        {
            A: '20.520',
            B: '20520',
            C: 'Tillverkning av lim',
        },
        {
            A: '20.530',
            B: '20530',
            C: 'Tillverkning av eteriska oljor',
        },
        {
            A: '20.590',
            B: '20590',
            C: 'Tillverkning av övriga kemiska produkter',
        },
        {
            A: '20.600',
            B: '20600',
            C: 'Konstfibertillverkning',
        },
        {
            A: '21.100',
            B: '21100',
            C: 'Tillverkning av farmaceutiska basprodukter',
        },
        {
            A: '21.200',
            B: '21200',
            C: 'Tillverkning av läkemedel',
        },
        {
            A: '22.110',
            B: '22110',
            C: 'Tillverkning av däck och slangar; regummering',
        },
        {
            A: '22.190',
            B: '22190',
            C: 'Annan gummivarutillverkning',
        },
        {
            A: '22.210',
            B: '22210',
            C: 'Tillverkning av plasthalvfabrikat',
        },
        {
            A: '22.220',
            B: '22220',
            C: 'Plastförpackningstillverkning',
        },
        {
            A: '22.230',
            B: '22230',
            C: 'Byggplastvarutillverkning',
        },
        {
            A: '22.290',
            B: '22290',
            C: 'Annan plastvarutillverkning',
        },
        {
            A: '23.110',
            B: '23110',
            C: 'Framställning av planglas',
        },
        {
            A: '23.120',
            B: '23120',
            C: 'Bearbetning av planglas',
        },
        {
            A: '23.130',
            B: '23130',
            C: 'Tillverkning av buteljer, glasförpackningar och husgeråd av glas',
        },
        {
            A: '23.140',
            B: '23140',
            C: 'Tillverkning av glasfiber',
        },
        {
            A: '23.190',
            B: '23190',
            C: 'Tillverkning av andra glasvaror inklusive tekniska glasvaror',
        },
        {
            A: '23.200',
            B: '23200',
            C: 'Tillverkning av eldfasta produkter',
        },
        {
            A: '23.310',
            B: '23310',
            C: 'Tillverkning av keramiska golv- och väggplattor',
        },
        {
            A: '23.320',
            B: '23320',
            C: 'Tillverkning av murtegel, takpannor och andra byggvaror av tegel',
        },
        {
            A: '23.410',
            B: '23410',
            C: 'Tillverkning av keramiska hushålls- och prydnadsartiklar',
        },
        {
            A: '23.420',
            B: '23420',
            C: 'Tillverkning av keramiska sanitetsartiklar',
        },
        {
            A: '23.430',
            B: '23430',
            C: 'Tillverkning av keramiska isolatorer o.d.',
        },
        {
            A: '23.440',
            B: '23440',
            C: 'Tillverkning av andra tekniska keramiska produkter',
        },
        {
            A: '23.490',
            B: '23490',
            C: 'Tillverkning av andra keramiska produkter',
        },
        {
            A: '23.510',
            B: '23510',
            C: 'Tillverkning av cement',
        },
        {
            A: '23.520',
            B: '23520',
            C: 'Tillverkning av kalk och gips',
        },
        {
            A: '23.610',
            B: '23610',
            C: 'Tillverkning av betongvaror  för byggändamål',
        },
        {
            A: '23.620',
            B: '23620',
            C: 'Tillverkning av gipsvaror  för byggändamål',
        },
        {
            A: '23.630',
            B: '23630',
            C: 'Tillverkning av fabriksblandad betong',
        },
        {
            A: '23.640',
            B: '23640',
            C: 'Tillverkning av murbruk',
        },
        {
            A: '23.650',
            B: '23650',
            C: 'Tillverkning av fibercementvaror',
        },
        {
            A: '23.690',
            B: '23690',
            C: 'Tillverkning av andra varor av betong, cement och gips',
        },
        {
            A: '23.701',
            B: '23701',
            C: 'Huggning, formning och slutlig bearbetning av sten för byggnadsändamål',
        },
        {
            A: '23.709',
            B: '23709',
            C: 'Huggning, formning och slutlig bearbetning av sten för prydnadsändamål',
        },
        {
            A: '23.910',
            B: '23910',
            C: 'Slipmedelstillverkning',
        },
        {
            A: '23.991',
            B: '23991',
            C: 'Tillverkning av varor av sten- och mineralull',
        },
        {
            A: '23.999',
            B: '23999',
            C: 'Diverse övrig tillverkning av icke-metalliska mineraliska produkter',
        },
        {
            A: '24.100',
            B: '24100',
            C: 'Framställning av järn och stål samt ferrolegeringar',
        },
        {
            A: '24.200',
            B: '24200',
            C: 'Tillverkning av rör, ledningar, ihåliga profiler och tillbehör av stål',
        },
        {
            A: '24.310',
            B: '24310',
            C: 'Tillverkning av kalldragen stålstång',
        },
        {
            A: '24.320',
            B: '24320',
            C: 'Tillverkning av kallvalsade stålband',
        },
        {
            A: '24.330',
            B: '24330',
            C: 'Tillverkning av andra kallformade produkter av stål',
        },
        {
            A: '24.340',
            B: '24340',
            C: 'Tillverkning av kalldragen ståltråd',
        },
        {
            A: '24.410',
            B: '24410',
            C: 'Framställning av ädla metaller',
        },
        {
            A: '24.420',
            B: '24420',
            C: 'Framställning av aluminium',
        },
        {
            A: '24.430',
            B: '24430',
            C: 'Framställning av bly, zink och tenn',
        },
        {
            A: '24.440',
            B: '24440',
            C: 'Framställning av koppar',
        },
        {
            A: '24.450',
            B: '24450',
            C: 'Framställning av andra metaller',
        },
        {
            A: '24.460',
            B: '24460',
            C: 'Tillverkning av kärnbränsle',
        },
        {
            A: '24.510',
            B: '24510',
            C: 'Gjutning av järn',
        },
        {
            A: '24.520',
            B: '24520',
            C: 'Gjutning av stål',
        },
        {
            A: '24.530',
            B: '24530',
            C: 'Gjutning av lättmetall',
        },
        {
            A: '24.540',
            B: '24540',
            C: 'Gjutning av andra metaller',
        },
        {
            A: '25.110',
            B: '25110',
            C: 'Tillverkning av metallstommar och delar därav',
        },
        {
            A: '25.120',
            B: '25120',
            C: 'Tillverkning av dörrar och fönster av metall',
        },
        {
            A: '25.210',
            B: '25210',
            C: 'Tillverkning av radiatorer och pannor för centraluppvärmning',
        },
        {
            A: '25.290',
            B: '25290',
            C: 'Tillverkning av andra cisterner, tankar, kar och andra behållare av metall',
        },
        {
            A: '25.300',
            B: '25300',
            C: 'Tillverkning av ånggeneratorer utom varmvattenpannor för centraluppvärmning',
        },
        {
            A: '25.400',
            B: '25400',
            C: 'Tillverkning av vapen och ammunition',
        },
        {
            A: '25.500',
            B: '25500',
            C: 'Smidning, pressning, prägling och valsning av metall; pulvermetallurgi',
        },
        {
            A: '25.610',
            B: '25610',
            C: 'Beläggning och överdragning av metall',
        },
        {
            A: '25.620',
            B: '25620',
            C: 'Metallegoarbeten',
        },
        {
            A: '25.710',
            B: '25710',
            C: 'Tillverkning av bestick',
        },
        {
            A: '25.720',
            B: '25720',
            C: 'Tillverkning av lås och gångjärn',
        },
        {
            A: '25.730',
            B: '25730',
            C: 'Tillverkning av verktyg och redskap',
        },
        {
            A: '25.910',
            B: '25910',
            C: 'Tillverkning av stålfat o.d. behållare',
        },
        {
            A: '25.920',
            B: '25920',
            C: 'Tillverkning av lättmetallförpackningar',
        },
        {
            A: '25.930',
            B: '25930',
            C: 'Tillverkning av metalltrådvaror, kedjor och fjädrar',
        },
        {
            A: '25.940',
            B: '25940',
            C: 'Tillverkning av nitar och skruvar',
        },
        {
            A: '25.991',
            B: '25991',
            C: 'Tillverkning av diskbänkar, sanitetsgods m. m. av metall för byggändamål',
        },
        {
            A: '25.999',
            B: '25999',
            C: 'Diverse övrig metallvarutillverkning',
        },
        {
            A: '26.110',
            B: '26110',
            C: 'Tillverkning av elektroniska komponenter',
        },
        {
            A: '26.120',
            B: '26120',
            C: 'Tillverkning av kretskort',
        },
        {
            A: '26.200',
            B: '26200',
            C: 'Tillverkning av datorer och kringutrustning',
        },
        {
            A: '26.300',
            B: '26300',
            C: 'Tillverkning av kommunikationsutrustning',
        },
        {
            A: '26.400',
            B: '26400',
            C: 'Tillverkning av hemelektronik',
        },
        {
            A: '26.510',
            B: '26510',
            C: 'Tillverkning av instrument och apparater för mätning, provning och navigering',
        },
        {
            A: '26.520',
            B: '26520',
            C: 'Urtillverkning',
        },
        {
            A: '26.600',
            B: '26600',
            C: 'Tillverkning av strålningsutrustning samt elektromedicinsk och elektroterapeutisk utrustning',
        },
        {
            A: '26.700',
            B: '26700',
            C: 'Tillverkning av optiska instrument och fotoutrustning',
        },
        {
            A: '26.800',
            B: '26800',
            C: 'Tillverkning av magnetiska och optiska medier',
        },
        {
            A: '27.110',
            B: '27110',
            C: 'Tillverkning av elmotorer, generatorer och transformatorer',
        },
        {
            A: '27.120',
            B: '27120',
            C: 'Tillverkning av eldistributions- och elkontrollapparater',
        },
        {
            A: '27.200',
            B: '27200',
            C: 'Batteri- och ackumulatortillverkning',
        },
        {
            A: '27.310',
            B: '27310',
            C: 'Tillverkning av optiska fiberkablar',
        },
        {
            A: '27.320',
            B: '27320',
            C: 'Tillverkning av andra elektroniska och elektriska ledningar och kablar',
        },
        {
            A: '27.330',
            B: '27330',
            C: 'Tillverkning av kabeltillbehör',
        },
        {
            A: '27.400',
            B: '27400',
            C: 'Tillverkning av belysningsarmatur',
        },
        {
            A: '27.510',
            B: '27510',
            C: 'Tillverkning av elektriska hushållsmaskiner och hushållsapparater',
        },
        {
            A: '27.520',
            B: '27520',
            C: 'Tillverkning av icke-elektriska hushållsmaskiner och hushållsapparater',
        },
        {
            A: '27.900',
            B: '27900',
            C: 'Tillverkning av annan elapparatur',
        },
        {
            A: '28.110',
            B: '28110',
            C: 'Tillverkning av motorer och turbiner utom för luftfartyg och fordon',
        },
        {
            A: '28.120',
            B: '28120',
            C: 'Tillverkning av fluidteknisk utrustning',
        },
        {
            A: '28.130',
            B: '28130',
            C: 'Tillverkning av andra pumpar och kompressorer',
        },
        {
            A: '28.140',
            B: '28140',
            C: 'Tillverkning av andra kranar och ventiler',
        },
        {
            A: '28.150',
            B: '28150',
            C: 'Tillverkning av lager, kugghjul och andra delar för kraftöverföring',
        },
        {
            A: '28.210',
            B: '28210',
            C: 'Tillverkning av ugnar och brännare',
        },
        {
            A: '28.220',
            B: '28220',
            C: 'Tillverkning av lyft- och godshanteringsanordningar',
        },
        {
            A: '28.230',
            B: '28230',
            C: 'Tillverkning av kontorsmaskiner och kontorsutrustning (utom datorer och kringutrustning)',
        },
        {
            A: '28.240',
            B: '28240',
            C: 'Tillverkning av motordrivna handverktyg',
        },
        {
            A: '28.250',
            B: '28250',
            C: 'Tillverkning av maskiner och apparater för kyla och ventilation utom för hushåll',
        },
        {
            A: '28.290',
            B: '28290',
            C: 'Övrig tillverkning av maskiner för allmänt ändamål',
        },
        {
            A: '28.300',
            B: '28300',
            C: 'Tillverkning av jord- och skogsbruksmaskiner',
        },
        {
            A: '28.410',
            B: '28410',
            C: 'Tillverkning av verktygsmaskiner för metallbearbetning',
        },
        {
            A: '28.490',
            B: '28490',
            C: 'Tillverkning av övriga verktygsmaskiner',
        },
        {
            A: '28.910',
            B: '28910',
            C: 'Tillverkning av maskiner för metallurgi',
        },
        {
            A: '28.920',
            B: '28920',
            C: 'Tillverkning av gruv-, bergbrytnings- och byggmaskiner',
        },
        {
            A: '28.930',
            B: '28930',
            C: 'Tillverkning av maskiner för framställning av livsmedel, drycker och tobaksvaror',
        },
        {
            A: '28.940',
            B: '28940',
            C: 'Tillverkning av maskiner för produktion av textil-, beklädnads- och lädervaror',
        },
        {
            A: '28.950',
            B: '28950',
            C: 'Tillverkning av maskiner för produktion av massa, papper och papp',
        },
        {
            A: '28.960',
            B: '28960',
            C: 'Tillverkning av maskiner för gummi och plast',
        },
        {
            A: '28.990',
            B: '28990',
            C: 'Tillverkning av övriga specialmaskiner',
        },
        {
            A: '29.101',
            B: '29101',
            C: 'Tillverkning av personbilar och andra lätta motorfordon',
        },
        {
            A: '29.102',
            B: '29102',
            C: 'Tillverkning av lastbilar och andra tunga motorfordon',
        },
        {
            A: '29.200',
            B: '29200',
            C: 'Tillverkning av karosserier för motorfordon; tillverkning av släpfordon och påhängsvagnar',
        },
        {
            A: '29.310',
            B: '29310',
            C: 'Tillverkning av elektrisk och elektronisk utrustning för motorfordon',
        },
        {
            A: '29.320',
            B: '29320',
            C: 'Tillverkning av andra delar och tillbehör till motorfordon',
        },
        {
            A: '30.110',
            B: '30110',
            C: 'Byggande av fartyg och flytande materiel',
        },
        {
            A: '30.120',
            B: '30120',
            C: 'Byggande av fritidsbåtar',
        },
        {
            A: '30.200',
            B: '30200',
            C: 'Tillverkning av rälsfordon',
        },
        {
            A: '30.300',
            B: '30300',
            C: 'Tillverkning av luftfartyg, rymdfarkoster o.d.',
        },
        {
            A: '30.400',
            B: '30400',
            C: 'Tillverkning av militära stridsfordon',
        },
        {
            A: '30.910',
            B: '30910',
            C: 'Tillverkning av motorcyklar',
        },
        {
            A: '30.920',
            B: '30920',
            C: 'Tillverkning av cyklar och invalidfordon',
        },
        {
            A: '30.990',
            B: '30990',
            C: 'Diverse övrig transportmedelstillverkning',
        },
        {
            A: '31.011',
            B: '31011',
            C: 'Tillverkning av kontors- och butiksmöbler',
        },
        {
            A: '31.012',
            B: '31012',
            C: 'Tillverkning av kontors- och butiksinredningar',
        },
        {
            A: '31.021',
            B: '31021',
            C: 'Tillverkning av köksmöbler',
        },
        {
            A: '31.022',
            B: '31022',
            C: 'Tillverkning av köksinredningar',
        },
        {
            A: '31.030',
            B: '31030',
            C: 'Tillverkning av madrasser',
        },
        {
            A: '31.090',
            B: '31090',
            C: 'Tillverkning av andra möbler',
        },
        {
            A: '32.110',
            B: '32110',
            C: 'Prägling av mynt',
        },
        {
            A: '32.120',
            B: '32120',
            C: 'Tillverkning av smycken, guld- och silversmedsvaror',
        },
        {
            A: '32.130',
            B: '32130',
            C: 'Tillverkning av bijouterier o.d.',
        },
        {
            A: '32.200',
            B: '32200',
            C: 'Tillverkning av musikinstrument',
        },
        {
            A: '32.300',
            B: '32300',
            C: 'Tillverkning av sportartiklar',
        },
        {
            A: '32.400',
            B: '32400',
            C: 'Tillverkning av spel och leksaker',
        },
        {
            A: '32.501',
            B: '32501',
            C: 'Tillverkning av medicinska och dentala instrument och tillbehör',
        },
        {
            A: '32.502',
            B: '32502',
            C: 'Tillverkning av tandproteser',
        },
        {
            A: '32.910',
            B: '32910',
            C: 'Tillverkning av borstbinderiarbeten',
        },
        {
            A: '32.990',
            B: '32990',
            C: 'Diverse övrig tillverkning',
        },
        {
            A: '33.110',
            B: '33110',
            C: 'Reparation av metallvaror',
        },
        {
            A: '33.120',
            B: '33120',
            C: 'Reparation av maskiner',
        },
        {
            A: '33.130',
            B: '33130',
            C: 'Reparation av elektronisk och optisk utrustning',
        },
        {
            A: '33.140',
            B: '33140',
            C: 'Reparation av elapparatur',
        },
        {
            A: '33.150',
            B: '33150',
            C: 'Reparation och underhåll av fartyg och båtar',
        },
        {
            A: '33.160',
            B: '33160',
            C: 'Reparation och underhåll av luftfartyg och rymdfarkoster',
        },
        {
            A: '33.170',
            B: '33170',
            C: 'Reparation och underhåll av andra transportmedel',
        },
        {
            A: '33.190',
            B: '33190',
            C: 'Reparation av annan utrustning',
        },
        {
            A: '33.200',
            B: '33200',
            C: 'Installation av industrimaskiner och -utrustning',
        },
        {
            A: '35.110',
            B: '35110',
            C: 'Generering av elektricitet',
        },
        {
            A: '35.120',
            B: '35120',
            C: 'Överföring av elektricitet',
        },
        {
            A: '35.130',
            B: '35130',
            C: 'Distribution av elektricitet',
        },
        {
            A: '35.140',
            B: '35140',
            C: 'Handel med elektricitet',
        },
        {
            A: '35.210',
            B: '35210',
            C: 'Framställning av gas',
        },
        {
            A: '35.220',
            B: '35220',
            C: 'Distribution av gasformiga bränslen via rörnät',
        },
        {
            A: '35.230',
            B: '35230',
            C: 'Handel med gas via rörnät',
        },
        {
            A: '35.300',
            B: '35300',
            C: 'Försörjning av värme och kyla',
        },
        {
            A: '36.001',
            B: '36001',
            C: 'Grundvattenförsörjning',
        },
        {
            A: '36.002',
            B: '36002',
            C: 'Ytvattenförsörjning',
        },
        {
            A: '37.000',
            B: '37000',
            C: 'Avloppsrening',
        },
        {
            A: '38.110',
            B: '38110',
            C: 'Insamling av icke-farligt avfall',
        },
        {
            A: '38.120',
            B: '38120',
            C: 'Insamling av farligt avfall',
        },
        {
            A: '38.210',
            B: '38210',
            C: 'Behandling och bortskaffande av icke-farligt avfall',
        },
        {
            A: '38.220',
            B: '38220',
            C: 'Behandling och bortskaffande av farligt avfall',
        },
        {
            A: '38.311',
            B: '38311',
            C: 'Demontering av uttjänta fordon',
        },
        {
            A: '38.312',
            B: '38312',
            C: 'Demontering av elektrisk och elektronisk utrustning',
        },
        {
            A: '38.319',
            B: '38319',
            C: 'Demontering av övrig kasserad utrustning',
        },
        {
            A: '38.320',
            B: '38320',
            C: 'Återvinning av källsorterat material',
        },
        {
            A: '39.000',
            B: '39000',
            C: 'Sanering, efterbehandling av jord och vatten samt annan verksamhet för föroreningsbekämpning',
        },
        {
            A: '41.100',
            B: '41100',
            C: 'Utformning av byggprojekt',
        },
        {
            A: '41.200',
            B: '41200',
            C: 'Byggande av bostadshus och andra byggnader',
        },
        {
            A: '42.110',
            B: '42110',
            C: 'Anläggning av vägar och motorvägar',
        },
        {
            A: '42.120',
            B: '42120',
            C: 'Anläggning av järnvägar och tunnelbanor',
        },
        {
            A: '42.130',
            B: '42130',
            C: 'Anläggning av broar och tunnlar',
        },
        {
            A: '42.210',
            B: '42210',
            C: 'Allmännyttiga anläggningsarbeten för värme, vatten och avlopp',
        },
        {
            A: '42.220',
            B: '42220',
            C: 'Anläggningsarbeten för el och telekommunikation',
        },
        {
            A: '42.910',
            B: '42910',
            C: 'Vattenbyggnad',
        },
        {
            A: '42.990',
            B: '42990',
            C: 'Övriga anläggningsarbeten',
        },
        {
            A: '43.110',
            B: '43110',
            C: 'Rivning av hus och byggnader',
        },
        {
            A: '43.120',
            B: '43120',
            C: 'Mark- och grundarbeten',
        },
        {
            A: '43.130',
            B: '43130',
            C: 'Markundersökning',
        },
        {
            A: '43.210',
            B: '43210',
            C: 'Elinstallationer',
        },
        {
            A: '43.221',
            B: '43221',
            C: 'Värme- och sanitetsarbeten',
        },
        {
            A: '43.222',
            B: '43222',
            C: 'Ventilationsarbeten',
        },
        {
            A: '43.223',
            B: '43223',
            C: 'Kyl- och frysinstallationsarbeten',
        },
        {
            A: '43.229',
            B: '43229',
            C: 'Övriga VVS-arbeten',
        },
        {
            A: '43.290',
            B: '43290',
            C: 'Andra bygginstallationer',
        },
        {
            A: '43.310',
            B: '43310',
            C: 'Puts-, fasad- och stuckatörsarbeten',
        },
        {
            A: '43.320',
            B: '43320',
            C: 'Byggnadssnickeriarbeten',
        },
        {
            A: '43.330',
            B: '43330',
            C: 'Golv- och väggbeläggningsarbeten',
        },
        {
            A: '43.341',
            B: '43341',
            C: 'Måleriarbeten',
        },
        {
            A: '43.342',
            B: '43342',
            C: 'Glasmästeriarbeten',
        },
        {
            A: '43.390',
            B: '43390',
            C: 'Annan slutbehandling av byggnader',
        },
        {
            A: '43.911',
            B: '43911',
            C: 'Takarbeten av plåt',
        },
        {
            A: '43.912',
            B: '43912',
            C: 'Takarbeten av andra material än plåt',
        },
        {
            A: '43.991',
            B: '43991',
            C: 'Uthyrning av bygg- och anläggningsmaskiner med förare',
        },
        {
            A: '43.999',
            B: '43999',
            C: 'Diverse övrig specialiserad bygg- och anläggningsverksamhet',
        },
        {
            A: '45.110',
            B: '45110',
            C: 'Handel med personbilar och lätta motorfordon',
        },
        {
            A: '45.191',
            B: '45191',
            C: 'Handel med lastbilar, bussar och specialfordon',
        },
        {
            A: '45.192',
            B: '45192',
            C: 'Handel med husvagnar, husbilar, släpfordon och påhängsvagnar',
        },
        {
            A: '45.201',
            B: '45201',
            C: 'Allmän service och reparation av motorfordon utom motorcyklar',
        },
        {
            A: '45.202',
            B: '45202',
            C: 'Plåt-, lack- och glasreparationer på motorfordon utom motorcyklar',
        },
        {
            A: '45.203',
            B: '45203',
            C: 'Installationer och reparationer av elsystem till motorfordon utom motorcyklar',
        },
        {
            A: '45.204',
            B: '45204',
            C: 'Däckservice',
        },
        {
            A: '45.310',
            B: '45310',
            C: 'Parti- och provisionshandel med reservdelar och tillbehör till motorfordon utom motorcyklar',
        },
        {
            A: '45.320',
            B: '45320',
            C: 'Detaljhandel med reservdelar och tillbehör till motorfordon utom motorcyklar',
        },
        {
            A: '45.400',
            B: '45400',
            C: 'Handel med och service av motorcyklar inklusive reservdelar och tillbehör',
        },
        {
            A: '46.110',
            B: '46110',
            C: 'Provisionshandel med jordbruksråvaror, levande djur, textilråvaror och textilhalvfabrikat',
        },
        {
            A: '46.120',
            B: '46120',
            C: 'Provisionshandel med bränsle, malm, metaller och industrikemikalier',
        },
        {
            A: '46.130',
            B: '46130',
            C: 'Provisionshandel med virke och byggmaterial',
        },
        {
            A: '46.141',
            B: '46141',
            C: 'Provisionshandel med maskiner, industriell utrustning, fartyg och luftfartyg utom kontorsutrustning och datorer',
        },
        {
            A: '46.142',
            B: '46142',
            C: 'Provisionshandel med kontorsutrustning och datorer',
        },
        {
            A: '46.150',
            B: '46150',
            C: 'Provisionshandel med möbler, hushålls- och järnhandelsvaror',
        },
        {
            A: '46.160',
            B: '46160',
            C: 'Provisionshandel med textilier, kläder, skodon och lädervaror',
        },
        {
            A: '46.170',
            B: '46170',
            C: 'Provisionshandel med livsmedel, drycker och tobak',
        },
        {
            A: '46.180',
            B: '46180',
            C: 'Provisionshandel med annat specialsortiment',
        },
        {
            A: '46.190',
            B: '46190',
            C: 'Provisionshandel med blandat sortiment',
        },
        {
            A: '46.210',
            B: '46210',
            C: 'Partihandel med spannmål, råtobak, utsäde och djurfoder',
        },
        {
            A: '46.220',
            B: '46220',
            C: 'Partihandel med blommor och växter',
        },
        {
            A: '46.230',
            B: '46230',
            C: 'Partihandel med levande djur',
        },
        {
            A: '46.240',
            B: '46240',
            C: 'Partihandel med hudar, skinn och läder',
        },
        {
            A: '46.310',
            B: '46310',
            C: 'Partihandel med frukt och grönsaker',
        },
        {
            A: '46.320',
            B: '46320',
            C: 'Partihandel med kött- och köttvaror',
        },
        {
            A: '46.330',
            B: '46330',
            C: 'Partihandel med mejeriprodukter, ägg, matolja och matfett',
        },
        {
            A: '46.340',
            B: '46340',
            C: 'Partihandel med drycker',
        },
        {
            A: '46.350',
            B: '46350',
            C: 'Partihandel med tobak',
        },
        {
            A: '46.360',
            B: '46360',
            C: 'Partihandel med socker, choklad och sockerkonfektyrer',
        },
        {
            A: '46.370',
            B: '46370',
            C: 'Partihandel med kaffe, te, kakao och kryddor',
        },
        {
            A: '46.380',
            B: '46380',
            C: 'Partihandel med andra livsmedel, bl.a. fisk samt skal- och blötdjur',
        },
        {
            A: '46.390',
            B: '46390',
            C: 'Icke specialiserad partihandel med livsmedel, drycker och tobak',
        },
        {
            A: '46.410',
            B: '46410',
            C: 'Partihandel med textilier',
        },
        {
            A: '46.420',
            B: '46420',
            C: 'Partihandel med kläder och skodon',
        },
        {
            A: '46.431',
            B: '46431',
            C: 'Partihandel med elektriska hushållsmaskiner och -apparater',
        },
        {
            A: '46.432',
            B: '46432',
            C: 'Partihandel med ljud- och bildanläggningar samt videoutrustning',
        },
        {
            A: '46.433',
            B: '46433',
            C: 'Partihandel med inspelade band och skivor för musik och bild',
        },
        {
            A: '46.434',
            B: '46434',
            C: 'Partihandel med elartiklar',
        },
        {
            A: '46.435',
            B: '46435',
            C: 'Partihandel med fotografiska och optiska produkter',
        },
        {
            A: '46.440',
            B: '46440',
            C: 'Partihandel med glas och porslin, rengöringsmedel',
        },
        {
            A: '46.450',
            B: '46450',
            C: 'Partihandel med parfym och kosmetika',
        },
        {
            A: '46.460',
            B: '46460',
            C: 'Partihandel med medicinsk utrustning och apoteksvaror',
        },
        {
            A: '46.470',
            B: '46470',
            C: 'Partihandel med möbler, mattor och belysningsartiklar',
        },
        {
            A: '46.480',
            B: '46480',
            C: 'Partihandel med ur och guldsmedsvaror',
        },
        {
            A: '46.491',
            B: '46491',
            C: 'Partihandel med sport- och fritidsartiklar',
        },
        {
            A: '46.492',
            B: '46492',
            C: 'Partihandel med kontorsförbrukningsvaror',
        },
        {
            A: '46.499',
            B: '46499',
            C: 'Partihandel med övriga hushållsvaror',
        },
        {
            A: '46.510',
            B: '46510',
            C: 'Partihandel med datorer och kringutrustning samt programvara',
        },
        {
            A: '46.521',
            B: '46521',
            C: 'Partihandel med elektronikkomponenter',
        },
        {
            A: '46.522',
            B: '46522',
            C: 'Partihandel med teleprodukter',
        },
        {
            A: '46.610',
            B: '46610',
            C: 'Partihandel med jordbruksmaskiner och -utrustning',
        },
        {
            A: '46.620',
            B: '46620',
            C: 'Partihandel med verktygsmaskiner',
        },
        {
            A: '46.630',
            B: '46630',
            C: 'Partihandel med gruv-, bygg- och anläggningsmaskiner',
        },
        {
            A: '46.640',
            B: '46640',
            C: 'Partihandel med textil-, sy- och stickmaskiner',
        },
        {
            A: '46.650',
            B: '46650',
            C: 'Partihandel med kontorsmöbler',
        },
        {
            A: '46.660',
            B: '46660',
            C: 'Partihandel med andra kontorsmaskiner och kontorsutrustning',
        },
        {
            A: '46.691',
            B: '46691',
            C: 'Partihandel med mät- och precisionsinstrument',
        },
        {
            A: '46.692',
            B: '46692',
            C: 'Partihandel med datoriserad materialhanteringsutrustning',
        },
        {
            A: '46.699',
            B: '46699',
            C: 'Partihandel med diverse övriga maskiner och utrustning',
        },
        {
            A: '46.710',
            B: '46710',
            C: 'Partihandel med bränslen',
        },
        {
            A: '46.720',
            B: '46720',
            C: 'Partihandel med metaller och metallmalmer',
        },
        {
            A: '46.731',
            B: '46731',
            C: 'Partihandel med virke och andra byggmaterial',
        },
        {
            A: '46.732',
            B: '46732',
            C: 'Partihandel med sanitetsgods',
        },
        {
            A: '46.741',
            B: '46741',
            C: 'Partihandel med järnhandelsvaror',
        },
        {
            A: '46.742',
            B: '46742',
            C: 'Partihandel med VVS-varor',
        },
        {
            A: '46.750',
            B: '46750',
            C: 'Partihandel med kemiska produkter',
        },
        {
            A: '46.761',
            B: '46761',
            C: 'Partihandel med industriförnödenheter',
        },
        {
            A: '46.762',
            B: '46762',
            C: 'Partihandel med emballage',
        },
        {
            A: '46.769',
            B: '46769',
            C: 'Partihandel med övriga insatsvaror',
        },
        {
            A: '46.771',
            B: '46771',
            C: 'Partihandel med uttjänta fordon',
        },
        {
            A: '46.772',
            B: '46772',
            C: 'Partihandel med metallavfall och metallskrot',
        },
        {
            A: '46.773',
            B: '46773',
            C: 'Partihandel med avfall och skrot av icke-metall',
        },
        {
            A: '46.900',
            B: '46900',
            C: 'Övrig partihandel',
        },
        {
            A: '47.111',
            B: '47111',
            C: 'Varuhus- och stormarknadshandel, mest livsmedel, drycker och tobak',
        },
        {
            A: '47.112',
            B: '47112',
            C: 'Livsmedelshandel med brett sortiment, ej varuhus eller stormarknad',
        },
        {
            A: '47.191',
            B: '47191',
            C: 'Annan varuhus- och stormarknadshandel',
        },
        {
            A: '47.199',
            B: '47199',
            C: 'Övrig detaljhandel med brett sortiment',
        },
        {
            A: '47.210',
            B: '47210',
            C: 'Specialiserad butikshandel med frukt och grönsaker',
        },
        {
            A: '47.220',
            B: '47220',
            C: 'Specialiserad butikshandel med kött och charkuterier',
        },
        {
            A: '47.230',
            B: '47230',
            C: 'Specialiserad butikshandel med fisk, skal- och blötdjur',
        },
        {
            A: '47.241',
            B: '47241',
            C: 'Specialiserad butikshandel med bröd och konditorivaror',
        },
        {
            A: '47.242',
            B: '47242',
            C: 'Specialiserad butikshandel med konfektyrer',
        },
        {
            A: '47.250',
            B: '47250',
            C: 'Specialiserad butikshandel med alkoholhaltiga och andra drycker',
        },
        {
            A: '47.260',
            B: '47260',
            C: 'Specialiserad butikshandel med tobaksvaror',
        },
        {
            A: '47.291',
            B: '47291',
            C: 'Specialiserad butikshandel med hälsokost',
        },
        {
            A: '47.299',
            B: '47299',
            C: 'Övrig specialiserad butikshandel med livsmedel',
        },
        {
            A: '47.300',
            B: '47300',
            C: 'Specialiserad detaljhandel med drivmedel',
        },
        {
            A: '47.410',
            B: '47410',
            C: 'Specialiserad butikshandel med datorer, programvara, data- och tv-spel',
        },
        {
            A: '47.420',
            B: '47420',
            C: 'Specialiserad butikshandel med telekommunikationsutrustning',
        },
        {
            A: '47.430',
            B: '47430',
            C: 'Specialiserad butikshandel med ljud- och bildanläggningar samt videoutrustning',
        },
        {
            A: '47.510',
            B: '47510',
            C: 'Specialiserad butikshandel med textilier',
        },
        {
            A: '47.521',
            B: '47521',
            C: 'Specialiserad butikshandel med virke och byggvaror',
        },
        {
            A: '47.522',
            B: '47522',
            C: 'Specialiserad butikshandel med järn- och VVS-varor',
        },
        {
            A: '47.523',
            B: '47523',
            C: 'Specialiserad butikshandel med färger, fernissor och lacker',
        },
        {
            A: '47.531',
            B: '47531',
            C: 'Specialiserad butikshandel med mattor och annan vägg- och golvbeklädnad',
        },
        {
            A: '47.532',
            B: '47532',
            C: 'Specialiserad butikshandel med inredningstextilier',
        },
        {
            A: '47.540',
            B: '47540',
            C: 'Specialiserad butikshandel med elektriska hushållsmaskiner och hushållsapparater',
        },
        {
            A: '47.591',
            B: '47591',
            C: 'Specialiserad butikshandel med möbler för hemmet',
        },
        {
            A: '47.592',
            B: '47592',
            C: 'Specialiserad butikshandel med kontorsmöbler',
        },
        {
            A: '47.593',
            B: '47593',
            C: 'Specialiserad butikshandel med glas, porslin och andra bosättningsvaror',
        },
        {
            A: '47.594',
            B: '47594',
            C: 'Specialiserad butikshandel med belysningsartiklar',
        },
        {
            A: '47.595',
            B: '47595',
            C: 'Specialiserad butikshandel med musikinstrument och noter',
        },
        {
            A: '47.610',
            B: '47610',
            C: 'Specialiserad butikshandel med böcker',
        },
        {
            A: '47.621',
            B: '47621',
            C: 'Specialiserad butikshandel med tidningar',
        },
        {
            A: '47.622',
            B: '47622',
            C: 'Specialiserad butikshandel med kontorsförbrukningsvaror',
        },
        {
            A: '47.630',
            B: '47630',
            C: 'Specialiserad butikshandel med inspelade och oinspelade band och skivor för musik och bild',
        },
        {
            A: '47.641',
            B: '47641',
            C: 'Specialiserad butikshandel med sport- och fritidsartiklar utom cyklar och båtar',
        },
        {
            A: '47.642',
            B: '47642',
            C: 'Specialiserad butikshandel med cyklar',
        },
        {
            A: '47.643',
            B: '47643',
            C: 'Specialiserad butikshandel med båtar',
        },
        {
            A: '47.650',
            B: '47650',
            C: 'Specialiserad butikshandel med spel och leksaker',
        },
        {
            A: '47.711',
            B: '47711',
            C: 'Specialiserad butikshandel med herr-, dam- och barnkläder, blandat',
        },
        {
            A: '47.712',
            B: '47712',
            C: 'Specialiserad butikshandel med herrkläder',
        },
        {
            A: '47.713',
            B: '47713',
            C: 'Specialiserad butikshandel med damkläder',
        },
        {
            A: '47.714',
            B: '47714',
            C: 'Specialiserad butikshandel med barnkläder',
        },
        {
            A: '47.715',
            B: '47715',
            C: 'Specialiserad butikshandel med pälsar',
        },
        {
            A: '47.721',
            B: '47721',
            C: 'Specialiserad butikshandel med skodon',
        },
        {
            A: '47.722',
            B: '47722',
            C: 'Specialiserad butikshandel med väskor, reseffekter och lädervaror',
        },
        {
            A: '47.730',
            B: '47730',
            C: 'Apotekshandel',
        },
        {
            A: '47.740',
            B: '47740',
            C: 'Specialiserad butikshandel med sjukvårdsartiklar',
        },
        {
            A: '47.750',
            B: '47750',
            C: 'Specialiserad butikshandel med kosmetika och hygienartiklar',
        },
        {
            A: '47.761',
            B: '47761',
            C: 'Specialiserad butikshandel med blommor och andra växter, frön och gödselmedel',
        },
        {
            A: '47.762',
            B: '47762',
            C: 'Specialiserad butikshandel med små sällskapsdjur',
        },
        {
            A: '47.771',
            B: '47771',
            C: 'Specialiserad butikshandel med ur',
        },
        {
            A: '47.772',
            B: '47772',
            C: 'Specialiserad butikshandel med guldsmedsvaror och smycken',
        },
        {
            A: '47.781',
            B: '47781',
            C: 'Specialiserad butikshandel med glasögon och andra optiska artiklar utom fotoutrustning',
        },
        {
            A: '47.782',
            B: '47782',
            C: 'Specialiserad butikshandel med fotoutrustning',
        },
        {
            A: '47.783',
            B: '47783',
            C: 'Specialiserad butikshandel med konst samt galleriverksamhet',
        },
        {
            A: '47.784',
            B: '47784',
            C: 'Specialiserad butikshandel med mynt och frimärken',
        },
        {
            A: '47.789',
            B: '47789',
            C: 'Övrig specialiserad butikshandel',
        },
        {
            A: '47.791',
            B: '47791',
            C: 'Specialiserad butikshandel med antikviteter och begagnade böcker',
        },
        {
            A: '47.792',
            B: '47792',
            C: 'Specialiserad butikshandel med övriga begagnade varor',
        },
        {
            A: '47.793',
            B: '47793',
            C: 'Auktioner i butik',
        },
        {
            A: '47.810',
            B: '47810',
            C: 'Torg- och marknadshandel med livsmedel, drycker och tobak',
        },
        {
            A: '47.820',
            B: '47820',
            C: 'Torg- och marknadshandel med textilier, kläder och skodon',
        },
        {
            A: '47.890',
            B: '47890',
            C: 'Torg- och marknadshandel med övriga varor',
        },
        {
            A: '47.911',
            B: '47911',
            C: 'Postorderhandel och detaljhandel på Internet med brett sortiment',
        },
        {
            A: '47.912',
            B: '47912',
            C: 'Postorderhandel och detaljhandel på Internet med beklädnadsvaror',
        },
        {
            A: '47.913',
            B: '47913',
            C: 'Postorderhandel och detaljhandel på Internet med böcker och andra mediavaror',
        },
        {
            A: '47.914',
            B: '47914',
            C: 'Postorderhandel och detaljhandel på Internet med datorer och annan elektronisk utrustning',
        },
        {
            A: '47.915',
            B: '47915',
            C: 'Postorderhandel och detaljhandel på Internet med sport- och fritidsutrustning',
        },
        {
            A: '47.916',
            B: '47916',
            C: 'Postorderhandel och detaljhandel på Internet med bosättningsvaror',
        },
        {
            A: '47.917',
            B: '47917',
            C: 'Auktioner på Internet',
        },
        {
            A: '47.919',
            B: '47919',
            C: 'Postorderhandel och detaljhandel på Internet med övriga varor',
        },
        {
            A: '47.991',
            B: '47991',
            C: 'Provisionsdetaljhandel (ej auktioner)',
        },
        {
            A: '47.992',
            B: '47992',
            C: 'Ambulerande och tillfällig handel med livsmedel',
        },
        {
            A: '47.993',
            B: '47993',
            C: 'Ambulerande och tillfällig handel med övriga varor',
        },
        {
            A: '47.994',
            B: '47994',
            C: 'Auktioner ej i butik eller på Internet',
        },
        {
            A: '47.999',
            B: '47999',
            C: 'Övrig detaljhandel ej i butik',
        },
        {
            A: '49.100',
            B: '49100',
            C: 'Järnvägstransport, passagerartrafik',
        },
        {
            A: '49.200',
            B: '49200',
            C: 'Järnvägstransport, godstrafik',
        },
        {
            A: '49.311',
            B: '49311',
            C: 'Linjebussverksamhet',
        },
        {
            A: '49.319',
            B: '49319',
            C: 'Övrig kollektivtrafik',
        },
        {
            A: '49.320',
            B: '49320',
            C: 'Taxitrafik',
        },
        {
            A: '49.390',
            B: '49390',
            C: 'Annan landtransport av passagerare',
        },
        {
            A: '49.410',
            B: '49410',
            C: 'Vägtransport, godstrafik',
        },
        {
            A: '49.420',
            B: '49420',
            C: 'Flyttjänster',
        },
        {
            A: '49.500',
            B: '49500',
            C: 'Transport i rörsystem',
        },
        {
            A: '50.101',
            B: '50101',
            C: 'Reguljär sjötrafik över hav och kust av passagerare',
        },
        {
            A: '50.102',
            B: '50102',
            C: 'Icke reguljär sjötrafik över hav och kust av passagerare',
        },
        {
            A: '50.201',
            B: '50201',
            C: 'Reguljär sjötrafik över hav och kust av gods',
        },
        {
            A: '50.202',
            B: '50202',
            C: 'Icke reguljär sjötrafik över hav och kust av gods',
        },
        {
            A: '50.301',
            B: '50301',
            C: 'Reguljär sjötrafik på inre vattenvägar av passagerare',
        },
        {
            A: '50.302',
            B: '50302',
            C: 'Icke reguljär sjötrafik på inre vattenvägar av passagerare',
        },
        {
            A: '50.401',
            B: '50401',
            C: 'Reguljär sjötrafik på inre vattenvägar av gods',
        },
        {
            A: '50.402',
            B: '50402',
            C: 'Icke reguljär sjötrafik på inre vattenvägar av gods',
        },
        {
            A: '51.101',
            B: '51101',
            C: 'Reguljär lufttransport av passagerare',
        },
        {
            A: '51.102',
            B: '51102',
            C: 'Icke reguljär lufttransport av passagerare',
        },
        {
            A: '51.211',
            B: '51211',
            C: 'Reguljär lufttransport av gods',
        },
        {
            A: '51.212',
            B: '51212',
            C: 'Icke reguljär lufttransport av gods',
        },
        {
            A: '51.220',
            B: '51220',
            C: 'Rymdfart',
        },
        {
            A: '52.100',
            B: '52100',
            C: 'Magasinering och varulagring',
        },
        {
            A: '52.211',
            B: '52211',
            C: 'Bärgning för landtransport',
        },
        {
            A: '52.219',
            B: '52219',
            C: 'Övriga stödtjänster till landtransport',
        },
        {
            A: '52.220',
            B: '52220',
            C: 'Stödtjänster till sjötransport',
        },
        {
            A: '52.230',
            B: '52230',
            C: 'Stödtjänster till lufttransport',
        },
        {
            A: '52.241',
            B: '52241',
            C: 'Hamngodshantering',
        },
        {
            A: '52.249',
            B: '52249',
            C: 'Övrig godshantering',
        },
        {
            A: '52.290',
            B: '52290',
            C: 'Övriga stödtjänster till transport',
        },
        {
            A: '53.100',
            B: '53100',
            C: 'Postbefordran via nationella posten',
        },
        {
            A: '53.201',
            B: '53201',
            C: 'Annan postbefordran',
        },
        {
            A: '53.202',
            B: '53202',
            C: 'Bud- och kurirverksamhet',
        },
        {
            A: '53.203',
            B: '53203',
            C: 'Tidningsdistribution',
        },
        {
            A: '55.101',
            B: '55101',
            C: 'Hotellverksamhet med restaurangrörelse',
        },
        {
            A: '55.102',
            B: '55102',
            C: 'Drift av konferensanläggningar',
        },
        {
            A: '55.103',
            B: '55103',
            C: 'Hotellverksamhet utan restaurangrörelse',
        },
        {
            A: '55.201',
            B: '55201',
            C: 'Vandrarhemsverksamhet',
        },
        {
            A: '55.202',
            B: '55202',
            C: 'Stugbyverksamhet m.m.',
        },
        {
            A: '55.300',
            B: '55300',
            C: 'Campingplatsverksamhet',
        },
        {
            A: '55.900',
            B: '55900',
            C: 'Annan logiverksamhet',
        },
        {
            A: '56.100',
            B: '56100',
            C: 'Restaurangverksamhet',
        },
        {
            A: '56.210',
            B: '56210',
            C: 'Cateringverksamhet vid enskilda evenemang',
        },
        {
            A: '56.291',
            B: '56291',
            C: 'Drift av personalmatsalar',
        },
        {
            A: '56.292',
            B: '56292',
            C: 'Centralköksverksamhet för sjukhus',
        },
        {
            A: '56.293',
            B: '56293',
            C: 'Centralköksverksamhet för skolor, omsorgs- och andra institutioner',
        },
        {
            A: '56.294',
            B: '56294',
            C: 'Cateringverksamhet för transportsektorn',
        },
        {
            A: '56.299',
            B: '56299',
            C: 'Övrig cateringverksamhet',
        },
        {
            A: '56.300',
            B: '56300',
            C: 'Barverksamhet',
        },
        {
            A: '58.110',
            B: '58110',
            C: 'Bokutgivning',
        },
        {
            A: '58.120',
            B: '58120',
            C: 'Publicering av kataloger och sändlistor',
        },
        {
            A: '58.131',
            B: '58131',
            C: 'Dagstidningsutgivning',
        },
        {
            A: '58.132',
            B: '58132',
            C: 'Annonstidningsutgivning',
        },
        {
            A: '58.140',
            B: '58140',
            C: 'Utgivning av tidskrifter',
        },
        {
            A: '58.190',
            B: '58190',
            C: 'Annan förlagsverksamhet',
        },
        {
            A: '58.210',
            B: '58210',
            C: 'Utgivning av dataspel',
        },
        {
            A: '58.290',
            B: '58290',
            C: 'Utgivning av annan programvara',
        },
        {
            A: '59.110',
            B: '59110',
            C: 'Produktion av film, video och TV-program',
        },
        {
            A: '59.120',
            B: '59120',
            C: 'Efterproduktion av film, video och TV-program',
        },
        {
            A: '59.130',
            B: '59130',
            C: 'Film-, video- och TV-programdistribution',
        },
        {
            A: '59.140',
            B: '59140',
            C: 'Filmvisning',
        },
        {
            A: '59.200',
            B: '59200',
            C: 'Ljudinspelning och fonogramutgivning',
        },
        {
            A: '60.100',
            B: '60100',
            C: 'Sändning av radioprogram',
        },
        {
            A: '60.200',
            B: '60200',
            C: 'Planering av TV-program och sändningsverksamhet',
        },
        {
            A: '61.100',
            B: '61100',
            C: 'Trådbunden telekommunikation',
        },
        {
            A: '61.200',
            B: '61200',
            C: 'Trådlös telekommunikation',
        },
        {
            A: '61.300',
            B: '61300',
            C: 'Telekommunikation via satellit',
        },
        {
            A: '61.900',
            B: '61900',
            C: 'Annan telekommunikation',
        },
        {
            A: '62.010',
            B: '62010',
            C: 'Dataprogrammering',
        },
        {
            A: '62.020',
            B: '62020',
            C: 'Datakonsultverksamhet',
        },
        {
            A: '62.030',
            B: '62030',
            C: 'Datordrifttjänster',
        },
        {
            A: '62.090',
            B: '62090',
            C: 'Andra IT- och datatjänster',
        },
        {
            A: '63.110',
            B: '63110',
            C: 'Databehandling, hosting o.d.',
        },
        {
            A: '63.120',
            B: '63120',
            C: 'Webbportaler',
        },
        {
            A: '63.910',
            B: '63910',
            C: 'Nyhetsservice',
        },
        {
            A: '63.990',
            B: '63990',
            C: 'Övriga informationstjänster',
        },
        {
            A: '64.110',
            B: '64110',
            C: 'Centralbanksverksamhet',
        },
        {
            A: '64.190',
            B: '64190',
            C: 'Annan monetär finansförmedling',
        },
        {
            A: '64.201',
            B: '64201',
            C: 'Holdingverksamhet i finansiella koncerner',
        },
        {
            A: '64.202',
            B: '64202',
            C: 'Holdingverksamhet i icke-finansiella koncerner',
        },
        {
            A: '64.301',
            B: '64301',
            C: 'Investeringsfonder',
        },
        {
            A: '64.309',
            B: '64309',
            C: 'Andra fonder och liknande finansiella enheter',
        },
        {
            A: '64.910',
            B: '64910',
            C: 'Finansiell leasing',
        },
        {
            A: '64.920',
            B: '64920',
            C: 'Annan kreditgivning',
        },
        {
            A: '64.991',
            B: '64991',
            C: 'Investment- och riskkapitalbolagsverksamhet',
        },
        {
            A: '64.992',
            B: '64992',
            C: 'Handel med och förvaltning av värdepapper, för egen räkning',
        },
        {
            A: '64.993',
            B: '64993',
            C: 'Förvaltning av och handel med värdepapper för en begränsad och sluten krets av ägare',
        },
        {
            A: '64.999',
            B: '64999',
            C: 'Diverse övrig finansförmedling',
        },
        {
            A: '65.111',
            B: '65111',
            C: 'Fondanknuten livförsäkring',
        },
        {
            A: '65.119',
            B: '65119',
            C: 'Övrig livförsäkring',
        },
        {
            A: '65.120',
            B: '65120',
            C: 'Skadeförsäkring',
        },
        {
            A: '65.200',
            B: '65200',
            C: 'Återförsäkring',
        },
        {
            A: '65.300',
            B: '65300',
            C: 'Pensionsfondsverksamhet',
        },
        {
            A: '66.110',
            B: '66110',
            C: 'Administrativa tjänster till finansiella marknader',
        },
        {
            A: '66.120',
            B: '66120',
            C: 'Verksamhet utförd av värdepappers- och varumäklare',
        },
        {
            A: '66.190',
            B: '66190',
            C: 'Andra stödtjänster till finansiella tjänster utom försäkring och pensionsfondsverksamhet',
        },
        {
            A: '66.210',
            B: '66210',
            C: 'Risk- och skadebedömning',
        },
        {
            A: '66.220',
            B: '66220',
            C: 'Verksamhet utförd av försäkringsombud och försäkringsmäklare',
        },
        {
            A: '66.290',
            B: '66290',
            C: 'Andra stödtjänster till försäkring och pensionsfondsverksamhet',
        },
        {
            A: '66.301',
            B: '66301',
            C: 'Förvaltning av investeringsfonder',
        },
        {
            A: '66.309',
            B: '66309',
            C: 'Annan fondförvaltning',
        },
        {
            A: '68.100',
            B: '68100',
            C: 'Handel med egna fastigheter',
        },
        {
            A: '68.201',
            B: '68201',
            C: 'Uthyrning och förvaltning av egna eller arrenderade bostäder',
        },
        {
            A: '68.202',
            B: '68202',
            C: 'Uthyrning och förvaltning av egna eller arrenderade industrilokaler',
        },
        {
            A: '68.203',
            B: '68203',
            C: 'Uthyrning och förvaltning av egna eller arrenderade, andra lokaler',
        },
        {
            A: '68.204',
            B: '68204',
            C: 'Förvaltning i bostadsrättsföreningar',
        },
        {
            A: '68.209',
            B: '68209',
            C: 'Övrig förvaltning av egna eller arrenderade fastigheter',
        },
        {
            A: '68.310',
            B: '68310',
            C: 'Fastighetsförmedling',
        },
        {
            A: '68.320',
            B: '68320',
            C: 'Fastighetsförvaltning på uppdrag',
        },
        {
            A: '69.101',
            B: '69101',
            C: 'Advokatbyråverksamhet',
        },
        {
            A: '69.102',
            B: '69102',
            C: 'Juridiska byråers verksamhet m.m.',
        },
        {
            A: '69.103',
            B: '69103',
            C: 'Patentbyråverksamhet m.m.',
        },
        {
            A: '69.201',
            B: '69201',
            C: 'Redovisning och bokföring',
        },
        {
            A: '69.202',
            B: '69202',
            C: 'Revision',
        },
        {
            A: '69.203',
            B: '69203',
            C: 'Skatterådgivning',
        },
        {
            A: '70.100',
            B: '70100',
            C: 'Verksamheter som utövas av huvudkontor',
        },
        {
            A: '70.210',
            B: '70210',
            C: 'PR och kommunikation',
        },
        {
            A: '70.220',
            B: '70220',
            C: 'Konsultverksamhet avseende företags organisation',
        },
        {
            A: '71.110',
            B: '71110',
            C: 'Arkitektverksamhet',
        },
        {
            A: '71.121',
            B: '71121',
            C: 'Teknisk konsultverksamhet inom bygg- och anläggningsteknik',
        },
        {
            A: '71.122',
            B: '71122',
            C: 'Teknisk konsultverksamhet inom industriteknik',
        },
        {
            A: '71.123',
            B: '71123',
            C: 'Teknisk konsultverksamhet inom elteknik',
        },
        {
            A: '71.124',
            B: '71124',
            C: 'Teknisk konsultverksamhet inom energi-, miljö- och VVS-teknik',
        },
        {
            A: '71.129',
            B: '71129',
            C: 'Övrig teknisk konsultverksamhet',
        },
        {
            A: '71.200',
            B: '71200',
            C: 'Teknisk provning och analys',
        },
        {
            A: '72.110',
            B: '72110',
            C: 'Bioteknisk forskning och utveckling',
        },
        {
            A: '72.190',
            B: '72190',
            C: 'Annan naturvetenskaplig och teknisk forskning och utveckling',
        },
        {
            A: '72.200',
            B: '72200',
            C: 'Samhällsvetenskaplig och humanistisk forskning och utveckling',
        },
        {
            A: '73.111',
            B: '73111',
            C: 'Reklambyråverksamhet',
        },
        {
            A: '73.112',
            B: '73112',
            C: 'Direktreklamverksamhet',
        },
        {
            A: '73.119',
            B: '73119',
            C: 'Övrig reklamverksamhet',
        },
        {
            A: '73.120',
            B: '73120',
            C: 'Mediebyråverksamhet och annonsförsäljning',
        },
        {
            A: '73.200',
            B: '73200',
            C: 'Marknads- och opinionsundersökning',
        },
        {
            A: '74.101',
            B: '74101',
            C: 'Industri- och produktdesignverksamhet',
        },
        {
            A: '74.102',
            B: '74102',
            C: 'Grafisk designverksamhet',
        },
        {
            A: '74.103',
            B: '74103',
            C: 'Inredningsarkitektverksamhet',
        },
        {
            A: '74.201',
            B: '74201',
            C: 'Porträttfotoverksamhet',
        },
        {
            A: '74.202',
            B: '74202',
            C: 'Reklamfotoverksamhet',
        },
        {
            A: '74.203',
            B: '74203',
            C: 'Press- och övrig fotografverksamhet',
        },
        {
            A: '74.204',
            B: '74204',
            C: 'Fotolaboratorieverksamhet',
        },
        {
            A: '74.300',
            B: '74300',
            C: 'Översättning och tolkning',
        },
        {
            A: '74.900',
            B: '74900',
            C: 'Övrig verksamhet inom juridik, ekonomi, vetenskap och teknik',
        },
        {
            A: '75.000',
            B: '75000',
            C: 'Veterinärverksamhet',
        },
        {
            A: '77.110',
            B: '77110',
            C: 'Uthyrning och leasing av personbilar och lätta motorfordon',
        },
        {
            A: '77.120',
            B: '77120',
            C: 'Uthyrning och leasing av lastbilar och andra tunga motorfordon',
        },
        {
            A: '77.210',
            B: '77210',
            C: 'Uthyrning och leasing av fritids- och sportutrustning',
        },
        {
            A: '77.220',
            B: '77220',
            C: 'Uthyrning av videokassetter och dvd-skivor',
        },
        {
            A: '77.290',
            B: '77290',
            C: 'Uthyrning och leasing av andra hushållsartiklar och varor för personligt bruk',
        },
        {
            A: '77.310',
            B: '77310',
            C: 'Uthyrning och leasing av jordbruksmaskiner och jordbruksredskap',
        },
        {
            A: '77.320',
            B: '77320',
            C: 'Uthyrning och leasing av bygg- och anläggningsmaskiner',
        },
        {
            A: '77.330',
            B: '77330',
            C: 'Uthyrning och leasing av kontorsmaskiner och kontorsutrustning (inklusive datorer)',
        },
        {
            A: '77.340',
            B: '77340',
            C: 'Uthyrning och leasing av fartyg och båtar',
        },
        {
            A: '77.350',
            B: '77350',
            C: 'Uthyrning och leasing av flygplan',
        },
        {
            A: '77.390',
            B: '77390',
            C: 'Uthyrning och leasing av övrig utrustning och övriga maskiner och materiella tillgångar',
        },
        {
            A: '77.400',
            B: '77400',
            C: 'Leasing av immateriell egendom och liknande produkter, med undantag för upphovsrättsskyddade verk',
        },
        {
            A: '78.100',
            B: '78100',
            C: 'Arbetsförmedling och rekrytering',
        },
        {
            A: '78.200',
            B: '78200',
            C: 'Personaluthyrning',
        },
        {
            A: '78.300',
            B: '78300',
            C: 'Övrigt tillhandahållande av personalfunktioner',
        },
        {
            A: '79.110',
            B: '79110',
            C: 'Resebyråverksamhet',
        },
        {
            A: '79.120',
            B: '79120',
            C: 'Researrangemang',
        },
        {
            A: '79.900',
            B: '79900',
            C: 'Turist- och bokningsservice',
        },
        {
            A: '80.100',
            B: '80100',
            C: 'Säkerhetsverksamhet',
        },
        {
            A: '80.200',
            B: '80200',
            C: 'Säkerhetssystemtjänster',
        },
        {
            A: '80.300',
            B: '80300',
            C: 'Spanings- och detektivverksamhet',
        },
        {
            A: '81.100',
            B: '81100',
            C: 'Fastighetsrelaterade stödtjänster',
        },
        {
            A: '81.210',
            B: '81210',
            C: 'Lokalvård',
        },
        {
            A: '81.221',
            B: '81221',
            C: 'Rengöring av byggnader',
        },
        {
            A: '81.222',
            B: '81222',
            C: 'Skorstensfejarverksamhet',
        },
        {
            A: '81.290',
            B: '81290',
            C: 'Annan rengöring',
        },
        {
            A: '81.300',
            B: '81300',
            C: 'Skötsel och underhåll av grönytor',
        },
        {
            A: '82.110',
            B: '82110',
            C: 'Kombinerade kontorstjänster',
        },
        {
            A: '82.190',
            B: '82190',
            C: 'Kopiering, dokumentsammanställning och andra specialiserade kontorstjänster',
        },
        {
            A: '82.200',
            B: '82200',
            C: 'Callcenterverksamhet',
        },
        {
            A: '82.300',
            B: '82300',
            C: 'Arrangemang av kongresser och mässor',
        },
        {
            A: '82.910',
            B: '82910',
            C: 'Inkassoföretags och kreditupplysningsföretags verksamhet',
        },
        {
            A: '82.920',
            B: '82920',
            C: 'Förpackningsverksamhet',
        },
        {
            A: '82.990',
            B: '82990',
            C: 'Övriga företagstjänster',
        },
        {
            A: '84.111',
            B: '84111',
            C: 'Stats- och kommunledning, lagstiftning och övergripande planering',
        },
        {
            A: '84.112',
            B: '84112',
            C: 'Inspektion, kontroll, tillståndsgivning',
        },
        {
            A: '84.113',
            B: '84113',
            C: 'Skatteförvaltning, indrivning',
        },
        {
            A: '84.114',
            B: '84114',
            C: 'Samhällelig informationsförsörjning',
        },
        {
            A: '84.115',
            B: '84115',
            C: 'Personalförvaltning och andra allmänna stödtjänster',
        },
        {
            A: '84.121',
            B: '84121',
            C: 'Administration av grundskole- och gymnasieskoleutbildning',
        },
        {
            A: '84.122',
            B: '84122',
            C: 'Administration av universitets- och högskoleutbildning samt forskning',
        },
        {
            A: '84.123',
            B: '84123',
            C: 'Administration av hälso- och sjukvård',
        },
        {
            A: '84.124',
            B: '84124',
            C: 'Administration av omsorg och socialtjänst',
        },
        {
            A: '84.125',
            B: '84125',
            C: 'Administration av program för kultur, miljö, boende m.m.',
        },
        {
            A: '84.131',
            B: '84131',
            C: 'Administration av infrastrukturprogram',
        },
        {
            A: '84.132',
            B: '84132',
            C: 'Administration av program för jordbruk, skogsbruk, jakt och fiske',
        },
        {
            A: '84.133',
            B: '84133',
            C: 'Administration av arbetsmarknadsprogram',
        },
        {
            A: '84.139',
            B: '84139',
            C: 'Administration av andra näringslivsprogram',
        },
        {
            A: '84.210',
            B: '84210',
            C: 'Utrikesförvaltning',
        },
        {
            A: '84.221',
            B: '84221',
            C: 'Militärt försvar',
        },
        {
            A: '84.222',
            B: '84222',
            C: 'Gemensam verksamhet för totalförsvaret',
        },
        {
            A: '84.223',
            B: '84223',
            C: 'Civilt försvar och frivilligförsvar',
        },
        {
            A: '84.231',
            B: '84231',
            C: 'Åklagarverksamhet',
        },
        {
            A: '84.232',
            B: '84232',
            C: 'Domstolsverksamhet',
        },
        {
            A: '84.233',
            B: '84233',
            C: 'Kriminalvård',
        },
        {
            A: '84.240',
            B: '84240',
            C: 'Polisverksamhet',
        },
        {
            A: '84.250',
            B: '84250',
            C: 'Brand- och räddningsverksamhet',
        },
        {
            A: '84.300',
            B: '84300',
            C: 'Obligatorisk socialförsäkring',
        },
        {
            A: '85.100',
            B: '85100',
            C: 'Förskoleutbildning',
        },
        {
            A: '85.201',
            B: '85201',
            C: 'Grundskoleutbildning och förskoleklass',
        },
        {
            A: '85.202',
            B: '85202',
            C: 'Utbildning inom grundsärskola',
        },
        {
            A: '85.311',
            B: '85311',
            C: 'Studieförberedande gymnasial utbildning',
        },
        {
            A: '85.312',
            B: '85312',
            C: 'Kommunal vuxenutbildning o.d.',
        },
        {
            A: '85.321',
            B: '85321',
            C: 'Gymnasial yrkesutbildning',
        },
        {
            A: '85.322',
            B: '85322',
            C: 'Utbildning inom gymnasiesärskola',
        },
        {
            A: '85.323',
            B: '85323',
            C: 'Annan gymnasial utbildning',
        },
        {
            A: '85.324',
            B: '85324',
            C: 'Yrkesförarutbildning m.m.',
        },
        {
            A: '85.410',
            B: '85410',
            C: 'Eftergymnasial utbildning vid annat än universitet och högskola',
        },
        {
            A: '85.420',
            B: '85420',
            C: 'Universitets- eller högskoleutbildning',
        },
        {
            A: '85.510',
            B: '85510',
            C: 'Sport- och fritidsutbildning',
        },
        {
            A: '85.521',
            B: '85521',
            C: 'Kommunala kulturskolans utbildning',
        },
        {
            A: '85.522',
            B: '85522',
            C: 'Övrig musik-, dans- och kulturell utbildning',
        },
        {
            A: '85.530',
            B: '85530',
            C: 'Trafikskoleverksamhet',
        },
        {
            A: '85.591',
            B: '85591',
            C: 'Arbetsmarknadsutbildning',
        },
        {
            A: '85.592',
            B: '85592',
            C: 'Folkhögskoleutbildning',
        },
        {
            A: '85.593',
            B: '85593',
            C: 'Studieförbundens och frivilligorganisationernas utbildning',
        },
        {
            A: '85.594',
            B: '85594',
            C: 'Personalutbildning',
        },
        {
            A: '85.599',
            B: '85599',
            C: 'Diverse övrig utbildning',
        },
        {
            A: '85.600',
            B: '85600',
            C: 'Stödverksamhet för utbildningsväsendet',
        },
        {
            A: '86.101',
            B: '86101',
            C: 'Sluten primärvård',
        },
        {
            A: '86.102',
            B: '86102',
            C: 'Specialiserad sluten somatisk hälso- och sjukvård på sjukhus',
        },
        {
            A: '86.103',
            B: '86103',
            C: 'Specialiserad sluten psykiatrisk hälso- och sjukvård på sjukhus',
        },
        {
            A: '86.211',
            B: '86211',
            C: 'Primärvårdsmottagningar med läkare m.m.',
        },
        {
            A: '86.212',
            B: '86212',
            C: 'Annan allmän öppen hälso- och sjukvård, ej primärvård',
        },
        {
            A: '86.221',
            B: '86221',
            C: 'Specialistläkarverksamhet inom öppenvård, på sjukhus',
        },
        {
            A: '86.222',
            B: '86222',
            C: 'Specialistläkarverksamhet inom öppenvård, ej på sjukhus',
        },
        {
            A: '86.230',
            B: '86230',
            C: 'Tandläkarverksamhet',
        },
        {
            A: '86.901',
            B: '86901',
            C: 'Medicinsk laboratorieverksamhet m.m.',
        },
        {
            A: '86.902',
            B: '86902',
            C: 'Ambulanstransporter och ambulanssjukvård',
        },
        {
            A: '86.903',
            B: '86903',
            C: 'Primärvård, ej läkare',
        },
        {
            A: '86.904',
            B: '86904',
            C: 'Tandhygienistverksamhet',
        },
        {
            A: '86.905',
            B: '86905',
            C: 'Fysioterapeutisk verksamhet  o.d.',
        },
        {
            A: '86.909',
            B: '86909',
            C: 'Annan öppen hälso- och sjukvård, utan läkare',
        },
        {
            A: '87.100',
            B: '87100',
            C: 'Boende med sjuksköterskevård',
        },
        {
            A: '87.201',
            B: '87201',
            C: 'Boende med särskild service för personer med utvecklingsstörning eller  psykiska funktionshinder',
        },
        {
            A: '87.202',
            B: '87202',
            C: 'Boende med särskild service för barn och ungdomar med missbruksproblem',
        },
        {
            A: '87.203',
            B: '87203',
            C: 'Boende med särskild service för vuxna med missbruksproblem',
        },
        {
            A: '87.301',
            B: '87301',
            C: 'Vård och omsorg i särskilda boendeformer för äldre personer',
        },
        {
            A: '87.302',
            B: '87302',
            C: 'Vård och omsorg i särskilda boendeformer för  personer med funktionshinder',
        },
        {
            A: '87.901',
            B: '87901',
            C: 'Heldygnsvård med boende för barn och ungdomar med sociala problem',
        },
        {
            A: '87.902',
            B: '87902',
            C: 'Omsorg och sociala insatser i övriga boendeformer för vuxna',
        },
        {
            A: '88.101',
            B: '88101',
            C: 'Öppna sociala insatser för äldre personer',
        },
        {
            A: '88.102',
            B: '88102',
            C: 'Öppna sociala insatser för personer med funktionshinder',
        },
        {
            A: '88.910',
            B: '88910',
            C: 'Dagbarnvård',
        },
        {
            A: '88.991',
            B: '88991',
            C: 'Öppna sociala insatser för barn och ungdomar med sociala problem',
        },
        {
            A: '88.992',
            B: '88992',
            C: 'Öppna sociala insatser för vuxna med missbruksproblem',
        },
        {
            A: '88.993',
            B: '88993',
            C: 'Övriga öppna sociala insatser för vuxna',
        },
        {
            A: '88.994',
            B: '88994',
            C: 'Humanitära insatser',
        },
        {
            A: '88.995',
            B: '88995',
            C: 'Drift av flyktingförläggning',
        },
        {
            A: '90.010',
            B: '90010',
            C: 'Artistisk verksamhet',
        },
        {
            A: '90.020',
            B: '90020',
            C: 'Stödtjänster till artistisk verksamhet',
        },
        {
            A: '90.030',
            B: '90030',
            C: 'Litterärt och konstnärligt skapande',
        },
        {
            A: '90.040',
            B: '90040',
            C: 'Drift av teatrar, konserthus o.d.',
        },
        {
            A: '91.011',
            B: '91011',
            C: 'Biblioteksverksamhet',
        },
        {
            A: '91.012',
            B: '91012',
            C: 'Arkivverksamhet',
        },
        {
            A: '91.020',
            B: '91020',
            C: 'Museiverksamhet',
        },
        {
            A: '91.030',
            B: '91030',
            C: 'Vård av historiska minnesmärken och byggnader och liknande sevärdheter',
        },
        {
            A: '91.040',
            B: '91040',
            C: 'Drift av botaniska trädgårdar, djurparker och naturreservat',
        },
        {
            A: '92.000',
            B: '92000',
            C: 'Spel- och vadhållningsverksamhet',
        },
        {
            A: '93.111',
            B: '93111',
            C: 'Drift av skidsportanläggningar',
        },
        {
            A: '93.112',
            B: '93112',
            C: 'Drift av golfbanor',
        },
        {
            A: '93.113',
            B: '93113',
            C: 'Drift av motorbanor',
        },
        {
            A: '93.114',
            B: '93114',
            C: 'Drift av trav- och galoppbanor',
        },
        {
            A: '93.119',
            B: '93119',
            C: 'Drift av sporthallar, idrottsplatser och andra sportanläggningar',
        },
        {
            A: '93.120',
            B: '93120',
            C: 'Sportklubbars och idrottsföreningars verksamhet',
        },
        {
            A: '93.130',
            B: '93130',
            C: 'Drift av gymanläggningar',
        },
        {
            A: '93.191',
            B: '93191',
            C: 'Tävling med hästar',
        },
        {
            A: '93.199',
            B: '93199',
            C: 'Övrig sportverksamhet',
        },
        {
            A: '93.210',
            B: '93210',
            C: 'Nöjes- och temaparksverksamhet',
        },
        {
            A: '93.290',
            B: '93290',
            C: 'Övrig fritids- och nöjesverksamhet',
        },
        {
            A: '94.111',
            B: '94111',
            C: 'Intressebevakning inom branschorganisationer',
        },
        {
            A: '94.112',
            B: '94112',
            C: 'Intressebevakning inom arbetsgivarorganisationer',
        },
        {
            A: '94.120',
            B: '94120',
            C: 'Intressebevakning inom yrkesorganisationer',
        },
        {
            A: '94.200',
            B: '94200',
            C: 'Intressebevakning inom arbetstagarorganisationer',
        },
        {
            A: '94.910',
            B: '94910',
            C: 'Verksamhet i religiösa samfund',
        },
        {
            A: '94.920',
            B: '94920',
            C: 'Verksamhet i politiska organisationer',
        },
        {
            A: '94.990',
            B: '94990',
            C: 'Verksamhet i andra intresseorganisationer',
        },
        {
            A: '95.110',
            B: '95110',
            C: 'Reparation av datorer och kringutrustning',
        },
        {
            A: '95.120',
            B: '95120',
            C: 'Reparation av kommunikationsutrustning',
        },
        {
            A: '95.210',
            B: '95210',
            C: 'Reparation av hemelektronik',
        },
        {
            A: '95.220',
            B: '95220',
            C: 'Reparation av hushållsapparater samt av utrustning för hem och trädgård',
        },
        {
            A: '95.230',
            B: '95230',
            C: 'Lagning av skodon och lädervaror',
        },
        {
            A: '95.240',
            B: '95240',
            C: 'Reparation av möbler och heminredning',
        },
        {
            A: '95.250',
            B: '95250',
            C: 'Reparation av ur och guldsmedsvaror',
        },
        {
            A: '95.290',
            B: '95290',
            C: 'Reparation av andra hushållsartiklar och personliga artiklar',
        },
        {
            A: '96.011',
            B: '96011',
            C: 'Industri- och institutionstvätt',
        },
        {
            A: '96.012',
            B: '96012',
            C: 'Konsumenttvätt',
        },
        {
            A: '96.021',
            B: '96021',
            C: 'Hårvård',
        },
        {
            A: '96.022',
            B: '96022',
            C: 'Skönhetsvård',
        },
        {
            A: '96.030',
            B: '96030',
            C: 'Begravningsverksamhet',
        },
        {
            A: '96.040',
            B: '96040',
            C: 'Kroppsvård',
        },
        {
            A: '96.090',
            B: '96090',
            C: 'Övriga konsumenttjänster',
        },
        {
            A: '97.000',
            B: '97000',
            C: 'Förvärvsarbete i hushåll',
        },
        {
            A: '98.100',
            B: '98100',
            C: 'Hushållens produktion av diverse varor för eget bruk',
        },
        {
            A: '98.200',
            B: '98200',
            C: 'Hushållens produktion av diverse tjänster för eget bruk',
        },
        {
            A: '99.000',
            B: '99000',
            C: 'Verksamhet vid internationella organisationer, utländska ambassader o.d.',
        },
    ],
    'Undergrupp (Fyrsiffer)': [
        {
            A: 'SNI 2007',
        },
        {
            A: 'Undergrupp (Officiell kodstruktur)',
            B: 'Undergrupp',
            C: 'Benämning',
        },
        {
            A: '01.11',
            B: '0111',
            C: 'Odling av spannmål (utom ris), baljväxter och oljeväxter',
        },
        {
            A: '01.12',
            B: '0112',
            C: 'Odling av ris',
        },
        {
            A: '01.13',
            B: '0113',
            C: 'Odling av grönsaker och meloner, rotfrukter och stam- eller rotknölar',
        },
        {
            A: '01.14',
            B: '0114',
            C: 'Odling av sockerrör',
        },
        {
            A: '01.15',
            B: '0115',
            C: 'Odling av tobak',
        },
        {
            A: '01.16',
            B: '0116',
            C: 'Odling av fiberväxter',
        },
        {
            A: '01.19',
            B: '0119',
            C: 'Odling av andra ett- och tvååriga växter',
        },
        {
            A: '01.21',
            B: '0121',
            C: 'Odling av druvor',
        },
        {
            A: '01.22',
            B: '0122',
            C: 'Odling av tropiska och subtropiska frukter',
        },
        {
            A: '01.23',
            B: '0123',
            C: 'Odling av citrusfrukter',
        },
        {
            A: '01.24',
            B: '0124',
            C: 'Odling av kärnfrukter och stenfrukter',
        },
        {
            A: '01.25',
            B: '0125',
            C: 'Odling av andra frukter och bär samt nötter',
        },
        {
            A: '01.26',
            B: '0126',
            C: 'Odling av oljehaltiga frukter',
        },
        {
            A: '01.27',
            B: '0127',
            C: 'Odling av växter för dryckesframställning',
        },
        {
            A: '01.28',
            B: '0128',
            C: 'Odling av kryddväxter, drog- och medicinalväxter',
        },
        {
            A: '01.29',
            B: '0129',
            C: 'Odling av andra fleråriga växter',
        },
        {
            A: '01.30',
            B: '0130',
            C: 'Odling av plantskoleväxter',
        },
        {
            A: '01.41',
            B: '0141',
            C: 'Mjölkproduktion och uppfödning av nötkreatur av mjölkras',
        },
        {
            A: '01.42',
            B: '0142',
            C: 'Uppfödning av andra nötkreatur och bufflar',
        },
        {
            A: '01.43',
            B: '0143',
            C: 'Uppfödning av hästar och andra hästdjur',
        },
        {
            A: '01.44',
            B: '0144',
            C: 'Uppfödning av kameler och kameldjur',
        },
        {
            A: '01.45',
            B: '0145',
            C: 'Uppfödning av får och getter',
        },
        {
            A: '01.46',
            B: '0146',
            C: 'Uppfödning av svin',
        },
        {
            A: '01.47',
            B: '0147',
            C: 'Äggproduktion och uppfödning av fjäderfä',
        },
        {
            A: '01.49',
            B: '0149',
            C: 'Uppfödning av andra djur',
        },
        {
            A: '01.50',
            B: '0150',
            C: 'Blandat jordbruk',
        },
        {
            A: '01.61',
            B: '0161',
            C: 'Service till växtodling',
        },
        {
            A: '01.62',
            B: '0162',
            C: 'Service till husdjursskötsel',
        },
        {
            A: '01.63',
            B: '0163',
            C: 'Bearbetning av skördade växter',
        },
        {
            A: '01.64',
            B: '0164',
            C: 'Bearbetning av utsäde',
        },
        {
            A: '01.70',
            B: '0170',
            C: 'Jakt och service i anslutning härtill',
        },
        {
            A: '02.10',
            B: '0210',
            C: 'Skogsförvaltning och skogsskötsel',
        },
        {
            A: '02.20',
            B: '0220',
            C: 'Drivning',
        },
        {
            A: '02.30',
            B: '0230',
            C: 'Insamling av annat vilt växande skogsmaterial än trä',
        },
        {
            A: '02.40',
            B: '0240',
            C: 'Service till skogsbruk',
        },
        {
            A: '03.11',
            B: '0311',
            C: 'Saltvattensfiske',
        },
        {
            A: '03.12',
            B: '0312',
            C: 'Sötvattensfiske',
        },
        {
            A: '03.21',
            B: '0321',
            C: 'Fiskodling i salvatten',
        },
        {
            A: '03.22',
            B: '0322',
            C: 'Fiskodling i sötvatten',
        },
        {
            A: '05.10',
            B: '0510',
            C: 'Stenkolsutvinning',
        },
        {
            A: '05.20',
            B: '0520',
            C: 'Brunkolsutvinning',
        },
        {
            A: '06.10',
            B: '0610',
            C: 'Utvinning av råpetroleum',
        },
        {
            A: '06.20',
            B: '0620',
            C: 'Utvinning av naturgas',
        },
        {
            A: '07.10',
            B: '0710',
            C: 'Järnmalmsutvinning',
        },
        {
            A: '07.21',
            B: '0721',
            C: 'Utvinning av uran- och toriummalm',
        },
        {
            A: '07.29',
            B: '0729',
            C: 'Utvinning av annan malm',
        },
        {
            A: '08.11',
            B: '0811',
            C: 'Brytning av natursten, kalk- och gipssten, krita och skiffer',
        },
        {
            A: '08.12',
            B: '0812',
            C: 'Utvinning av sand, grus och berg; utvinning av lera och kaolin',
        },
        {
            A: '08.91',
            B: '0891',
            C: 'Brytning av kemiska mineral',
        },
        {
            A: '08.92',
            B: '0892',
            C: 'Torvutvinning',
        },
        {
            A: '08.93',
            B: '0893',
            C: 'Saltutvinning',
        },
        {
            A: '08.99',
            B: '0899',
            C: 'Diverse övrig utvinning av mineral',
        },
        {
            A: '09.10',
            B: '0910',
            C: 'Stödtjänster till råpetroleum- och naturgasutvinning',
        },
        {
            A: '09.90',
            B: '0990',
            C: 'Stödtjänster till annan utvinning',
        },
        {
            A: '10.11',
            B: '1011',
            C: 'Beredning och hållbarhetsbehandling av kreaturskött',
        },
        {
            A: '10.12',
            B: '1012',
            C: 'Beredning och hållbarhetsbehandling av fjäderfäkött',
        },
        {
            A: '10.13',
            B: '1013',
            C: 'Charkuteri- och annan köttvarutillverkning',
        },
        {
            A: '10.20',
            B: '1020',
            C: 'Beredning och hållbarhetsbehandling av fisk samt skal- och blötdjur',
        },
        {
            A: '10.31',
            B: '1031',
            C: 'Beredning och hållbarhetsbehandling av potatis',
        },
        {
            A: '10.32',
            B: '1032',
            C: 'Juice- och safttillverkning',
        },
        {
            A: '10.39',
            B: '1039',
            C: 'Annan beredning och hållbarhetsbehandling av frukt, bär och grönsaker',
        },
        {
            A: '10.41',
            B: '1041',
            C: 'Framställning av oljor och fetter',
        },
        {
            A: '10.42',
            B: '1042',
            C: 'Matfettstillverkning',
        },
        {
            A: '10.51',
            B: '1051',
            C: 'Mejerivarutillverkning',
        },
        {
            A: '10.52',
            B: '1052',
            C: 'Glasstillverkning',
        },
        {
            A: '10.61',
            B: '1061',
            C: 'Tillverkning av kvarnprodukter',
        },
        {
            A: '10.62',
            B: '1062',
            C: 'Stärkelsetillverkning',
        },
        {
            A: '10.71',
            B: '1071',
            C: 'Tillverkning av mjukt matbröd och färska bakverk',
        },
        {
            A: '10.72',
            B: '1072',
            C: 'Tillverkning av knäckebröd, kex och konserverade bakverk',
        },
        {
            A: '10.73',
            B: '1073',
            C: 'Tillverkning av pastaprodukter',
        },
        {
            A: '10.81',
            B: '1081',
            C: 'Sockertillverkning',
        },
        {
            A: '10.82',
            B: '1082',
            C: 'Tillverkning av choklad, choklad- och sockerkonfektyrer',
        },
        {
            A: '10.83',
            B: '1083',
            C: 'Framställning av te och kaffe',
        },
        {
            A: '10.84',
            B: '1084',
            C: 'Tillverkning av senap, ketchup, kryddor och andra smaksättningsmedel',
        },
        {
            A: '10.85',
            B: '1085',
            C: 'Tillverkning av lagad mat och färdigrätter',
        },
        {
            A: '10.86',
            B: '1086',
            C: 'Tillverkning av homogeniserade livsmedelspreparat inklusive dietmat',
        },
        {
            A: '10.89',
            B: '1089',
            C: 'Framställning av andra livsmedel',
        },
        {
            A: '10.91',
            B: '1091',
            C: 'Framställning av beredda fodermedel',
        },
        {
            A: '10.92',
            B: '1092',
            C: 'Framställning av mat till sällskapsdjur',
        },
        {
            A: '11.01',
            B: '1101',
            C: 'Destillering, rening och tillblandning av spritdrycker',
        },
        {
            A: '11.02',
            B: '1102',
            C: 'Framställning av vin från druvor',
        },
        {
            A: '11.03',
            B: '1103',
            C: 'Framställning av cider och andra fruktviner',
        },
        {
            A: '11.04',
            B: '1104',
            C: 'Framställning av andra icke-destillerade jästa drycker',
        },
        {
            A: '11.05',
            B: '1105',
            C: 'Framställning av öl',
        },
        {
            A: '11.06',
            B: '1106',
            C: 'Framställning av malt',
        },
        {
            A: '11.07',
            B: '1107',
            C: 'Framställning av läskedrycker, mineralvatten och annat vatten på flaska',
        },
        {
            A: '12.00',
            B: '1200',
            C: 'Tobaksvarutillverkning',
        },
        {
            A: '13.10',
            B: '1310',
            C: 'Garntillverkning',
        },
        {
            A: '13.20',
            B: '1320',
            C: 'Vävnadstillverkning',
        },
        {
            A: '13.30',
            B: '1330',
            C: 'Blekning, färgning och annan textilberedning',
        },
        {
            A: '13.91',
            B: '1391',
            C: 'Tillverkning av trikåväv',
        },
        {
            A: '13.92',
            B: '1392',
            C: 'Tillverkning av sydda textilvaror utom beklädnadsvaror',
        },
        {
            A: '13.93',
            B: '1393',
            C: 'Tillverkning av mattor',
        },
        {
            A: '13.94',
            B: '1394',
            C: 'Tågvirkes- och bindgarnstillverkning',
        },
        {
            A: '13.95',
            B: '1395',
            C: 'Tillverkning av bondad duk',
        },
        {
            A: '13.96',
            B: '1396',
            C: 'Tillverkning av andra tekniska textilier och industritextilier',
        },
        {
            A: '13.99',
            B: '1399',
            C: 'Övrig textilietillverkning',
        },
        {
            A: '14.11',
            B: '1411',
            C: 'Tillverkning av läder- och skinnkläder',
        },
        {
            A: '14.12',
            B: '1412',
            C: 'Tillverkning av arbets-, skydds- och överdragskläder',
        },
        {
            A: '14.13',
            B: '1413',
            C: 'Tillverkning av andra gång- och ytterkläder',
        },
        {
            A: '14.14',
            B: '1414',
            C: 'Tillverkning av underkläder, skjortor och blusar',
        },
        {
            A: '14.19',
            B: '1419',
            C: 'Tillverkning av andra beklädnadsvaror och tillbehör',
        },
        {
            A: '14.20',
            B: '1420',
            C: 'Tillverkning av pälsvaror',
        },
        {
            A: '14.31',
            B: '1431',
            C: 'Tillverkning av strumpor',
        },
        {
            A: '14.39',
            B: '1439',
            C: 'Tillverkning av andra trikåvaror',
        },
        {
            A: '15.11',
            B: '1511',
            C: 'Garvning och annan läderberedning; pälsberedning',
        },
        {
            A: '15.12',
            B: '1512',
            C: 'Tillverkning av reseffekter, handväskor, sadel- och seldon m. m.',
        },
        {
            A: '15.20',
            B: '1520',
            C: 'Tillverkning av skodon',
        },
        {
            A: '16.10',
            B: '1610',
            C: 'Sågning och hyvling av trä',
        },
        {
            A: '16.21',
            B: '1621',
            C: 'Tillverkning av fanér och träbaserade skivor',
        },
        {
            A: '16.22',
            B: '1622',
            C: 'Tillverkning av sammansatta parkettgolv',
        },
        {
            A: '16.23',
            B: '1623',
            C: 'Tillverkning av andra byggnads- och inredningssnickerier',
        },
        {
            A: '16.24',
            B: '1624',
            C: 'Träförpackningstillverkning',
        },
        {
            A: '16.29',
            B: '1629',
            C: 'Övrig trävarutillverkning; tillverkning av varor av kork, halm, rotting o.d.',
        },
        {
            A: '17.11',
            B: '1711',
            C: 'Massatillverkning',
        },
        {
            A: '17.12',
            B: '1712',
            C: 'Pappers- och papptillverkning',
        },
        {
            A: '17.21',
            B: '1721',
            C: 'Tillverkning av wellpapp och pappers- och pappförpackningar',
        },
        {
            A: '17.22',
            B: '1722',
            C: 'Tillverkning av hushålls- och hygienartiklar av papper',
        },
        {
            A: '17.23',
            B: '1723',
            C: 'Tillverkning av skrivpapper, kuvert o.d.',
        },
        {
            A: '17.24',
            B: '1724',
            C: 'Tapettillverkning',
        },
        {
            A: '17.29',
            B: '1729',
            C: 'Tillverkning av andra pappers- och pappvaror',
        },
        {
            A: '18.11',
            B: '1811',
            C: 'Tryckning av dagstidningar',
        },
        {
            A: '18.12',
            B: '1812',
            C: 'Annan tryckning',
        },
        {
            A: '18.13',
            B: '1813',
            C: 'Grafiska tjänster före tryckning (prepress/premedia)',
        },
        {
            A: '18.14',
            B: '1814',
            C: 'Bokbindning och andra tjänster i samband med tryckning',
        },
        {
            A: '18.20',
            B: '1820',
            C: 'Reproduktion av inspelningar',
        },
        {
            A: '19.10',
            B: '1910',
            C: 'Tillverkning av stenkolsprodukter',
        },
        {
            A: '19.20',
            B: '1920',
            C: 'Petroleumraffinering',
        },
        {
            A: '20.11',
            B: '2011',
            C: 'Industrigasframställning',
        },
        {
            A: '20.12',
            B: '2012',
            C: 'Tillverkning av färgämnen',
        },
        {
            A: '20.13',
            B: '2013',
            C: 'Tillverkning av andra oorganiska baskemikalier',
        },
        {
            A: '20.14',
            B: '2014',
            C: 'Tillverkning av andra organiska baskemikalier',
        },
        {
            A: '20.15',
            B: '2015',
            C: 'Tillverkning av gödselmedel och kväveprodukter',
        },
        {
            A: '20.16',
            B: '2016',
            C: 'Basplastframställning',
        },
        {
            A: '20.17',
            B: '2017',
            C: 'Tillverkning av syntetiskt basgummi',
        },
        {
            A: '20.20',
            B: '2020',
            C: 'Tillverkning av bekämpningsmedel och andra lantbrukskemiska produkter',
        },
        {
            A: '20.30',
            B: '2030',
            C: 'Tillverkning av färg, lack, tryckfärg m.m.',
        },
        {
            A: '20.41',
            B: '2041',
            C: 'Tillverkning av tvål, såpa, tvättmedel och polermedel',
        },
        {
            A: '20.42',
            B: '2042',
            C: 'Tillverkning av parfymer och toalettartiklar',
        },
        {
            A: '20.51',
            B: '2051',
            C: 'Sprängämnestillverkning',
        },
        {
            A: '20.52',
            B: '2052',
            C: 'Tillverkning av lim',
        },
        {
            A: '20.53',
            B: '2053',
            C: 'Tillverkning av eteriska oljor',
        },
        {
            A: '20.59',
            B: '2059',
            C: 'Tillverkning av övriga kemiska produkter',
        },
        {
            A: '20.60',
            B: '2060',
            C: 'Konstfibertillverkning',
        },
        {
            A: '21.10',
            B: '2110',
            C: 'Tillverkning av farmaceutiska basprodukter',
        },
        {
            A: '21.20',
            B: '2120',
            C: 'Tillverkning av läkemedel',
        },
        {
            A: '22.11',
            B: '2211',
            C: 'Tillverkning av däck och slangar; regummering',
        },
        {
            A: '22.19',
            B: '2219',
            C: 'Annan gummivarutillverkning',
        },
        {
            A: '22.21',
            B: '2221',
            C: 'Tillverkning av plasthalvfabrikat',
        },
        {
            A: '22.22',
            B: '2222',
            C: 'Plastförpackningstillverkning',
        },
        {
            A: '22.23',
            B: '2223',
            C: 'Byggplastvarutillverkning',
        },
        {
            A: '22.29',
            B: '2229',
            C: 'Annan plastvarutillverkning',
        },
        {
            A: '23.11',
            B: '2311',
            C: 'Framställning av planglas',
        },
        {
            A: '23.12',
            B: '2312',
            C: 'Bearbetning av planglas',
        },
        {
            A: '23.13',
            B: '2313',
            C: 'Tillverkning av buteljer, glasförpackningar och husgeråd av glas',
        },
        {
            A: '23.14',
            B: '2314',
            C: 'Tillverkning av glasfiber',
        },
        {
            A: '23.19',
            B: '2319',
            C: 'Tillverkning av andra glasvaror inklusive tekniska glasvaror',
        },
        {
            A: '23.20',
            B: '2320',
            C: 'Tillverkning av eldfasta produkter',
        },
        {
            A: '23.31',
            B: '2331',
            C: 'Tillverkning av keramiska golv- och väggplattor',
        },
        {
            A: '23.32',
            B: '2332',
            C: 'Tillverkning av murtegel, takpannor och andra byggvaror av tegel',
        },
        {
            A: '23.41',
            B: '2341',
            C: 'Tillverkning av keramiska hushålls- och prydnadsartiklar',
        },
        {
            A: '23.42',
            B: '2342',
            C: 'Tillverkning av keramiska sanitetsartiklar',
        },
        {
            A: '23.43',
            B: '2343',
            C: 'Tillverkning av keramiska isolatorer o.d.',
        },
        {
            A: '23.44',
            B: '2344',
            C: 'Tillverkning av andra tekniska keramiska produkter',
        },
        {
            A: '23.49',
            B: '2349',
            C: 'Tillverkning av andra keramiska produkter',
        },
        {
            A: '23.51',
            B: '2351',
            C: 'Tillverkning av cement',
        },
        {
            A: '23.52',
            B: '2352',
            C: 'Tillverkning av kalk och gips',
        },
        {
            A: '23.61',
            B: '2361',
            C: 'Tillverkning av betongvaror  för byggändamål',
        },
        {
            A: '23.62',
            B: '2362',
            C: 'Tillverkning av gipsvaror  för byggändamål',
        },
        {
            A: '23.63',
            B: '2363',
            C: 'Tillverkning av fabriksblandad betong',
        },
        {
            A: '23.64',
            B: '2364',
            C: 'Tillverkning av murbruk',
        },
        {
            A: '23.65',
            B: '2365',
            C: 'Tillverkning av fibercementvaror',
        },
        {
            A: '23.69',
            B: '2369',
            C: 'Tillverkning av andra varor av betong, cement och gips',
        },
        {
            A: '23.70',
            B: '2370',
            C: 'Huggning, formning och slutlig bearbetning av sten',
        },
        {
            A: '23.91',
            B: '2391',
            C: 'Slipmedelstillverkning',
        },
        {
            A: '23.99',
            B: '2399',
            C: 'Tillverkning av övriga icke-metalliska mineraliska produkter',
        },
        {
            A: '24.10',
            B: '2410',
            C: 'Framställning av järn och stål samt ferrolegeringar',
        },
        {
            A: '24.20',
            B: '2420',
            C: 'Tillverkning av rör, ledningar, ihåliga profiler och tillbehör av stål',
        },
        {
            A: '24.31',
            B: '2431',
            C: 'Tillverkning av kalldragen stålstång',
        },
        {
            A: '24.32',
            B: '2432',
            C: 'Tillverkning av kallvalsade stålband',
        },
        {
            A: '24.33',
            B: '2433',
            C: 'Tillverkning av andra kallformade produkter av stål',
        },
        {
            A: '24.34',
            B: '2434',
            C: 'Tillverkning av kalldragen ståltråd',
        },
        {
            A: '24.41',
            B: '2441',
            C: 'Framställning av ädla metaller',
        },
        {
            A: '24.42',
            B: '2442',
            C: 'Framställning av aluminium',
        },
        {
            A: '24.43',
            B: '2443',
            C: 'Framställning av bly, zink och tenn',
        },
        {
            A: '24.44',
            B: '2444',
            C: 'Framställning av koppar',
        },
        {
            A: '24.45',
            B: '2445',
            C: 'Framställning av andra metaller',
        },
        {
            A: '24.46',
            B: '2446',
            C: 'Tillverkning av kärnbränsle',
        },
        {
            A: '24.51',
            B: '2451',
            C: 'Gjutning av järn',
        },
        {
            A: '24.52',
            B: '2452',
            C: 'Gjutning av stål',
        },
        {
            A: '24.53',
            B: '2453',
            C: 'Gjutning av lättmetall',
        },
        {
            A: '24.54',
            B: '2454',
            C: 'Gjutning av andra metaller',
        },
        {
            A: '25.11',
            B: '2511',
            C: 'Tillverkning av metallstommar och delar därav',
        },
        {
            A: '25.12',
            B: '2512',
            C: 'Tillverkning av dörrar och fönster av metall',
        },
        {
            A: '25.21',
            B: '2521',
            C: 'Tillverkning av radiatorer och pannor för centraluppvärmning',
        },
        {
            A: '25.29',
            B: '2529',
            C: 'Tillverkning av andra cisterner, tankar, kar och andra behållare av metall',
        },
        {
            A: '25.30',
            B: '2530',
            C: 'Tillverkning av ånggeneratorer utom varmvattenpannor för centraluppvärmning',
        },
        {
            A: '25.40',
            B: '2540',
            C: 'Tillverkning av vapen och ammunition',
        },
        {
            A: '25.50',
            B: '2550',
            C: 'Smidning, pressning, prägling och valsning av metall; pulvermetallurgi',
        },
        {
            A: '25.61',
            B: '2561',
            C: 'Beläggning och överdragning av metall',
        },
        {
            A: '25.62',
            B: '2562',
            C: 'Metallegoarbeten',
        },
        {
            A: '25.71',
            B: '2571',
            C: 'Tillverkning av bestick',
        },
        {
            A: '25.72',
            B: '2572',
            C: 'Tillverkning av lås och gångjärn',
        },
        {
            A: '25.73',
            B: '2573',
            C: 'Tillverkning av verktyg och redskap',
        },
        {
            A: '25.91',
            B: '2591',
            C: 'Tillverkning av stålfat o.d. behållare',
        },
        {
            A: '25.92',
            B: '2592',
            C: 'Tillverkning av lättmetallförpackningar',
        },
        {
            A: '25.93',
            B: '2593',
            C: 'Tillverkning av metalltrådvaror, kedjor och fjädrar',
        },
        {
            A: '25.94',
            B: '2594',
            C: 'Tillverkning av nitar och skruvar',
        },
        {
            A: '25.99',
            B: '2599',
            C: 'Övrig metallvarutillverkning',
        },
        {
            A: '26.11',
            B: '2611',
            C: 'Tillverkning av elektroniska komponenter',
        },
        {
            A: '26.12',
            B: '2612',
            C: 'Tillverkning av kretskort',
        },
        {
            A: '26.20',
            B: '2620',
            C: 'Tillverkning av datorer och kringutrustning',
        },
        {
            A: '26.30',
            B: '2630',
            C: 'Tillverkning av kommunikationsutrustning',
        },
        {
            A: '26.40',
            B: '2640',
            C: 'Tillverkning av hemelektronik',
        },
        {
            A: '26.51',
            B: '2651',
            C: 'Tillverkning av instrument och apparater för mätning, provning och navigering',
        },
        {
            A: '26.52',
            B: '2652',
            C: 'Urtillverkning',
        },
        {
            A: '26.60',
            B: '2660',
            C: 'Tillverkning av strålningsutrustning samt elektromedicinsk och elektroterapeutisk utrustning',
        },
        {
            A: '26.70',
            B: '2670',
            C: 'Tillverkning av optiska instrument och fotoutrustning',
        },
        {
            A: '26.80',
            B: '2680',
            C: 'Tillverkning av magnetiska och optiska medier',
        },
        {
            A: '27.11',
            B: '2711',
            C: 'Tillverkning av elmotorer, generatorer och transformatorer',
        },
        {
            A: '27.12',
            B: '2712',
            C: 'Tillverkning av eldistributions- och elkontrollapparater',
        },
        {
            A: '27.20',
            B: '2720',
            C: 'Batteri- och ackumulatortillverkning',
        },
        {
            A: '27.31',
            B: '2731',
            C: 'Tillverkning av optiska fiberkablar',
        },
        {
            A: '27.32',
            B: '2732',
            C: 'Tillverkning av andra elektroniska och elektriska ledningar och kablar',
        },
        {
            A: '27.33',
            B: '2733',
            C: 'Tillverkning av kabeltillbehör',
        },
        {
            A: '27.40',
            B: '2740',
            C: 'Tillverkning av belysningsarmatur',
        },
        {
            A: '27.51',
            B: '2751',
            C: 'Tillverkning av elektriska hushållsmaskiner och hushållsapparater',
        },
        {
            A: '27.52',
            B: '2752',
            C: 'Tillverkning av icke-elektriska hushållsmaskiner och hushållsapparater',
        },
        {
            A: '27.90',
            B: '2790',
            C: 'Tillverkning av annan elapparatur',
        },
        {
            A: '28.11',
            B: '2811',
            C: 'Tillverkning av motorer och turbiner utom för luftfartyg och fordon',
        },
        {
            A: '28.12',
            B: '2812',
            C: 'Tillverkning av fluidteknisk utrustning',
        },
        {
            A: '28.13',
            B: '2813',
            C: 'Tillverkning av andra pumpar och kompressorer',
        },
        {
            A: '28.14',
            B: '2814',
            C: 'Tillverkning av andra kranar och ventiler',
        },
        {
            A: '28.15',
            B: '2815',
            C: 'Tillverkning av lager, kugghjul och andra delar för kraftöverföring',
        },
        {
            A: '28.21',
            B: '2821',
            C: 'Tillverkning av ugnar och brännare',
        },
        {
            A: '28.22',
            B: '2822',
            C: 'Tillverkning av lyft- och godshanteringsanordningar',
        },
        {
            A: '28.23',
            B: '2823',
            C: 'Tillverkning av kontorsmaskiner och kontorsutrustning (utom datorer och kringutrustning)',
        },
        {
            A: '28.24',
            B: '2824',
            C: 'Tillverkning av motordrivna handverktyg',
        },
        {
            A: '28.25',
            B: '2825',
            C: 'Tillverkning av maskiner och apparater för kyla och ventilation utom för hushåll',
        },
        {
            A: '28.29',
            B: '2829',
            C: 'Övrig tillverkning av maskiner för allmänt ändamål',
        },
        {
            A: '28.30',
            B: '2830',
            C: 'Tillverkning av jord- och skogsbruksmaskiner',
        },
        {
            A: '28.41',
            B: '2841',
            C: 'Tillverkning av verktygsmaskiner för metallbearbetning',
        },
        {
            A: '28.49',
            B: '2849',
            C: 'Tillverkning av övriga verktygsmaskiner',
        },
        {
            A: '28.91',
            B: '2891',
            C: 'Tillverkning av maskiner för metallurgi',
        },
        {
            A: '28.92',
            B: '2892',
            C: 'Tillverkning av gruv-, bergbrytnings- och byggmaskiner',
        },
        {
            A: '28.93',
            B: '2893',
            C: 'Tillverkning av maskiner för framställning av livsmedel, drycker och tobaksvaror',
        },
        {
            A: '28.94',
            B: '2894',
            C: 'Tillverkning av maskiner för produktion av textil-, beklädnads- och lädervaror',
        },
        {
            A: '28.95',
            B: '2895',
            C: 'Tillverkning av maskiner för produktion av massa, papper och papp',
        },
        {
            A: '28.96',
            B: '2896',
            C: 'Tillverkning av maskiner för gummi och plast',
        },
        {
            A: '28.99',
            B: '2899',
            C: 'Tillverkning av övriga specialmaskiner',
        },
        {
            A: '29.10',
            B: '2910',
            C: 'Motorfordonstillverkning',
        },
        {
            A: '29.20',
            B: '2920',
            C: 'Tillverkning av karosserier för motorfordon; tillverkning av släpfordon och påhängsvagnar',
        },
        {
            A: '29.31',
            B: '2931',
            C: 'Tillverkning av elektrisk och elektronisk utrustning för motorfordon',
        },
        {
            A: '29.32',
            B: '2932',
            C: 'Tillverkning av andra delar och tillbehör till motorfordon',
        },
        {
            A: '30.11',
            B: '3011',
            C: 'Byggande av fartyg och flytande materiel',
        },
        {
            A: '30.12',
            B: '3012',
            C: 'Byggande av fritidsbåtar',
        },
        {
            A: '30.20',
            B: '3020',
            C: 'Tillverkning av rälsfordon',
        },
        {
            A: '30.30',
            B: '3030',
            C: 'Tillverkning av luftfartyg, rymdfarkoster o.d.',
        },
        {
            A: '30.40',
            B: '3040',
            C: 'Tillverkning av militära stridsfordon',
        },
        {
            A: '30.91',
            B: '3091',
            C: 'Tillverkning av motorcyklar',
        },
        {
            A: '30.92',
            B: '3092',
            C: 'Tillverkning av cyklar och invalidfordon',
        },
        {
            A: '30.99',
            B: '3099',
            C: 'Diverse övrig transportmedelstillverkning',
        },
        {
            A: '31.01',
            B: '3101',
            C: 'Tillverkning av kontors- och butiksmöbler samt kontors- och butiksinredningar',
        },
        {
            A: '31.02',
            B: '3102',
            C: 'Tillverkning av köksmöbler och köksinredningar',
        },
        {
            A: '31.03',
            B: '3103',
            C: 'Tillverkning av madrasser',
        },
        {
            A: '31.09',
            B: '3109',
            C: 'Tillverkning av andra möbler',
        },
        {
            A: '32.11',
            B: '3211',
            C: 'Prägling av mynt',
        },
        {
            A: '32.12',
            B: '3212',
            C: 'Tillverkning av smycken, guld- och silversmedsvaror',
        },
        {
            A: '32.13',
            B: '3213',
            C: 'Tillverkning av bijouterier o.d.',
        },
        {
            A: '32.20',
            B: '3220',
            C: 'Tillverkning av musikinstrument',
        },
        {
            A: '32.30',
            B: '3230',
            C: 'Tillverkning av sportartiklar',
        },
        {
            A: '32.40',
            B: '3240',
            C: 'Tillverkning av spel och leksaker',
        },
        {
            A: '32.50',
            B: '3250',
            C: 'Tillverkning av medicinsk och dental utrustning',
        },
        {
            A: '32.91',
            B: '3291',
            C: 'Tillverkning av borstbinderiarbeten',
        },
        {
            A: '32.99',
            B: '3299',
            C: 'Diverse övrig tillverkning',
        },
        {
            A: '33.11',
            B: '3311',
            C: 'Reparation av metallvaror',
        },
        {
            A: '33.12',
            B: '3312',
            C: 'Reparation av maskiner',
        },
        {
            A: '33.13',
            B: '3313',
            C: 'Reparation av elektronisk och optisk utrustning',
        },
        {
            A: '33.14',
            B: '3314',
            C: 'Reparation av elapparatur',
        },
        {
            A: '33.15',
            B: '3315',
            C: 'Reparation och underhåll av fartyg och båtar',
        },
        {
            A: '33.16',
            B: '3316',
            C: 'Reparation och underhåll av luftfartyg och rymdfarkoster',
        },
        {
            A: '33.17',
            B: '3317',
            C: 'Reparation och underhåll av andra transportmedel',
        },
        {
            A: '33.19',
            B: '3319',
            C: 'Reparation av annan utrustning',
        },
        {
            A: '33.20',
            B: '3320',
            C: 'Installation av industrimaskiner och -utrustning',
        },
        {
            A: '35.11',
            B: '3511',
            C: 'Generering av elektricitet',
        },
        {
            A: '35.12',
            B: '3512',
            C: 'Överföring av elektricitet',
        },
        {
            A: '35.13',
            B: '3513',
            C: 'Distribution av elektricitet',
        },
        {
            A: '35.14',
            B: '3514',
            C: 'Handel med elektricitet',
        },
        {
            A: '35.21',
            B: '3521',
            C: 'Framställning av gas',
        },
        {
            A: '35.22',
            B: '3522',
            C: 'Distribution av gasformiga bränslen via rörnät',
        },
        {
            A: '35.23',
            B: '3523',
            C: 'Handel med gas via rörnät',
        },
        {
            A: '35.30',
            B: '3530',
            C: 'Försörjning av värme och kyla',
        },
        {
            A: '36.00',
            B: '3600',
            C: 'Vattenförsörjning',
        },
        {
            A: '37.00',
            B: '3700',
            C: 'Avloppsrening',
        },
        {
            A: '38.11',
            B: '3811',
            C: 'Insamling av icke-farligt avfall',
        },
        {
            A: '38.12',
            B: '3812',
            C: 'Insamling av farligt avfall',
        },
        {
            A: '38.21',
            B: '3821',
            C: 'Behandling och bortskaffande av icke-farligt avfall',
        },
        {
            A: '38.22',
            B: '3822',
            C: 'Behandling och bortskaffande av farligt avfall',
        },
        {
            A: '38.31',
            B: '3831',
            C: 'Demontering av uttjänta fordon och maskiner',
        },
        {
            A: '38.32',
            B: '3832',
            C: 'Återvinning av källsorterat material',
        },
        {
            A: '39.00',
            B: '3900',
            C: 'Sanering, efterbehandling av jord och vatten samt annan verksamhet för föroreningsbekämpning',
        },
        {
            A: '41.10',
            B: '4110',
            C: 'Utformning av byggprojekt',
        },
        {
            A: '41.20',
            B: '4120',
            C: 'Byggande av bostadshus och andra byggnader',
        },
        {
            A: '42.11',
            B: '4211',
            C: 'Anläggning av vägar och motorvägar',
        },
        {
            A: '42.12',
            B: '4212',
            C: 'Anläggning av järnvägar och tunnelbanor',
        },
        {
            A: '42.13',
            B: '4213',
            C: 'Anläggning av broar och tunnlar',
        },
        {
            A: '42.21',
            B: '4221',
            C: 'Allmännyttiga anläggningsarbeten för värme, vatten och avlopp',
        },
        {
            A: '42.22',
            B: '4222',
            C: 'Anläggningsarbeten för el och telekommunikation',
        },
        {
            A: '42.91',
            B: '4291',
            C: 'Vattenbyggnad',
        },
        {
            A: '42.99',
            B: '4299',
            C: 'Övriga anläggningsarbeten',
        },
        {
            A: '43.11',
            B: '4311',
            C: 'Rivning av hus och byggnader',
        },
        {
            A: '43.12',
            B: '4312',
            C: 'Mark- och grundarbeten',
        },
        {
            A: '43.13',
            B: '4313',
            C: 'Markundersökning',
        },
        {
            A: '43.21',
            B: '4321',
            C: 'Elinstallationer',
        },
        {
            A: '43.22',
            B: '4322',
            C: 'VVS-arbeten',
        },
        {
            A: '43.29',
            B: '4329',
            C: 'Andra bygginstallationer',
        },
        {
            A: '43.31',
            B: '4331',
            C: 'Puts-, fasad- och stuckatörsarbeten',
        },
        {
            A: '43.32',
            B: '4332',
            C: 'Byggnadssnickeriarbeten',
        },
        {
            A: '43.33',
            B: '4333',
            C: 'Golv- och väggbeläggningsarbeten',
        },
        {
            A: '43.34',
            B: '4334',
            C: 'Måleri- och glasmästeriarbeten',
        },
        {
            A: '43.39',
            B: '4339',
            C: 'Annan slutbehandling av byggnader',
        },
        {
            A: '43.91',
            B: '4391',
            C: 'Takarbeten',
        },
        {
            A: '43.99',
            B: '4399',
            C: 'Övrig specialiserad bygg- och anläggningsverksamhet',
        },
        {
            A: '45.11',
            B: '4511',
            C: 'Handel med personbilar och lätta motorfordon',
        },
        {
            A: '45.19',
            B: '4519',
            C: 'Handel med andra motorfordon utom motorcyklar',
        },
        {
            A: '45.20',
            B: '4520',
            C: 'Underhåll och reparation av motorfordon utom motorcyklar',
        },
        {
            A: '45.31',
            B: '4531',
            C: 'Parti- och provisionshandel med reservdelar och tillbehör till motorfordon utom motorcyklar',
        },
        {
            A: '45.32',
            B: '4532',
            C: 'Detaljhandel med reservdelar och tillbehör till motorfordon utom motorcyklar',
        },
        {
            A: '45.40',
            B: '4540',
            C: 'Handel med och service av motorcyklar inklusive reservdelar och tillbehör',
        },
        {
            A: '46.11',
            B: '4611',
            C: 'Provisionshandel med jordbruksråvaror, levande djur, textilråvaror och textilhalvfabrikat',
        },
        {
            A: '46.12',
            B: '4612',
            C: 'Provisionshandel med bränsle, malm, metaller och industrikemikalier',
        },
        {
            A: '46.13',
            B: '4613',
            C: 'Provisionshandel med virke och byggmaterial',
        },
        {
            A: '46.14',
            B: '4614',
            C: 'Provisionshandel med maskiner, industriell utrustning, fartyg och luftfartyg',
        },
        {
            A: '46.15',
            B: '4615',
            C: 'Provisionshandel med möbler, hushålls- och järnhandelsvaror',
        },
        {
            A: '46.16',
            B: '4616',
            C: 'Provisionshandel med textilier, kläder, skodon och lädervaror',
        },
        {
            A: '46.17',
            B: '4617',
            C: 'Provisionshandel med livsmedel, drycker och tobak',
        },
        {
            A: '46.18',
            B: '4618',
            C: 'Provisionshandel med annat specialsortiment',
        },
        {
            A: '46.19',
            B: '4619',
            C: 'Provisionshandel med blandat sortiment',
        },
        {
            A: '46.21',
            B: '4621',
            C: 'Partihandel med spannmål, råtobak, utsäde och djurfoder',
        },
        {
            A: '46.22',
            B: '4622',
            C: 'Partihandel med blommor och växter',
        },
        {
            A: '46.23',
            B: '4623',
            C: 'Partihandel med levande djur',
        },
        {
            A: '46.24',
            B: '4624',
            C: 'Partihandel med hudar, skinn och läder',
        },
        {
            A: '46.31',
            B: '4631',
            C: 'Partihandel med frukt och grönsaker',
        },
        {
            A: '46.32',
            B: '4632',
            C: 'Partihandel med kött- och köttvaror',
        },
        {
            A: '46.33',
            B: '4633',
            C: 'Partihandel med mejeriprodukter, ägg, matolja och matfett',
        },
        {
            A: '46.34',
            B: '4634',
            C: 'Partihandel med drycker',
        },
        {
            A: '46.35',
            B: '4635',
            C: 'Partihandel med tobak',
        },
        {
            A: '46.36',
            B: '4636',
            C: 'Partihandel med socker, choklad och sockerkonfektyrer',
        },
        {
            A: '46.37',
            B: '4637',
            C: 'Partihandel med kaffe, te, kakao och kryddor',
        },
        {
            A: '46.38',
            B: '4638',
            C: 'Partihandel med andra livsmedel, bl.a. fisk samt skal- och blötdjur',
        },
        {
            A: '46.39',
            B: '4639',
            C: 'Icke specialiserad partihandel med livsmedel, drycker och tobak',
        },
        {
            A: '46.41',
            B: '4641',
            C: 'Partihandel med textilier',
        },
        {
            A: '46.42',
            B: '4642',
            C: 'Partihandel med kläder och skodon',
        },
        {
            A: '46.43',
            B: '4643',
            C: 'Partihandel med hushållsapparater, samt elartiklar',
        },
        {
            A: '46.44',
            B: '4644',
            C: 'Partihandel med glas och porslin, rengöringsmedel',
        },
        {
            A: '46.45',
            B: '4645',
            C: 'Partihandel med parfym och kosmetika',
        },
        {
            A: '46.46',
            B: '4646',
            C: 'Partihandel med medicinsk utrustning och apoteksvaror',
        },
        {
            A: '46.47',
            B: '4647',
            C: 'Partihandel med möbler, mattor och belysningsartiklar',
        },
        {
            A: '46.48',
            B: '4648',
            C: 'Partihandel med ur och guldsmedsvaror',
        },
        {
            A: '46.49',
            B: '4649',
            C: 'Partihandel med andra hushållsvaror',
        },
        {
            A: '46.51',
            B: '4651',
            C: 'Partihandel med datorer och kringutrustning samt programvara',
        },
        {
            A: '46.52',
            B: '4652',
            C: 'Partihandel med elektronik- och telekommunikationsutrustning',
        },
        {
            A: '46.61',
            B: '4661',
            C: 'Partihandel med jordbruksmaskiner och -utrustning',
        },
        {
            A: '46.62',
            B: '4662',
            C: 'Partihandel med verktygsmaskiner',
        },
        {
            A: '46.63',
            B: '4663',
            C: 'Partihandel med gruv-, bygg- och anläggningsmaskiner',
        },
        {
            A: '46.64',
            B: '4664',
            C: 'Partihandel med textil-, sy- och stickmaskiner',
        },
        {
            A: '46.65',
            B: '4665',
            C: 'Partihandel med kontorsmöbler',
        },
        {
            A: '46.66',
            B: '4666',
            C: 'Partihandel med andra kontorsmaskiner och kontorsutrustning',
        },
        {
            A: '46.69',
            B: '4669',
            C: 'Partihandel med andra maskiner och annan utrustning',
        },
        {
            A: '46.71',
            B: '4671',
            C: 'Partihandel med bränslen',
        },
        {
            A: '46.72',
            B: '4672',
            C: 'Partihandel med metaller och metallmalmer',
        },
        {
            A: '46.73',
            B: '4673',
            C: 'Partihandel med virke, andra byggmaterial och sanitetsgods',
        },
        {
            A: '46.74',
            B: '4674',
            C: 'Partihandel med järnhandelsvaror och VVS-armatur',
        },
        {
            A: '46.75',
            B: '4675',
            C: 'Partihandel med kemiska produkter',
        },
        {
            A: '46.76',
            B: '4676',
            C: 'Partihandel med andra insatsvaror',
        },
        {
            A: '46.77',
            B: '4677',
            C: 'Partihandel med avfallsprodukter och skrot',
        },
        {
            A: '46.90',
            B: '4690',
            C: 'Övrig partihandel',
        },
        {
            A: '47.11',
            B: '4711',
            C: 'Detaljhandel med brett sortiment, mest livsmedel, drycker och tobak',
        },
        {
            A: '47.19',
            B: '4719',
            C: 'Annan detaljhandel med brett sortiment',
        },
        {
            A: '47.21',
            B: '4721',
            C: 'Specialiserad butikshandel med frukt och grönsaker',
        },
        {
            A: '47.22',
            B: '4722',
            C: 'Specialiserad butikshandel med kött och charkuterier',
        },
        {
            A: '47.23',
            B: '4723',
            C: 'Specialiserad butikshandel med fisk, skal- och blötdjur',
        },
        {
            A: '47.24',
            B: '4724',
            C: 'Specialiserad butikshandel med bröd, konditorivaror och konfektyrer',
        },
        {
            A: '47.25',
            B: '4725',
            C: 'Specialiserad butikshandel med alkoholhaltiga och andra drycker',
        },
        {
            A: '47.26',
            B: '4726',
            C: 'Specialiserad butikshandel med tobaksvaror',
        },
        {
            A: '47.29',
            B: '4729',
            C: 'Annan specialiserad butikshandel med livsmedel',
        },
        {
            A: '47.30',
            B: '4730',
            C: 'Specialiserad detaljhandel med drivmedel',
        },
        {
            A: '47.41',
            B: '4741',
            C: 'Specialiserad butikshandel med datorer, programvara, data- och tv-spel',
        },
        {
            A: '47.42',
            B: '4742',
            C: 'Specialiserad butikshandel med telekommunikationsutrustning',
        },
        {
            A: '47.43',
            B: '4743',
            C: 'Specialiserad butikshandel med ljud- och bildanläggningar samt videoutrustning',
        },
        {
            A: '47.51',
            B: '4751',
            C: 'Specialiserad butikshandel med textilier',
        },
        {
            A: '47.52',
            B: '4752',
            C: 'Specialiserad butikshandel med bygg-, järn- och VVS-varor samt färger och glas',
        },
        {
            A: '47.53',
            B: '4753',
            C: 'Specialiserad butikshandel med mattor och inredningstextilier',
        },
        {
            A: '47.54',
            B: '4754',
            C: 'Specialiserad butikshandel med elektriska hushållsmaskiner och hushållsapparater',
        },
        {
            A: '47.59',
            B: '4759',
            C: 'Specialiserad butikshandel med möbler, belysnings- och heminredningsartiklar',
        },
        {
            A: '47.61',
            B: '4761',
            C: 'Specialiserad butikshandel med böcker',
        },
        {
            A: '47.62',
            B: '4762',
            C: 'Specialiserad butikshandel med tidningar och kontorsförbrukningsvaror',
        },
        {
            A: '47.63',
            B: '4763',
            C: 'Specialiserad butikshandel med inspelade och oinspelade band och skivor för musik och bild',
        },
        {
            A: '47.64',
            B: '4764',
            C: 'Specialiserad butikshandel med sport- och fritidsartiklar',
        },
        {
            A: '47.65',
            B: '4765',
            C: 'Specialiserad butikshandel med spel och leksaker',
        },
        {
            A: '47.71',
            B: '4771',
            C: 'Specialiserad butikshandel med kläder',
        },
        {
            A: '47.72',
            B: '4772',
            C: 'Specialiserad butikshandel med skodon och lädervaror',
        },
        {
            A: '47.73',
            B: '4773',
            C: 'Apotekshandel',
        },
        {
            A: '47.74',
            B: '4774',
            C: 'Specialiserad butikshandel med sjukvårdsartiklar',
        },
        {
            A: '47.75',
            B: '4775',
            C: 'Specialiserad butikshandel med kosmetika och hygienartiklar',
        },
        {
            A: '47.76',
            B: '4776',
            C: 'Specialiserad butikshandel med blommor och andra växter, frön och gödselmedel samt små sällskapsdjur',
        },
        {
            A: '47.77',
            B: '4777',
            C: 'Specialiserad butikshandel med ur, guldsmedsvaror och smycken',
        },
        {
            A: '47.78',
            B: '4778',
            C: 'Annan specialiserad butikshandel med nya varor',
        },
        {
            A: '47.79',
            B: '4779',
            C: 'Specialiserad butikshandel med antikviteter och andra begagnade varor',
        },
        {
            A: '47.81',
            B: '4781',
            C: 'Torg- och marknadshandel med livsmedel, drycker och tobak',
        },
        {
            A: '47.82',
            B: '4782',
            C: 'Torg- och marknadshandel med textilier, kläder och skodon',
        },
        {
            A: '47.89',
            B: '4789',
            C: 'Torg- och marknadshandel med övriga varor',
        },
        {
            A: '47.91',
            B: '4791',
            C: 'Postorderhandel och detaljhandel på Internet',
        },
        {
            A: '47.99',
            B: '4799',
            C: 'Övrig detaljhandel ej i butik, på torg eller marknad',
        },
        {
            A: '49.10',
            B: '4910',
            C: 'Järnvägstransport, passagerartrafik',
        },
        {
            A: '49.20',
            B: '4920',
            C: 'Järnvägstransport, godstrafik',
        },
        {
            A: '49.31',
            B: '4931',
            C: 'Kollektivtrafik',
        },
        {
            A: '49.32',
            B: '4932',
            C: 'Taxitrafik',
        },
        {
            A: '49.39',
            B: '4939',
            C: 'Annan landtransport av passagerare',
        },
        {
            A: '49.41',
            B: '4941',
            C: 'Vägtransport, godstrafik',
        },
        {
            A: '49.42',
            B: '4942',
            C: 'Flyttjänster',
        },
        {
            A: '49.50',
            B: '4950',
            C: 'Transport i rörsystem',
        },
        {
            A: '50.10',
            B: '5010',
            C: 'Havs- och kustsjöfart, passagerartrafik',
        },
        {
            A: '50.20',
            B: '5020',
            C: 'Havs- och kustsjöfart, godstrafik',
        },
        {
            A: '50.30',
            B: '5030',
            C: 'Sjöfart på inre vattenvägar, passagerartrafik',
        },
        {
            A: '50.40',
            B: '5040',
            C: 'Sjöfart på inre vattenvägar, godstrafik',
        },
        {
            A: '51.10',
            B: '5110',
            C: 'Lufttransport, passagerartrafik',
        },
        {
            A: '51.21',
            B: '5121',
            C: 'Lufttransport, godstrafik',
        },
        {
            A: '51.22',
            B: '5122',
            C: 'Rymdfart',
        },
        {
            A: '52.10',
            B: '5210',
            C: 'Magasinering och varulagring',
        },
        {
            A: '52.21',
            B: '5221',
            C: 'Stödtjänster till landtransport',
        },
        {
            A: '52.22',
            B: '5222',
            C: 'Stödtjänster till sjötransport',
        },
        {
            A: '52.23',
            B: '5223',
            C: 'Stödtjänster till lufttransport',
        },
        {
            A: '52.24',
            B: '5224',
            C: 'Godshantering',
        },
        {
            A: '52.29',
            B: '5229',
            C: 'Övriga stödtjänster till transport',
        },
        {
            A: '53.10',
            B: '5310',
            C: 'Postbefordran via nationella posten',
        },
        {
            A: '53.20',
            B: '5320',
            C: 'Annan postbefordran samt kurirverksamhet',
        },
        {
            A: '55.10',
            B: '5510',
            C: 'Hotellverksamhet',
        },
        {
            A: '55.20',
            B: '5520',
            C: 'Semesterbostäder och annan korttidsinkvartering',
        },
        {
            A: '55.30',
            B: '5530',
            C: 'Campingplatsverksamhet',
        },
        {
            A: '55.90',
            B: '5590',
            C: 'Annan logiverksamhet',
        },
        {
            A: '56.10',
            B: '5610',
            C: 'Restaurangverksamhet',
        },
        {
            A: '56.21',
            B: '5621',
            C: 'Cateringverksamhet vid enskilda evenemang',
        },
        {
            A: '56.29',
            B: '5629',
            C: 'Annan catering- och centralköksverksamhet',
        },
        {
            A: '56.30',
            B: '5630',
            C: 'Barverksamhet',
        },
        {
            A: '58.11',
            B: '5811',
            C: 'Bokutgivning',
        },
        {
            A: '58.12',
            B: '5812',
            C: 'Publicering av kataloger och sändlistor',
        },
        {
            A: '58.13',
            B: '5813',
            C: 'Tidningsutgivning',
        },
        {
            A: '58.14',
            B: '5814',
            C: 'Utgivning av tidskrifter',
        },
        {
            A: '58.19',
            B: '5819',
            C: 'Annan förlagsverksamhet',
        },
        {
            A: '58.21',
            B: '5821',
            C: 'Utgivning av dataspel',
        },
        {
            A: '58.29',
            B: '5829',
            C: 'Utgivning av annan programvara',
        },
        {
            A: '59.11',
            B: '5911',
            C: 'Produktion av film, video och TV-program',
        },
        {
            A: '59.12',
            B: '5912',
            C: 'Efterproduktion av film, video och TV-program',
        },
        {
            A: '59.13',
            B: '5913',
            C: 'Film-, video- och TV-programdistribution',
        },
        {
            A: '59.14',
            B: '5914',
            C: 'Filmvisning',
        },
        {
            A: '59.20',
            B: '5920',
            C: 'Ljudinspelning och fonogramutgivning',
        },
        {
            A: '60.10',
            B: '6010',
            C: 'Sändning av radioprogram',
        },
        {
            A: '60.20',
            B: '6020',
            C: 'Planering av TV-program och sändningsverksamhet',
        },
        {
            A: '61.10',
            B: '6110',
            C: 'Trådbunden telekommunikation',
        },
        {
            A: '61.20',
            B: '6120',
            C: 'Trådlös telekommunikation',
        },
        {
            A: '61.30',
            B: '6130',
            C: 'Telekommunikation via satellit',
        },
        {
            A: '61.90',
            B: '6190',
            C: 'Annan telekommunikation',
        },
        {
            A: '62.01',
            B: '6201',
            C: 'Dataprogrammering',
        },
        {
            A: '62.02',
            B: '6202',
            C: 'Datakonsultverksamhet',
        },
        {
            A: '62.03',
            B: '6203',
            C: 'Datordrifttjänster',
        },
        {
            A: '62.09',
            B: '6209',
            C: 'Andra IT- och datatjänster',
        },
        {
            A: '63.11',
            B: '6311',
            C: 'Databehandling, hosting o.d.',
        },
        {
            A: '63.12',
            B: '6312',
            C: 'Webbportaler',
        },
        {
            A: '63.91',
            B: '6391',
            C: 'Nyhetsservice',
        },
        {
            A: '63.99',
            B: '6399',
            C: 'Övriga informationstjänster',
        },
        {
            A: '64.11',
            B: '6411',
            C: 'Centralbanksverksamhet',
        },
        {
            A: '64.19',
            B: '6419',
            C: 'Annan monetär finansförmedling',
        },
        {
            A: '64.20',
            B: '6420',
            C: 'Holdingverksamhet',
        },
        {
            A: '64.30',
            B: '6430',
            C: 'Fonder och liknande finansiella enheter',
        },
        {
            A: '64.91',
            B: '6491',
            C: 'Finansiell leasing',
        },
        {
            A: '64.92',
            B: '6492',
            C: 'Annan kreditgivning',
        },
        {
            A: '64.99',
            B: '6499',
            C: 'Diverse övriga finansiella tjänster utom försäkring och pensionsfondsverksamhet',
        },
        {
            A: '65.11',
            B: '6511',
            C: 'Livförsäkring',
        },
        {
            A: '65.12',
            B: '6512',
            C: 'Skadeförsäkring',
        },
        {
            A: '65.20',
            B: '6520',
            C: 'Återförsäkring',
        },
        {
            A: '65.30',
            B: '6530',
            C: 'Pensionsfondsverksamhet',
        },
        {
            A: '66.11',
            B: '6611',
            C: 'Administrativa tjänster till finansiella marknader',
        },
        {
            A: '66.12',
            B: '6612',
            C: 'Verksamhet utförd av värdepappers- och varumäklare',
        },
        {
            A: '66.19',
            B: '6619',
            C: 'Andra stödtjänster till finansiella tjänster utom försäkring och pensionsfondsverksamhet',
        },
        {
            A: '66.21',
            B: '6621',
            C: 'Risk- och skadebedömning',
        },
        {
            A: '66.22',
            B: '6622',
            C: 'Verksamhet utförd av försäkringsombud och försäkringsmäklare',
        },
        {
            A: '66.29',
            B: '6629',
            C: 'Andra stödtjänster till försäkring och pensionsfondsverksamhet',
        },
        {
            A: '66.30',
            B: '6630',
            C: 'Fondförvaltning',
        },
        {
            A: '68.10',
            B: '6810',
            C: 'Handel med egna fastigheter',
        },
        {
            A: '68.20',
            B: '6820',
            C: 'Uthyrning och förvaltning av egna eller arrenderade fastigheter',
        },
        {
            A: '68.31',
            B: '6831',
            C: 'Fastighetsförmedling',
        },
        {
            A: '68.32',
            B: '6832',
            C: 'Fastighetsförvaltning på uppdrag',
        },
        {
            A: '69.10',
            B: '6910',
            C: 'Juridisk verksamhet',
        },
        {
            A: '69.20',
            B: '6920',
            C: 'Redovisning och bokföring, revision, skatterådgivning',
        },
        {
            A: '70.10',
            B: '7010',
            C: 'Verksamheter som utövas av huvudkontor',
        },
        {
            A: '70.21',
            B: '7021',
            C: 'PR och kommunikation',
        },
        {
            A: '70.22',
            B: '7022',
            C: 'Konsultverksamhet avseende företags organisation',
        },
        {
            A: '71.11',
            B: '7111',
            C: 'Arkitektverksamhet',
        },
        {
            A: '71.12',
            B: '7112',
            C: 'Teknisk konsultverksamhet o.d.',
        },
        {
            A: '71.20',
            B: '7120',
            C: 'Teknisk provning och analys',
        },
        {
            A: '72.11',
            B: '7211',
            C: 'Bioteknisk forskning och utveckling',
        },
        {
            A: '72.19',
            B: '7219',
            C: 'Annan naturvetenskaplig och teknisk forskning och utveckling',
        },
        {
            A: '72.20',
            B: '7220',
            C: 'Samhällsvetenskaplig och humanistisk forskning och utveckling',
        },
        {
            A: '73.11',
            B: '7311',
            C: 'Reklambyråverksamhet o.d.',
        },
        {
            A: '73.12',
            B: '7312',
            C: 'Mediebyråverksamhet och annonsförsäljning',
        },
        {
            A: '73.20',
            B: '7320',
            C: 'Marknads- och opinionsundersökning',
        },
        {
            A: '74.10',
            B: '7410',
            C: 'Specialiserad designverksamhet',
        },
        {
            A: '74.20',
            B: '7420',
            C: 'Fotoverksamhet',
        },
        {
            A: '74.30',
            B: '7430',
            C: 'Översättning och tolkning',
        },
        {
            A: '74.90',
            B: '7490',
            C: 'Övrig verksamhet inom juridik, ekonomi, vetenskap och teknik',
        },
        {
            A: '75.00',
            B: '7500',
            C: 'Veterinärverksamhet',
        },
        {
            A: '77.11',
            B: '7711',
            C: 'Uthyrning och leasing av personbilar och lätta motorfordon',
        },
        {
            A: '77.12',
            B: '7712',
            C: 'Uthyrning och leasing av lastbilar och andra tunga motorfordon',
        },
        {
            A: '77.21',
            B: '7721',
            C: 'Uthyrning och leasing av fritids- och sportutrustning',
        },
        {
            A: '77.22',
            B: '7722',
            C: 'Uthyrning av videokassetter och dvd-skivor',
        },
        {
            A: '77.29',
            B: '7729',
            C: 'Uthyrning och leasing av andra hushållsartiklar och varor för personligt bruk',
        },
        {
            A: '77.31',
            B: '7731',
            C: 'Uthyrning och leasing av jordbruksmaskiner och jordbruksredskap',
        },
        {
            A: '77.32',
            B: '7732',
            C: 'Uthyrning och leasing av bygg- och anläggningsmaskiner',
        },
        {
            A: '77.33',
            B: '7733',
            C: 'Uthyrning och leasing av kontorsmaskiner och kontorsutrustning (inklusive datorer)',
        },
        {
            A: '77.34',
            B: '7734',
            C: 'Uthyrning och leasing av fartyg och båtar',
        },
        {
            A: '77.35',
            B: '7735',
            C: 'Uthyrning och leasing av flygplan',
        },
        {
            A: '77.39',
            B: '7739',
            C: 'Uthyrning och leasing av övrig utrustning och övriga maskiner och materiella tillgångar',
        },
        {
            A: '77.40',
            B: '7740',
            C: 'Leasing av immateriell egendom och liknande produkter, med undantag för upphovsrättsskyddade verk',
        },
        {
            A: '78.10',
            B: '7810',
            C: 'Arbetsförmedling och rekrytering',
        },
        {
            A: '78.20',
            B: '7820',
            C: 'Personaluthyrning',
        },
        {
            A: '78.30',
            B: '7830',
            C: 'Övrigt tillhandahållande av personalfunktioner',
        },
        {
            A: '79.11',
            B: '7911',
            C: 'Resebyråverksamhet',
        },
        {
            A: '79.12',
            B: '7912',
            C: 'Researrangemang',
        },
        {
            A: '79.90',
            B: '7990',
            C: 'Turist- och bokningsservice',
        },
        {
            A: '80.10',
            B: '8010',
            C: 'Säkerhetsverksamhet',
        },
        {
            A: '80.20',
            B: '8020',
            C: 'Säkerhetssystemtjänster',
        },
        {
            A: '80.30',
            B: '8030',
            C: 'Spanings- och detektivverksamhet',
        },
        {
            A: '81.10',
            B: '8110',
            C: 'Fastighetsrelaterade stödtjänster',
        },
        {
            A: '81.21',
            B: '8121',
            C: 'Lokalvård',
        },
        {
            A: '81.22',
            B: '8122',
            C: 'Rengöring och sotning av byggnader',
        },
        {
            A: '81.29',
            B: '8129',
            C: 'Annan rengöring',
        },
        {
            A: '81.30',
            B: '8130',
            C: 'Skötsel och underhåll av grönytor',
        },
        {
            A: '82.11',
            B: '8211',
            C: 'Kombinerade kontorstjänster',
        },
        {
            A: '82.19',
            B: '8219',
            C: 'Kopiering, dokumentsammanställning och andra specialiserade kontorstjänster',
        },
        {
            A: '82.20',
            B: '8220',
            C: 'Callcenterverksamhet',
        },
        {
            A: '82.30',
            B: '8230',
            C: 'Arrangemang av kongresser och mässor',
        },
        {
            A: '82.91',
            B: '8291',
            C: 'Inkassoföretags och kreditupplysningsföretags verksamhet',
        },
        {
            A: '82.92',
            B: '8292',
            C: 'Förpackningsverksamhet',
        },
        {
            A: '82.99',
            B: '8299',
            C: 'Övriga företagstjänster',
        },
        {
            A: '84.11',
            B: '8411',
            C: 'Övergripande offentlig förvaltning',
        },
        {
            A: '84.12',
            B: '8412',
            C: 'Administration av vård, utbildning, kulturell verksamhet och annan samhällsservice',
        },
        {
            A: '84.13',
            B: '8413',
            C: 'Administration av näringslivsprogram',
        },
        {
            A: '84.21',
            B: '8421',
            C: 'Utrikesförvaltning',
        },
        {
            A: '84.22',
            B: '8422',
            C: 'Totalförsvar',
        },
        {
            A: '84.23',
            B: '8423',
            C: 'Rättskipning',
        },
        {
            A: '84.24',
            B: '8424',
            C: 'Polisverksamhet',
        },
        {
            A: '84.25',
            B: '8425',
            C: 'Brand- och räddningsverksamhet',
        },
        {
            A: '84.30',
            B: '8430',
            C: 'Obligatorisk socialförsäkring',
        },
        {
            A: '85.10',
            B: '8510',
            C: 'Förskoleutbildning',
        },
        {
            A: '85.20',
            B: '8520',
            C: 'Grundskoleutbildning',
        },
        {
            A: '85.31',
            B: '8531',
            C: 'Studieförberedande gymnasial utbildning m.m.',
        },
        {
            A: '85.32',
            B: '8532',
            C: 'Gymnasial yrkesutbildning m.m.',
        },
        {
            A: '85.41',
            B: '8541',
            C: 'Eftergymnasial utbildning vid annat än universitet och högskola',
        },
        {
            A: '85.42',
            B: '8542',
            C: 'Universitets- eller högskoleutbildning',
        },
        {
            A: '85.51',
            B: '8551',
            C: 'Sport- och fritidsutbildning',
        },
        {
            A: '85.52',
            B: '8552',
            C: 'Musik-, dans- och övrig kulturell utbildning',
        },
        {
            A: '85.53',
            B: '8553',
            C: 'Trafikskoleverksamhet',
        },
        {
            A: '85.59',
            B: '8559',
            C: 'Övrig utbildning',
        },
        {
            A: '85.60',
            B: '8560',
            C: 'Stödverksamhet för utbildningsväsendet',
        },
        {
            A: '86.10',
            B: '8610',
            C: 'Sluten sjukvård',
        },
        {
            A: '86.21',
            B: '8621',
            C: 'Allmänpraktiserande läkarverksamhet',
        },
        {
            A: '86.22',
            B: '8622',
            C: 'Specialistläkarverksamhet inom öppenvård',
        },
        {
            A: '86.23',
            B: '8623',
            C: 'Tandläkarverksamhet',
        },
        {
            A: '86.90',
            B: '8690',
            C: 'Annan hälso- och sjukvård',
        },
        {
            A: '87.10',
            B: '8710',
            C: 'Boende med sjuksköterskevård',
        },
        {
            A: '87.20',
            B: '8720',
            C: 'Boende med särskild service för personer med utvecklingsstörning, psykiska funktionshinder eller missbruksproblem',
        },
        {
            A: '87.30',
            B: '8730',
            C: 'Vård och omsorg i särskilda boendeformer för äldre och funktionshindrade personer',
        },
        {
            A: '87.90',
            B: '8790',
            C: 'Annan vård och omsorg med boende',
        },
        {
            A: '88.10',
            B: '8810',
            C: 'Öppna sociala insatser för äldre och funktionshindrade personer',
        },
        {
            A: '88.91',
            B: '8891',
            C: 'Dagbarnvård',
        },
        {
            A: '88.99',
            B: '8899',
            C: 'Övriga öppna sociala insatser',
        },
        {
            A: '90.01',
            B: '9001',
            C: 'Artistisk verksamhet',
        },
        {
            A: '90.02',
            B: '9002',
            C: 'Stödtjänster till artistisk verksamhet',
        },
        {
            A: '90.03',
            B: '9003',
            C: 'Litterärt och konstnärligt skapande',
        },
        {
            A: '90.04',
            B: '9004',
            C: 'Drift av teatrar, konserthus o.d.',
        },
        {
            A: '91.01',
            B: '9101',
            C: 'Biblioteks- och arkivverksamhet',
        },
        {
            A: '91.02',
            B: '9102',
            C: 'Museiverksamhet',
        },
        {
            A: '91.03',
            B: '9103',
            C: 'Vård av historiska minnesmärken och byggnader och liknande sevärdheter',
        },
        {
            A: '91.04',
            B: '9104',
            C: 'Drift av botaniska trädgårdar, djurparker och naturreservat',
        },
        {
            A: '92.00',
            B: '9200',
            C: 'Spel- och vadhållningsverksamhet',
        },
        {
            A: '93.11',
            B: '9311',
            C: 'Drift av sportanläggningar',
        },
        {
            A: '93.12',
            B: '9312',
            C: 'Sportklubbars och idrottsföreningars verksamhet',
        },
        {
            A: '93.13',
            B: '9313',
            C: 'Drift av gymanläggningar',
        },
        {
            A: '93.19',
            B: '9319',
            C: 'Annan sportverksamhet',
        },
        {
            A: '93.21',
            B: '9321',
            C: 'Nöjes- och temaparksverksamhet',
        },
        {
            A: '93.29',
            B: '9329',
            C: 'Övrig fritids- och nöjesverksamhet',
        },
        {
            A: '94.11',
            B: '9411',
            C: 'Intressebevakning inom bransch- och arbetsgivarorganisationer',
        },
        {
            A: '94.12',
            B: '9412',
            C: 'Intressebevakning inom yrkesorganisationer',
        },
        {
            A: '94.20',
            B: '9420',
            C: 'Intressebevakning inom arbetstagarorganisationer',
        },
        {
            A: '94.91',
            B: '9491',
            C: 'Verksamhet i religiösa samfund',
        },
        {
            A: '94.92',
            B: '9492',
            C: 'Verksamhet i politiska organisationer',
        },
        {
            A: '94.99',
            B: '9499',
            C: 'Verksamhet i andra intresseorganisationer',
        },
        {
            A: '95.11',
            B: '9511',
            C: 'Reparation av datorer och kringutrustning',
        },
        {
            A: '95.12',
            B: '9512',
            C: 'Reparation av kommunikationsutrustning',
        },
        {
            A: '95.21',
            B: '9521',
            C: 'Reparation av hemelektronik',
        },
        {
            A: '95.22',
            B: '9522',
            C: 'Reparation av hushållsapparater samt av utrustning för hem och trädgård',
        },
        {
            A: '95.23',
            B: '9523',
            C: 'Lagning av skodon och lädervaror',
        },
        {
            A: '95.24',
            B: '9524',
            C: 'Reparation av möbler och heminredning',
        },
        {
            A: '95.25',
            B: '9525',
            C: 'Reparation av ur och guldsmedsvaror',
        },
        {
            A: '95.29',
            B: '9529',
            C: 'Reparation av andra hushållsartiklar och personliga artiklar',
        },
        {
            A: '96.01',
            B: '9601',
            C: 'Tvätteriverksamhet',
        },
        {
            A: '96.02',
            B: '9602',
            C: 'Hår- och skönhetsvård',
        },
        {
            A: '96.03',
            B: '9603',
            C: 'Begravningsverksamhet',
        },
        {
            A: '96.04',
            B: '9604',
            C: 'Kroppsvård',
        },
        {
            A: '96.09',
            B: '9609',
            C: 'Övriga konsumenttjänster',
        },
        {
            A: '97.00',
            B: '9700',
            C: 'Förvärvsarbete i hushåll',
        },
        {
            A: '98.10',
            B: '9810',
            C: 'Hushållens produktion av diverse varor för eget bruk',
        },
        {
            A: '98.20',
            B: '9820',
            C: 'Hushållens produktion av diverse tjänster för eget bruk',
        },
        {
            A: '99.00',
            B: '9900',
            C: 'Verksamhet vid internationella organisationer, utländska ambassader o.d.',
        },
    ],
    'Grupp (Tresiffer)': [
        {
            A: 'SNI 2007',
        },
        {
            A: 'Grupp (Officiell kodstruktur)',
            B: 'Grupp',
            C: 'Benämning',
        },
        {
            A: '01.1',
            B: '011',
            C: 'Odling av ett- och tvååriga växter',
        },
        {
            A: '01.2',
            B: '012',
            C: 'Odling av fleråriga växter',
        },
        {
            A: '01.3',
            B: '013',
            C: 'Odling av plantskoleväxter',
        },
        {
            A: '01.4',
            B: '014',
            C: 'Husdjursskötsel',
        },
        {
            A: '01.5',
            B: '015',
            C: 'Blandat jordbruk',
        },
        {
            A: '01.6',
            B: '016',
            C: 'Service till jordbruk och bearbetning av skördade växter',
        },
        {
            A: '01.7',
            B: '017',
            C: 'Jakt och service i anslutning härtill',
        },
        {
            A: '02.1',
            B: '021',
            C: 'Skogsförvaltning och skogsskötsel',
        },
        {
            A: '02.2',
            B: '022',
            C: 'Drivning',
        },
        {
            A: '02.3',
            B: '023',
            C: 'Insamling av annat vilt växande skogsmaterial än trä',
        },
        {
            A: '02.4',
            B: '024',
            C: 'Service till skogsbruk',
        },
        {
            A: '03.1',
            B: '031',
            C: 'Fiske',
        },
        {
            A: '03.2',
            B: '032',
            C: 'Vattenbruk',
        },
        {
            A: '05.1',
            B: '051',
            C: 'Stenkolsutvinning',
        },
        {
            A: '05.2',
            B: '052',
            C: 'Brunkolsutvinning',
        },
        {
            A: '06.1',
            B: '061',
            C: 'Utvinning av råpetroleum',
        },
        {
            A: '06.2',
            B: '062',
            C: 'Utvinning av naturgas',
        },
        {
            A: '07.1',
            B: '071',
            C: 'Järnmalmsutvinning',
        },
        {
            A: '07.2',
            B: '072',
            C: 'Utvinning av andra metallmalmer än järnmalm',
        },
        {
            A: '08.1',
            B: '081',
            C: 'Utvinning av sand, grus, sten och lera',
        },
        {
            A: '08.9',
            B: '089',
            C: 'Övrig utvinning av mineral',
        },
        {
            A: '09.1',
            B: '091',
            C: 'Stödtjänster till råpetroleum- och naturgasutvinning',
        },
        {
            A: '09.9',
            B: '099',
            C: 'Stödtjänster till annan utvinning',
        },
        {
            A: '10.1',
            B: '101',
            C: 'Beredning och hållbarhetsbehandling av kött och köttvaror',
        },
        {
            A: '10.2',
            B: '102',
            C: 'Beredning och hållbarhetsbehandling av fisk samt skal- och blötdjur',
        },
        {
            A: '10.3',
            B: '103',
            C: 'Beredning och hållbarhetsbehandling av frukt, bär och grönsaker',
        },
        {
            A: '10.4',
            B: '104',
            C: 'Framställning av vegetabiliska och animaliska oljor och fetter',
        },
        {
            A: '10.5',
            B: '105',
            C: 'Mejerivaru- och glasstillverkning',
        },
        {
            A: '10.6',
            B: '106',
            C: 'Tillverkning av kvarnprodukter och stärkelse',
        },
        {
            A: '10.7',
            B: '107',
            C: 'Tillverkning av bageri- och mjölprodukter',
        },
        {
            A: '10.8',
            B: '108',
            C: 'Annan livsmedelsframställning',
        },
        {
            A: '10.9',
            B: '109',
            C: 'Framställning av beredda djurfoder',
        },
        {
            A: '11.0',
            B: '110',
            C: 'Framställning av drycker',
        },
        {
            A: '12.0',
            B: '120',
            C: 'Tobaksvarutillverkning',
        },
        {
            A: '13.1',
            B: '131',
            C: 'Garntillverkning',
        },
        {
            A: '13.2',
            B: '132',
            C: 'Vävnadstillverkning',
        },
        {
            A: '13.3',
            B: '133',
            C: 'Blekning, färgning och annan textilberedning',
        },
        {
            A: '13.9',
            B: '139',
            C: 'Annan textilietillverkning',
        },
        {
            A: '14.1',
            B: '141',
            C: 'Tillverkning av kläder, utom pälsvaror',
        },
        {
            A: '14.2',
            B: '142',
            C: 'Tillverkning av pälsvaror',
        },
        {
            A: '14.3',
            B: '143',
            C: 'Tillverkning av trikåvaror',
        },
        {
            A: '15.1',
            B: '151',
            C: 'Garvning och annan läderberedning; tillverkning av reseffekter, handväskor, sadel- och seldon; pälsberedning',
        },
        {
            A: '15.2',
            B: '152',
            C: 'Tillverkning av skodon',
        },
        {
            A: '16.1',
            B: '161',
            C: 'Sågning och hyvling av trä',
        },
        {
            A: '16.2',
            B: '162',
            C: 'Tillverkning av varor av trä, kork, halm, rotting o.d.',
        },
        {
            A: '17.1',
            B: '171',
            C: 'Massa-, pappers- och papptillverkning',
        },
        {
            A: '17.2',
            B: '172',
            C: 'Tillverkning av pappers- och pappvaror',
        },
        {
            A: '18.1',
            B: '181',
            C: 'Grafisk produktion',
        },
        {
            A: '18.2',
            B: '182',
            C: 'Reproduktion av inspelningar',
        },
        {
            A: '19.1',
            B: '191',
            C: 'Tillverkning av stenkolsprodukter',
        },
        {
            A: '19.2',
            B: '192',
            C: 'Petroleumraffinering',
        },
        {
            A: '20.1',
            B: '201',
            C: 'Tillverkning av baskemikalier, gödselmedel och kväveprodukter, plaster och syntetgummi i obearbetad form',
        },
        {
            A: '20.2',
            B: '202',
            C: 'Tillverkning av bekämpningsmedel och andra lantbrukskemiska produkter',
        },
        {
            A: '20.3',
            B: '203',
            C: 'Tillverkning av färg, lack, tryckfärg m.m.',
        },
        {
            A: '20.4',
            B: '204',
            C: 'Tillverkning av rengöringsmedel, parfym och toalettartiklar',
        },
        {
            A: '20.5',
            B: '205',
            C: 'Tillverkning av andra kemiska produkter',
        },
        {
            A: '20.6',
            B: '206',
            C: 'Konstfibertillverkning',
        },
        {
            A: '21.1',
            B: '211',
            C: 'Tillverkning av farmaceutiska basprodukter',
        },
        {
            A: '21.2',
            B: '212',
            C: 'Tillverkning av läkemedel',
        },
        {
            A: '22.1',
            B: '221',
            C: 'Tillverkning av gummivaror',
        },
        {
            A: '22.2',
            B: '222',
            C: 'Plastvarutillverkning',
        },
        {
            A: '23.1',
            B: '231',
            C: 'Glas- och glasvarutillverkning',
        },
        {
            A: '23.2',
            B: '232',
            C: 'Tillverkning av eldfasta produkter',
        },
        {
            A: '23.3',
            B: '233',
            C: 'Tillverkning av byggmaterial av lergods',
        },
        {
            A: '23.4',
            B: '234',
            C: 'Tillverkning av andra porslinsprodukter och keramiska produkter',
        },
        {
            A: '23.5',
            B: '235',
            C: 'Tillverkning av cement, kalk och gips',
        },
        {
            A: '23.6',
            B: '236',
            C: 'Tillverkning av varor av betong, cement och gips',
        },
        {
            A: '23.7',
            B: '237',
            C: 'Huggning, formning och slutlig bearbetning av sten',
        },
        {
            A: '23.9',
            B: '239',
            C: 'Tillverkning av slipmedel och övriga icke-metalliska mineraliska produkter',
        },
        {
            A: '24.1',
            B: '241',
            C: 'Framställning av järn och stål samt ferrolegeringar',
        },
        {
            A: '24.2',
            B: '242',
            C: 'Tillverkning av rör, ledningar, ihåliga profiler och tillbehör av stål',
        },
        {
            A: '24.3',
            B: '243',
            C: 'Annan primärbearbetning av stål',
        },
        {
            A: '24.4',
            B: '244',
            C: 'Framställning av andra metaller än järn',
        },
        {
            A: '24.5',
            B: '245',
            C: 'Gjutning av metall',
        },
        {
            A: '25.1',
            B: '251',
            C: 'Byggnadsmetallvarutillverkning',
        },
        {
            A: '25.2',
            B: '252',
            C: 'Tillverkning av cisterner, tankar, kar och andra behållare av metall',
        },
        {
            A: '25.3',
            B: '253',
            C: 'Tillverkning av ånggeneratorer utom varmvattenpannor för centraluppvärmning',
        },
        {
            A: '25.4',
            B: '254',
            C: 'Tillverkning av vapen och ammunition',
        },
        {
            A: '25.5',
            B: '255',
            C: 'Smidning, pressning, prägling och valsning av metall; pulvermetallurgi',
        },
        {
            A: '25.6',
            B: '256',
            C: 'Beläggning och överdragning av metall; metallegoarbeten',
        },
        {
            A: '25.7',
            B: '257',
            C: 'Tillverkning av bestick, verktyg och andra järnhandelsvaror',
        },
        {
            A: '25.9',
            B: '259',
            C: 'Annan metallvarutillverkning',
        },
        {
            A: '26.1',
            B: '261',
            C: 'Tillverkning av elektroniska komponenter och kretskort',
        },
        {
            A: '26.2',
            B: '262',
            C: 'Tillverkning av datorer och kringutrustning',
        },
        {
            A: '26.3',
            B: '263',
            C: 'Tillverkning av kommunikationsutrustning',
        },
        {
            A: '26.4',
            B: '264',
            C: 'Tillverkning av hemelektronik',
        },
        {
            A: '26.5',
            B: '265',
            C: 'Tillverkning av instrument och apparater för mätning, provning och navigering samt ur',
        },
        {
            A: '26.6',
            B: '266',
            C: 'Tillverkning av strålningsutrustning samt elektromedicinsk och elektroterapeutisk utrustning',
        },
        {
            A: '26.7',
            B: '267',
            C: 'Tillverkning av optiska instrument och fotoutrustning',
        },
        {
            A: '26.8',
            B: '268',
            C: 'Tillverkning av magnetiska och optiska medier',
        },
        {
            A: '27.1',
            B: '271',
            C: 'Tillverkning av elmotorer, generatorer och transformatorer samt eldistributions- och elkontrollapparater',
        },
        {
            A: '27.2',
            B: '272',
            C: 'Batteri- och ackumulatortillverkning',
        },
        {
            A: '27.3',
            B: '273',
            C: 'Tillverkning av ledningar och kablar och kabeltillbehör',
        },
        {
            A: '27.4',
            B: '274',
            C: 'Tillverkning av belysningsarmatur',
        },
        {
            A: '27.5',
            B: '275',
            C: 'Tillverkning av hushållsmaskiner och hushållsapparater',
        },
        {
            A: '27.9',
            B: '279',
            C: 'Tillverkning av annan elapparatur',
        },
        {
            A: '28.1',
            B: '281',
            C: 'Tillverkning av maskiner för allmänt ändamål',
        },
        {
            A: '28.2',
            B: '282',
            C: 'Tillverkning av andra maskiner för allmänt ändamål',
        },
        {
            A: '28.3',
            B: '283',
            C: 'Tillverkning av jord- och skogsbruksmaskiner',
        },
        {
            A: '28.4',
            B: '284',
            C: 'Tillverkning av maskiner för metallbearbetning och verktygsmaskiner',
        },
        {
            A: '28.9',
            B: '289',
            C: 'Tillverkning av andra specialmaskiner',
        },
        {
            A: '29.1',
            B: '291',
            C: 'Motorfordonstillverkning',
        },
        {
            A: '29.2',
            B: '292',
            C: 'Tillverkning av karosserier för motorfordon; tillverkning av släpfordon och påhängsvagnar',
        },
        {
            A: '29.3',
            B: '293',
            C: 'Tillverkning av delar och tillbehör till motorfordon',
        },
        {
            A: '30.1',
            B: '301',
            C: 'Byggande av fartyg och båtar',
        },
        {
            A: '30.2',
            B: '302',
            C: 'Tillverkning av rälsfordon',
        },
        {
            A: '30.3',
            B: '303',
            C: 'Tillverkning av luftfartyg, rymdfarkoster o.d.',
        },
        {
            A: '30.4',
            B: '304',
            C: 'Tillverkning av militära stridsfordon',
        },
        {
            A: '30.9',
            B: '309',
            C: 'Övrig tillverkning av transportmedel',
        },
        {
            A: '31.0',
            B: '310',
            C: 'Tillverkning av möbler',
        },
        {
            A: '32.1',
            B: '321',
            C: 'Tillverkning av smycken, guld- och silversmedsvaror samt bijouterier',
        },
        {
            A: '32.2',
            B: '322',
            C: 'Tillverkning av musikinstrument',
        },
        {
            A: '32.3',
            B: '323',
            C: 'Tillverkning av sportartiklar',
        },
        {
            A: '32.4',
            B: '324',
            C: 'Tillverkning av spel och leksaker',
        },
        {
            A: '32.5',
            B: '325',
            C: 'Tillverkning av medicinsk och dental utrustning',
        },
        {
            A: '32.9',
            B: '329',
            C: 'Övrig tillverkning',
        },
        {
            A: '33.1',
            B: '331',
            C: 'Reparation av metallvaror, maskiner och apparater',
        },
        {
            A: '33.2',
            B: '332',
            C: 'Installation av industrimaskiner och -utrustning',
        },
        {
            A: '35.1',
            B: '351',
            C: 'Generering, överföring och distribution av elkraft',
        },
        {
            A: '35.2',
            B: '352',
            C: 'Gasförsörjning; distribution av gasformiga bränslen via rörnät',
        },
        {
            A: '35.3',
            B: '353',
            C: 'Försörjning av värme och kyla',
        },
        {
            A: '36.0',
            B: '360',
            C: 'Vattenförsörjning',
        },
        {
            A: '37.0',
            B: '370',
            C: 'Avloppsrening',
        },
        {
            A: '38.1',
            B: '381',
            C: 'Insamling av avfall',
        },
        {
            A: '38.2',
            B: '382',
            C: 'Behandling och bortskaffande av avfall',
        },
        {
            A: '38.3',
            B: '383',
            C: 'Återvinning',
        },
        {
            A: '39.0',
            B: '390',
            C: 'Sanering, efterbehandling av jord och vatten samt annan verksamhet för föroreningsbekämpning',
        },
        {
            A: '41.1',
            B: '411',
            C: 'Utformning av byggprojekt',
        },
        {
            A: '41.2',
            B: '412',
            C: 'Byggande av bostadshus och andra byggnader',
        },
        {
            A: '42.1',
            B: '421',
            C: 'Anläggning av vägar och järnvägar',
        },
        {
            A: '42.2',
            B: '422',
            C: 'Allmännyttiga anläggningsarbeten',
        },
        {
            A: '42.9',
            B: '429',
            C: 'Andra anläggningsarbeten',
        },
        {
            A: '43.1',
            B: '431',
            C: 'Rivning av hus samt mark- och grundarbeten',
        },
        {
            A: '43.2',
            B: '432',
            C: 'Elinstallationer, VVS-arbeten och andra bygginstallationer',
        },
        {
            A: '43.3',
            B: '433',
            C: 'Slutbehandling av byggnader',
        },
        {
            A: '43.9',
            B: '439',
            C: 'Annan specialiserad bygg- och anläggningsverksamhet',
        },
        {
            A: '45.1',
            B: '451',
            C: 'Handel med motorfordon utom motorcyklar',
        },
        {
            A: '45.2',
            B: '452',
            C: 'Underhåll och reparation av motorfordon utom motorcyklar',
        },
        {
            A: '45.3',
            B: '453',
            C: 'Handel med reservdelar och tillbehör till motorfordon utom motorcyklar',
        },
        {
            A: '45.4',
            B: '454',
            C: 'Handel med och service av motorcyklar inklusive reservdelar och tillbehör',
        },
        {
            A: '46.1',
            B: '461',
            C: 'Provisionshandel utom med motorfordon',
        },
        {
            A: '46.2',
            B: '462',
            C: 'Partihandel med jordbruksråvaror och levande djur',
        },
        {
            A: '46.3',
            B: '463',
            C: 'Partihandel med livsmedel, drycker och tobak',
        },
        {
            A: '46.4',
            B: '464',
            C: 'Partihandel med hushållsvaror',
        },
        {
            A: '46.5',
            B: '465',
            C: 'Partihandel med informations- och kommunikationsutrustning',
        },
        {
            A: '46.6',
            B: '466',
            C: 'Partihandel med övriga maskiner och övrig utrustning',
        },
        {
            A: '46.7',
            B: '467',
            C: 'Annan specialiserad partihandel',
        },
        {
            A: '46.9',
            B: '469',
            C: 'Övrig partihandel',
        },
        {
            A: '47.1',
            B: '471',
            C: 'Detaljhandel med brett sortiment',
        },
        {
            A: '47.2',
            B: '472',
            C: 'Specialiserad butikshandel med livsmedel, drycker och tobak',
        },
        {
            A: '47.3',
            B: '473',
            C: 'Specialiserad detaljhandel med drivmedel',
        },
        {
            A: '47.4',
            B: '474',
            C: 'Specialiserad butikshandel med informations- och kommunikationsutrustning',
        },
        {
            A: '47.5',
            B: '475',
            C: 'Specialiserad butikshandel med heminredningsartiklar och husgeråd',
        },
        {
            A: '47.6',
            B: '476',
            C: 'Specialiserad butikshandel med kultur- och fritidsartiklar',
        },
        {
            A: '47.7',
            B: '477',
            C: 'Övrig specialiserad butikshandel med hushållsvaror',
        },
        {
            A: '47.8',
            B: '478',
            C: 'Torg- och marknadshandel',
        },
        {
            A: '47.9',
            B: '479',
            C: 'Detaljhandel ej i butik, på torg eller marknad',
        },
        {
            A: '49.1',
            B: '491',
            C: 'Järnvägstransport, passagerartrafik',
        },
        {
            A: '49.2',
            B: '492',
            C: 'Järnvägstransport, godstrafik',
        },
        {
            A: '49.3',
            B: '493',
            C: 'Annan landtransport, passagerartrafik',
        },
        {
            A: '49.4',
            B: '494',
            C: 'Vägtransport, godstrafik och flyttjänster',
        },
        {
            A: '49.5',
            B: '495',
            C: 'Transport i rörsystem',
        },
        {
            A: '50.1',
            B: '501',
            C: 'Havs- och kustsjöfart, passagerartrafik',
        },
        {
            A: '50.2',
            B: '502',
            C: 'Havs- och kustsjöfart, godstrafik',
        },
        {
            A: '50.3',
            B: '503',
            C: 'Sjöfart på inre vattenvägar, passagerartrafik',
        },
        {
            A: '50.4',
            B: '504',
            C: 'Sjöfart på inre vattenvägar, godstrafik',
        },
        {
            A: '51.1',
            B: '511',
            C: 'Lufttransport, passagerartrafik',
        },
        {
            A: '51.2',
            B: '512',
            C: 'Lufttransport, godstrafik och rymdfart',
        },
        {
            A: '52.1',
            B: '521',
            C: 'Magasinering och varulagring',
        },
        {
            A: '52.2',
            B: '522',
            C: 'Stödtjänster till transport',
        },
        {
            A: '53.1',
            B: '531',
            C: 'Postbefordran via nationella posten',
        },
        {
            A: '53.2',
            B: '532',
            C: 'Annan postbefordran samt kurirverksamhet',
        },
        {
            A: '55.1',
            B: '551',
            C: 'Hotellverksamhet',
        },
        {
            A: '55.2',
            B: '552',
            C: 'Semesterbostäder och annan korttidsinkvartering',
        },
        {
            A: '55.3',
            B: '553',
            C: 'Campingplatsverksamhet',
        },
        {
            A: '55.9',
            B: '559',
            C: 'Annan logiverksamhet',
        },
        {
            A: '56.1',
            B: '561',
            C: 'Restaurangverksamhet',
        },
        {
            A: '56.2',
            B: '562',
            C: 'Cateringverksamhet',
        },
        {
            A: '56.3',
            B: '563',
            C: 'Barverksamhet',
        },
        {
            A: '58.1',
            B: '581',
            C: 'Utgivning av böcker och tidskrifter och annan förlagsverksamhet',
        },
        {
            A: '58.2',
            B: '582',
            C: 'Utgivning av programvara',
        },
        {
            A: '59.1',
            B: '591',
            C: 'Film-, video- och TV-programverksamhet',
        },
        {
            A: '59.2',
            B: '592',
            C: 'Ljudinspelning och fonogramutgivning',
        },
        {
            A: '60.1',
            B: '601',
            C: 'Sändning av radioprogram',
        },
        {
            A: '60.2',
            B: '602',
            C: 'Planering av TV-program och sändningsverksamhet',
        },
        {
            A: '61.1',
            B: '611',
            C: 'Trådbunden telekommunikation',
        },
        {
            A: '61.2',
            B: '612',
            C: 'Trådlös telekommunikation',
        },
        {
            A: '61.3',
            B: '613',
            C: 'Telekommunikation via satellit',
        },
        {
            A: '61.9',
            B: '619',
            C: 'Annan telekommunikation',
        },
        {
            A: '62.0',
            B: '620',
            C: 'Dataprogrammering, datakonsultverksamhet o.d.',
        },
        {
            A: '63.1',
            B: '631',
            C: 'Databehandling, hosting o.d.; webbportaler',
        },
        {
            A: '63.9',
            B: '639',
            C: 'Andra informationstjänster',
        },
        {
            A: '64.1',
            B: '641',
            C: 'Monetär finansförmedling',
        },
        {
            A: '64.2',
            B: '642',
            C: 'Holdingverksamhet',
        },
        {
            A: '64.3',
            B: '643',
            C: 'Fonder och liknande finansiella enheter',
        },
        {
            A: '64.9',
            B: '649',
            C: 'Andra finansiella tjänster utom försäkring och pensionsfondsverksamhet',
        },
        {
            A: '65.1',
            B: '651',
            C: 'Försäkring',
        },
        {
            A: '65.2',
            B: '652',
            C: 'Återförsäkring',
        },
        {
            A: '65.3',
            B: '653',
            C: 'Pensionsfondsverksamhet',
        },
        {
            A: '66.1',
            B: '661',
            C: 'Stödtjänster till finansiella tjänster utom försäkring och pensionsfondsverksamhet',
        },
        {
            A: '66.2',
            B: '662',
            C: 'Stödtjänster till försäkrings- och pensionsfondsverksamhet',
        },
        {
            A: '66.3',
            B: '663',
            C: 'Fondförvaltning',
        },
        {
            A: '68.1',
            B: '681',
            C: 'Handel med egna fastigheter',
        },
        {
            A: '68.2',
            B: '682',
            C: 'Uthyrning och förvaltning av egna eller arrenderade fastigheter',
        },
        {
            A: '68.3',
            B: '683',
            C: 'Fastighetsförmedling och fastighetsförvaltning på uppdrag',
        },
        {
            A: '69.1',
            B: '691',
            C: 'Juridisk verksamhet',
        },
        {
            A: '69.2',
            B: '692',
            C: 'Redovisning och bokföring, revision, skatterådgivning',
        },
        {
            A: '70.1',
            B: '701',
            C: 'Verksamheter som utövas av huvudkontor',
        },
        {
            A: '70.2',
            B: '702',
            C: 'Konsulttjänster till företag',
        },
        {
            A: '71.1',
            B: '711',
            C: 'Arkitekt- och teknisk konsultverksamhet o.d.',
        },
        {
            A: '71.2',
            B: '712',
            C: 'Teknisk provning och analys',
        },
        {
            A: '72.1',
            B: '721',
            C: 'Naturvetenskaplig och teknisk forskning och utveckling',
        },
        {
            A: '72.2',
            B: '722',
            C: 'Samhällsvetenskaplig och humanistisk forskning och utveckling',
        },
        {
            A: '73.1',
            B: '731',
            C: 'Reklamverksamhet',
        },
        {
            A: '73.2',
            B: '732',
            C: 'Marknads- och opinionsundersökning',
        },
        {
            A: '74.1',
            B: '741',
            C: 'Specialiserad designverksamhet',
        },
        {
            A: '74.2',
            B: '742',
            C: 'Fotoverksamhet',
        },
        {
            A: '74.3',
            B: '743',
            C: 'Översättning och tolkning',
        },
        {
            A: '74.9',
            B: '749',
            C: 'Övrig verksamhet inom juridik, ekonomi, vetenskap och teknik',
        },
        {
            A: '75.0',
            B: '750',
            C: 'Veterinärverksamhet',
        },
        {
            A: '77.1',
            B: '771',
            C: 'Uthyrning och leasing av motorfordon',
        },
        {
            A: '77.2',
            B: '772',
            C: 'Uthyrning och leasing av hushållsartiklar och varor för personligt bruk',
        },
        {
            A: '77.3',
            B: '773',
            C: 'Uthyrning och leasing av annan utrustning och andra maskiner och materiella tillgångar',
        },
        {
            A: '77.4',
            B: '774',
            C: 'Leasing av immateriell egendom och liknande produkter, med undantag för upphovsrättsskyddade verk',
        },
        {
            A: '78.1',
            B: '781',
            C: 'Arbetsförmedling och rekrytering',
        },
        {
            A: '78.2',
            B: '782',
            C: 'Personaluthyrning',
        },
        {
            A: '78.3',
            B: '783',
            C: 'Övrigt tillhandahållande av personalfunktioner',
        },
        {
            A: '79.1',
            B: '791',
            C: 'Resetjänster',
        },
        {
            A: '79.9',
            B: '799',
            C: 'Turist- och bokningsservice',
        },
        {
            A: '80.1',
            B: '801',
            C: 'Säkerhetsverksamhet',
        },
        {
            A: '80.2',
            B: '802',
            C: 'Säkerhetssystemtjänster',
        },
        {
            A: '80.3',
            B: '803',
            C: 'Spanings- och detektivverksamhet',
        },
        {
            A: '81.1',
            B: '811',
            C: 'Fastighetsrelaterade stödtjänster',
        },
        {
            A: '81.2',
            B: '812',
            C: 'Rengöring och lokalvård',
        },
        {
            A: '81.3',
            B: '813',
            C: 'Skötsel och underhåll av grönytor',
        },
        {
            A: '82.1',
            B: '821',
            C: 'Kontorstjänster',
        },
        {
            A: '82.2',
            B: '822',
            C: 'Callcenterverksamhet',
        },
        {
            A: '82.3',
            B: '823',
            C: 'Arrangemang av kongresser och mässor',
        },
        {
            A: '82.9',
            B: '829',
            C: 'Andra företagstjänster',
        },
        {
            A: '84.1',
            B: '841',
            C: 'Offentlig förvaltning',
        },
        {
            A: '84.2',
            B: '842',
            C: 'Offentliga tjänster',
        },
        {
            A: '84.3',
            B: '843',
            C: 'Obligatorisk socialförsäkring',
        },
        {
            A: '85.1',
            B: '851',
            C: 'Förskoleutbildning',
        },
        {
            A: '85.2',
            B: '852',
            C: 'Grundskoleutbildning',
        },
        {
            A: '85.3',
            B: '853',
            C: 'Gymnasial utbildning',
        },
        {
            A: '85.4',
            B: '854',
            C: 'Eftergymnasial utbildning',
        },
        {
            A: '85.5',
            B: '855',
            C: 'Vuxenutbildning och övrig utbildning',
        },
        {
            A: '85.6',
            B: '856',
            C: 'Stödverksamhet för utbildningsväsendet',
        },
        {
            A: '86.1',
            B: '861',
            C: 'Sluten sjukvård',
        },
        {
            A: '86.2',
            B: '862',
            C: 'Öppen hälso- och sjukvård, tandvård',
        },
        {
            A: '86.9',
            B: '869',
            C: 'Annan hälso- och sjukvård',
        },
        {
            A: '87.1',
            B: '871',
            C: 'Boende med sjuksköterskevård',
        },
        {
            A: '87.2',
            B: '872',
            C: 'Boende med särskild service för personer med utvecklingsstörning, psykiska funktionshinder eller missbruksproblem',
        },
        {
            A: '87.3',
            B: '873',
            C: 'Vård och omsorg i särskilda boendeformer för äldre och funktionshindrade personer',
        },
        {
            A: '87.9',
            B: '879',
            C: 'Annan vård och omsorg med boende',
        },
        {
            A: '88.1',
            B: '881',
            C: 'Öppna sociala insatser för äldre och funktionshindrade personer',
        },
        {
            A: '88.9',
            B: '889',
            C: 'Andra öppna sociala insatser',
        },
        {
            A: '90.0',
            B: '900',
            C: 'Konstnärlig och kulturell verksamhet samt underhållningsverksamhet',
        },
        {
            A: '91.0',
            B: '910',
            C: 'Biblioteks-, arkiv- och museiverksamhet m.m.',
        },
        {
            A: '92.0',
            B: '920',
            C: 'Spel- och vadhållningsverksamhet',
        },
        {
            A: '93.1',
            B: '931',
            C: 'Sportverksamhet',
        },
        {
            A: '93.2',
            B: '932',
            C: 'Fritids- och nöjesverksamhet',
        },
        {
            A: '94.1',
            B: '941',
            C: 'Intressebevakning inom bransch-, arbetsgivar- och yrkesorganisationer',
        },
        {
            A: '94.2',
            B: '942',
            C: 'Intressebevakning inom arbetstagarorganisationer',
        },
        {
            A: '94.9',
            B: '949',
            C: 'Verksamhet i religiösa samfund och i andra intresseorganisationer',
        },
        {
            A: '95.1',
            B: '951',
            C: 'Reparation av datorer och kommunikationsutrustning',
        },
        {
            A: '95.2',
            B: '952',
            C: 'Reparation av hushållsartiklar och personliga artiklar',
        },
        {
            A: '96.0',
            B: '960',
            C: 'Andra konsumenttjänster',
        },
        {
            A: '97.0',
            B: '970',
            C: 'Förvärvsarbete i hushåll',
        },
        {
            A: '98.1',
            B: '981',
            C: 'Hushållens produktion av diverse varor för eget bruk',
        },
        {
            A: '98.2',
            B: '982',
            C: 'Hushållens produktion av diverse tjänster för eget bruk',
        },
        {
            A: '99.0',
            B: '990',
            C: 'Verksamhet vid internationella organisationer, utländska ambassader o.d.',
        },
    ],
    'Huvudgrupp (Tvåsiffer)': [
        {
            A: 'SNI 2007',
        },
        {
            A: 'Huvudgrupp',
            B: 'Benämning',
        },
        {
            A: '01',
            B: 'Jordbruk och jakt samt service i anslutning härtill',
        },
        {
            A: '02',
            B: 'Skogsbruk',
        },
        {
            A: '03',
            B: 'Fiske och vattenbruk',
        },
        {
            A: '05',
            B: 'Kolutvinning',
        },
        {
            A: '06',
            B: 'Utvinning av råpetroleum och naturgas',
        },
        {
            A: '07',
            B: 'Utvinning av metallmalmer',
        },
        {
            A: '08',
            B: 'Annan utvinning av mineral',
        },
        {
            A: '09',
            B: 'Service till utvinning',
        },
        {
            A: '10',
            B: 'Livsmedelsframställning',
        },
        {
            A: '11',
            B: 'Framställning av drycker',
        },
        {
            A: '12',
            B: 'Tobaksvarutillverkning',
        },
        {
            A: '13',
            B: 'Textilvarutillverkning',
        },
        {
            A: '14',
            B: 'Tillverkning av kläder',
        },
        {
            A: '15',
            B: 'Tillverkning av läder, läder- och skinnvaror m.m.',
        },
        {
            A: '16',
            B: 'Tillverkning av trä och varor av trä, kork, rotting o.d. utom möbler',
        },
        {
            A: '17',
            B: 'Pappers- och pappersvarutillverkning',
        },
        {
            A: '18',
            B: 'Grafisk produktion och reproduktion av inspelningar',
        },
        {
            A: '19',
            B: 'Tillverkning av stenkolsprodukter och raffinerade petroleumprodukter',
        },
        {
            A: '20',
            B: 'Tillverkning av kemikalier och kemiska produkter',
        },
        {
            A: '21',
            B: 'Tillverkning av farmaceutiska basprodukter och läkemedel',
        },
        {
            A: '22',
            B: 'Tillverkning av gummi- och plastvaror',
        },
        {
            A: '23',
            B: 'Tillverkning av andra icke-metalliska mineraliska produkter',
        },
        {
            A: '24',
            B: 'Stål- och metallframställning',
        },
        {
            A: '25',
            B: 'Tillverkning av metallvaror utom maskiner och apparater',
        },
        {
            A: '26',
            B: 'Tillverkning av datorer, elektronikvaror och optik',
        },
        {
            A: '27',
            B: 'Tillverkning av elapparatur',
        },
        {
            A: '28',
            B: 'Tillverkning av övriga maskiner',
        },
        {
            A: '29',
            B: 'Tillverkning av motorfordon, släpfordon och påhängsvagnar',
        },
        {
            A: '30',
            B: 'Tillverkning av andra transportmedel',
        },
        {
            A: '31',
            B: 'Tillverkning av möbler',
        },
        {
            A: '32',
            B: 'Annan tillverkning',
        },
        {
            A: '33',
            B: 'Reparation och installation av maskiner och apparater',
        },
        {
            A: '35',
            B: 'Försörjning av el, gas, värme och kyla',
        },
        {
            A: '36',
            B: 'Vattenförsörjning',
        },
        {
            A: '37',
            B: 'Avloppsrening',
        },
        {
            A: '38',
            B: 'Avfallshantering; återvinning',
        },
        {
            A: '39',
            B: 'Sanering, efterbehandling av jord och vatten samt annan verksamhet för föroreningsbekämpning',
        },
        {
            A: '41',
            B: 'Byggande av hus',
        },
        {
            A: '42',
            B: 'Anläggningsarbeten',
        },
        {
            A: '43',
            B: 'Specialiserad bygg- och anläggningsverksamhet',
        },
        {
            A: '45',
            B: 'Handel samt reparation av motorfordon och motorcyklar',
        },
        {
            A: '46',
            B: 'Parti- och provisionshandel utom med motorfordon',
        },
        {
            A: '47',
            B: 'Detaljhandel utom med motorfordon och motorcyklar',
        },
        {
            A: '49',
            B: 'Landtransport; transport i rörsystem',
        },
        {
            A: '50',
            B: 'Sjötransport',
        },
        {
            A: '51',
            B: 'Lufttransport',
        },
        {
            A: '52',
            B: 'Magasinering och stödtjänster till transport',
        },
        {
            A: '53',
            B: 'Post- och kurirverksamhet',
        },
        {
            A: '55',
            B: 'Hotell- och logiverksamhet',
        },
        {
            A: '56',
            B: 'Restaurang-, catering- och barverksamhet',
        },
        {
            A: '58',
            B: 'Förlagsverksamhet',
        },
        {
            A: '59',
            B: 'Film-, video- och tv-programverksamhet, ljudinspelningar och fonogramutgivning',
        },
        {
            A: '60',
            B: 'Planering och sändning av program',
        },
        {
            A: '61',
            B: 'Telekommunikation',
        },
        {
            A: '62',
            B: 'Dataprogrammering, datakonsultverksamhet o.d.',
        },
        {
            A: '63',
            B: 'Informationstjänster',
        },
        {
            A: '64',
            B: 'Finansiella tjänster utom försäkring och pensionsfondsverksamhet',
        },
        {
            A: '65',
            B: 'Försäkring, återförsäkring och pensionsfondsverksamhet utom obligatorisk socialförsäkring',
        },
        {
            A: '66',
            B: 'Stödtjänster till finansiella tjänster och försäkring',
        },
        {
            A: '68',
            B: 'Fastighetsverksamhet',
        },
        {
            A: '69',
            B: 'Juridisk och ekonomisk konsultverksamhet',
        },
        {
            A: '70',
            B: 'Verksamheter som utövas av huvudkontor; konsulttjänster till företag',
        },
        {
            A: '71',
            B: 'Arkitekt- och teknisk konsultverksamhet; teknisk provning och analys',
        },
        {
            A: '72',
            B: 'Vetenskaplig forskning och utveckling',
        },
        {
            A: '73',
            B: 'Reklam och marknadsundersökning',
        },
        {
            A: '74',
            B: 'Annan verksamhet inom juridik, ekonomi, vetenskap och teknik',
        },
        {
            A: '75',
            B: 'Veterinärverksamhet',
        },
        {
            A: '77',
            B: 'Uthyrning och leasing',
        },
        {
            A: '78',
            B: 'Arbetsförmedling, bemanning och andra personalrelaterade tjänster',
        },
        {
            A: '79',
            B: 'Resebyrå- och researrangörsverksamhet och andra resetjänster och relaterade tjänster',
        },
        {
            A: '80',
            B: 'Säkerhets- och bevakningsverksamhet',
        },
        {
            A: '81',
            B: 'Fastighetsservice samt skötsel och underhåll av grönytor',
        },
        {
            A: '82',
            B: 'Kontorstjänster och andra företagstjänster',
        },
        {
            A: '84',
            B: 'Offentlig förvaltning och försvar;  obligatorisk socialförsäkring',
        },
        {
            A: '85',
            B: 'Utbildning',
        },
        {
            A: '86',
            B: 'Hälso- och sjukvård',
        },
        {
            A: '87',
            B: 'Vård och omsorg med boende',
        },
        {
            A: '88',
            B: 'Öppna sociala insatser',
        },
        {
            A: '90',
            B: 'Konstnärlig och kulturell verksamhet samt underhållningsverksamhet',
        },
        {
            A: '91',
            B: 'Biblioteks-, arkiv- och museiverksamhet m.m.',
        },
        {
            A: '92',
            B: 'Spel- och vadhållningsverksamhet',
        },
        {
            A: '93',
            B: 'Sport-, fritids- och nöjesverksamhet',
        },
        {
            A: '94',
            B: 'Intressebevakning; religiös verksamhet',
        },
        {
            A: '95',
            B: 'Reparation av datorer, hushållsartiklar och personliga artiklar',
        },
        {
            A: '96',
            B: 'Andra konsumenttjänster',
        },
        {
            A: '97',
            B: 'Förvärvsarbete i hushåll',
        },
        {
            A: '98',
            B: 'Hushållens produktion av diverse varor och tjänster för eget bruk',
        },
        {
            A: '99',
            B: 'Verksamhet vid internationella organisationer, utländska ambassader o.d.',
        },
    ],
    'Avdelning (Bokstav)': [
        {
            A: 'SNI 2007',
        },
        {
            A: 'Avdelning',
            B: 'Benämning',
        },
        {
            A: 'A',
            B: 'Jordbruk, skogsbruk och fiske',
        },
        {
            A: 'B',
            B: 'Utvinning av mineral',
        },
        {
            A: 'C',
            B: 'Tillverkning',
        },
        {
            A: 'D',
            B: 'Försörjning av el, gas, värme och kyla',
        },
        {
            A: 'E',
            B: 'Vattenförsörjning; avloppsrening, avfallshantering och sanering',
        },
        {
            A: 'F',
            B: 'Byggverksamhet',
        },
        {
            A: 'G',
            B: 'Handel; reparation av motorfordon och motorcyklar',
        },
        {
            A: 'H',
            B: 'Transport och magasinering',
        },
        {
            A: 'I',
            B: 'Hotell- och restaurangverksamhet',
        },
        {
            A: 'J',
            B: 'Informations- och kommunikationsverksamhet',
        },
        {
            A: 'K',
            B: 'Finans- och försäkringsverksamhet',
        },
        {
            A: 'L',
            B: 'Fastighetsverksamhet',
        },
        {
            A: 'M',
            B: 'Verksamhet inom juridik, ekonomi, vetenskap och teknik',
        },
        {
            A: 'N',
            B: 'Uthyrning, fastighetsservice, resetjänster och andra stödtjänster',
        },
        {
            A: 'O',
            B: 'Offentlig förvaltning och försvar; obligatorisk socialförsäkring',
        },
        {
            A: 'P',
            B: 'Utbildning',
        },
        {
            A: 'Q',
            B: 'Vård och omsorg; sociala tjänster',
        },
        {
            A: 'R',
            B: 'Kultur, nöje och fritid',
        },
        {
            A: 'S',
            B: 'Annan serviceverksamhet',
        },
        {
            A: 'T',
            B: 'Förvärvsarbete i hushåll; hushållens produktion av diverse varor och tjänster för eget bruk',
        },
        {
            A: 'U',
            B: 'Verksamhet vid internationella organisationer, utländska ambassader o.d.',
        },
    ],
};

const sniCodes5digitGroup = sniCodes['Detaljgrupp (Femsiffer)'];
const utils = {
    validate(sniCode) {
        const code = sniCodes5digitGroup.slice().filter((codeObj) => {
            return sniCode === codeObj['A'] || sniCode === codeObj['B'];
        });
        return !!(code.length === 1);
    },
    description(sniCode) {
        const code = sniCodes5digitGroup
            .slice()
            .filter((codeObj) => {
            return sniCode === codeObj['A'] || sniCode === codeObj['B'];
        })
            .shift();
        return code ? code['C'] : null;
    },
    search(sniCode) {
        const sniCodeRE = new RegExp(`^${sniCode}`);
        return sniCodes5digitGroup.slice().filter((codeObj) => {
            return sniCodeRE.test(codeObj['A']) || sniCodeRE.test(codeObj['B']);
        });
    },
    searchByDescription(txt) {
        const sniDescriptionRE = new RegExp(`${txt.trim()}`);
        return sniCodes5digitGroup.slice().filter((codeObj) => {
            return sniDescriptionRE.test(codeObj['C']);
        });
    },
};
class SniCode {
    static validate(sniCode) {
        return utils.validate(sniCode);
    }
    static description(sniCode) {
        return utils.description(sniCode);
    }
    static search(sniCode) {
        return utils.search(sniCode);
    }
    static searchByDescription(txt) {
        return utils.searchByDescription(txt);
    }
}

export { BankAccountValidator, IBAN, NationalIdentifierValidator, OrganisationsnummerSE, PGorBG, SniCode, mods };
